export const ZZZBuilds = [
  {
    char: 'corin',
    app_rate_sd: 0.27,
    app_rate_sd_e1: 0.04,
    app_rate_sd_s0: 0.02,
    avg_round_sd: 600,
    avg_round_sd_e1: 600,
    avg_round_sd_s0: 600,
    sample_sd: 13,
    sample_size_players_sd: 9,
    app_rate_da: 0.75,
    app_rate_da_e1: 0.12,
    app_rate_da_s0: 0.27,
    avg_round_da: 23554,
    avg_round_da_e1: 0,
    avg_round_da_s0: 0,
    app_rate_da_boss_1: 0.47,
    avg_round_da_boss_1: 24461,
    app_rate_da_boss_2: 0,
    avg_round_da_boss_2: 0,
    app_rate_da_boss_3: 0.33,
    avg_round_da_boss_3: 0,
    sample_da: 44,
    sample_size_players_da: 29,
    app_0: 2.27,
    round_0_sd: 600,
    round_0_da: 14064,
    app_1: 1,
    round_1_sd: 600,
    round_1_da: 0,
    app_2: 1,
    round_2_sd: 600,
    round_2_da: 0,
    app_3: 2.27,
    round_3_sd: 600,
    round_3_da: 15040,
    app_4: 2.27,
    round_4_sd: 600,
    round_4_da: 20274,
    app_5: 4.55,
    round_5_sd: 600,
    round_5_da: 16188,
    app_6: 91.65,
    round_6_sd: 178,
    round_6_da: 24680,
    cons_avg: 5.78,
    weapons_1: 'Housekeeper',
    weapons_1_app: 43.24,
    weapons_1_round_sd: 262,
    weapons_1_round_da: 20539,
    weapons_2: 'Steel Cushion',
    weapons_2_app: 40.99,
    weapons_2_round_sd: 158,
    weapons_2_round_da: 27700,
    weapons_3: 'Marcato Desire',
    weapons_3_app: 5.01,
    weapons_3_round_sd: 600,
    weapons_3_round_da: 22726,
    weapons_4: 'Severed Innocence',
    weapons_4_app: 3.71,
    weapons_4_round_sd: 169,
    weapons_4_round_da: 28522,
    weapons_5: 'Riot Suppressor Mark VI',
    weapons_5_app: 2.04,
    weapons_5_round_sd: 155,
    weapons_5_round_da: 0,
    weapons_6: 'Starlight Engine',
    weapons_6_app: 1.67,
    weapons_6_round_sd: 600,
    weapons_6_round_da: 15385,
    weapons_7: 'Zanshin Herb Case',
    weapons_7_app: 1.67,
    weapons_7_round_sd: 600,
    weapons_7_round_da: 31107,
    weapons_8: 'Street Superstar',
    weapons_8_app: 1.67,
    weapons_8_round_sd: 600,
    weapons_8_round_da: 14064,
    weapons_9: '',
    weapons_9_app: 0,
    weapons_9_round_sd: 600,
    weapons_9_round_da: 0,
    weapons_10: '',
    weapons_10_app: 0,
    weapons_10_round_sd: 600,
    weapons_10_round_da: 0,
    artifacts_1: 'Fanged Metal, Woodpecker Electro',
    artifacts_1_1: 'Fanged Metal',
    artifacts_1_2: 'Woodpecker Electro',
    artifacts_1_3: '',
    artifacts_1_app: 17.44,
    artifacts_1_round_sd: 207,
    artifacts_1_round_da: 22436,
    artifacts_2: 'Woodpecker Electro, Branch & Blade Song',
    artifacts_2_1: 'Woodpecker Electro',
    artifacts_2_2: 'Branch & Blade Song',
    artifacts_2_3: '',
    artifacts_2_app: 14.1,
    artifacts_2_round_sd: 129,
    artifacts_2_round_da: 28929,
    artifacts_3: 'Woodpecker Electro, Fanged Metal',
    artifacts_3_1: 'Woodpecker Electro',
    artifacts_3_2: 'Fanged Metal',
    artifacts_3_3: '',
    artifacts_3_app: 10.75,
    artifacts_3_round_sd: 158,
    artifacts_3_round_da: 24056,
    artifacts_4: 'Hormone Punk, Branch & Blade Song',
    artifacts_4_1: 'Hormone Punk',
    artifacts_4_2: 'Branch & Blade Song',
    artifacts_4_3: '',
    artifacts_4_app: 7.05,
    artifacts_4_round_sd: 151,
    artifacts_4_round_da: 29450,
    artifacts_5: 'Puffer Electro, Branch & Blade Song',
    artifacts_5_1: 'Puffer Electro',
    artifacts_5_2: 'Branch & Blade Song',
    artifacts_5_3: '',
    artifacts_5_app: 5.01,
    artifacts_5_round_sd: 600,
    artifacts_5_round_da: 20739,
    artifacts_6: 'Branch & Blade Song, Puffer Electro, Woodpecker Electro',
    artifacts_6_1: 'Branch & Blade Song',
    artifacts_6_2: 'Puffer Electro',
    artifacts_6_3: 'Woodpecker Electro',
    artifacts_6_app: 4.07,
    artifacts_6_round_sd: 179,
    artifacts_6_round_da: 0,
    artifacts_7: 'Fanged Metal, Branch & Blade Song',
    artifacts_7_1: 'Fanged Metal',
    artifacts_7_2: 'Branch & Blade Song',
    artifacts_7_3: '',
    artifacts_7_app: 3.35,
    artifacts_7_round_sd: 600,
    artifacts_7_round_da: 17712,
    artifacts_8: 'Hormone Punk, Fanged Metal',
    artifacts_8_1: 'Hormone Punk',
    artifacts_8_2: 'Fanged Metal',
    artifacts_8_3: '',
    artifacts_8_app: 3.35,
    artifacts_8_round_sd: 600,
    artifacts_8_round_da: 25962,
    artifacts_9: 'Woodpecker Electro, Puffer Electro',
    artifacts_9_1: 'Woodpecker Electro',
    artifacts_9_2: 'Puffer Electro',
    artifacts_9_3: '',
    artifacts_9_app: 3.35,
    artifacts_9_round_sd: 600,
    artifacts_9_round_da: 23948,
    artifacts_10: 'Fanged Metal, Hormone Punk',
    artifacts_10_1: 'Fanged Metal',
    artifacts_10_2: 'Hormone Punk',
    artifacts_10_3: '',
    artifacts_10_app: 3.35,
    artifacts_10_round_sd: 600,
    artifacts_10_round_da: 26500,
    drive_slot_4_1: 'CRIT Rate',
    drive_slot_4_1_app: 59.94,
    drive_slot_4_2: 'CRIT DMG',
    drive_slot_4_2_app: 37.11,
    drive_slot_4_3: 'Percent ATK',
    drive_slot_4_3_app: 2.94,
    drive_slot_5_1: 'Physical DMG Bonus',
    drive_slot_5_1_app: 44.32,
    drive_slot_5_2: 'PEN Ratio',
    drive_slot_5_2_app: 32.05,
    drive_slot_5_3: 'Percent ATK',
    drive_slot_5_3_app: 21.09,
    drive_slot_6_1: 'Percent ATK',
    drive_slot_6_1_app: 100,
    drive_slot_6_2: '',
    drive_slot_6_2_app: 0,
    drive_slot_6_3: '',
    drive_slot_6_3_app: 0,
    char_level: 60,
    w_engine_level: 60,
    basic_atk: 11.01,
    special_atk: 11.77,
    dash: 10.11,
    ultimate: 11.75,
    core_skill: 7,
    assist: 10.64,
    base_hp: 9866.01,
    base_atk: 2837.98,
    base_def: 893.21,
    base_impact: 93,
    crit_rate: 69.37,
    crit_dmg: 159.94,
    anomaly_mastery: 93,
    anomaly_proficiency: 118.76,
    pen_ratio: 9.62,
    pen: 31.82,
    base_energy_regen: 120,
    dmg_bonus: 17.73,
    percent_hp_sub: 6.26,
    percent_atk_sub: 18.66,
    percent_def_sub: 12.62,
    crit_rate_sub: 30.48,
    crit_dmg_sub: 54.88,
    pen_sub: 31.82,
    anomaly_proficiency_sub: 22.76
  },
  {
    char: 'soukaku',
    app_rate_sd: 16.28,
    app_rate_sd_e1: 8.21,
    app_rate_sd_s0: 0.64,
    avg_round_sd: 118,
    avg_round_sd_e1: 93,
    avg_round_sd_s0: 136,
    sample_sd: 783,
    sample_size_players_sd: 80,
    app_rate_da: 40.76,
    app_rate_da_e1: 15.19,
    app_rate_da_s0: 4.61,
    avg_round_da: 22516,
    avg_round_da_e1: 29916,
    avg_round_da_s0: 18127,
    app_rate_da_boss_1: 16.23,
    avg_round_da_boss_1: 21453,
    app_rate_da_boss_2: 28.25,
    avg_round_da_boss_2: 23443,
    app_rate_da_boss_3: 0.63,
    avg_round_da_boss_3: 17719,
    sample_da: 2385,
    sample_size_players_da: 161,
    app_0: 1,
    round_0_sd: 600,
    round_0_da: 0,
    app_1: 0.1,
    round_1_sd: 108,
    round_1_da: 30149,
    app_2: 0.39,
    round_2_sd: 123,
    round_2_da: 17393,
    app_3: 0.35,
    round_3_sd: 116,
    round_3_da: 20281,
    app_4: 0.44,
    round_4_sd: 151,
    round_4_da: 20640,
    app_5: 1.01,
    round_5_sd: 90,
    round_5_da: 24331,
    app_6: 97.72,
    round_6_sd: 118,
    round_6_da: 22521,
    cons_avg: 5.95,
    weapons_1: 'Bashful Demon',
    weapons_1_app: 88.14,
    weapons_1_round_sd: 120,
    weapons_1_round_da: 22159,
    weapons_2: 'Kaboom the Cannon',
    weapons_2_app: 5.17,
    weapons_2_round_sd: 98,
    weapons_2_round_da: 28160,
    weapons_3: 'Slice of Time',
    weapons_3_app: 1.12,
    weapons_3_round_sd: 116,
    weapons_3_round_da: 18602,
    weapons_4: 'Unfettered Game Ball',
    weapons_4_app: 1.03,
    weapons_4_round_sd: 112,
    weapons_4_round_da: 28748,
    weapons_5: 'The Vault',
    weapons_5_app: 0.79,
    weapons_5_round_sd: 100,
    weapons_5_round_da: 23756,
    weapons_6: 'Weeping Cradle',
    weapons_6_app: 0.57,
    weapons_6_round_sd: 107,
    weapons_6_round_da: 22376,
    weapons_7: '[Reverb] Mark II',
    weapons_7_app: 0.46,
    weapons_7_round_sd: 99,
    weapons_7_round_da: 22011,
    weapons_8: '[Reverb] Mark I',
    weapons_8_app: 0.19,
    weapons_8_round_sd: 175,
    weapons_8_round_da: 21541,
    weapons_9: '[Reverb] Mark III',
    weapons_9_app: 0.15,
    weapons_9_round_sd: 600,
    weapons_9_round_da: 23951,
    weapons_10: 'Steam Oven',
    weapons_10_app: 0.04,
    weapons_10_round_sd: 600,
    weapons_10_round_da: 0,
    artifacts_1: 'Swing Jazz, Hormone Punk',
    artifacts_1_1: 'Swing Jazz',
    artifacts_1_2: 'Hormone Punk',
    artifacts_1_3: '',
    artifacts_1_app: 37.2,
    artifacts_1_round_sd: 122,
    artifacts_1_round_da: 21343,
    artifacts_2: 'Astral Voice, Swing Jazz',
    artifacts_2_1: 'Astral Voice',
    artifacts_2_2: 'Swing Jazz',
    artifacts_2_3: '',
    artifacts_2_app: 10.5,
    artifacts_2_round_sd: 121,
    artifacts_2_round_da: 23387,
    artifacts_3: 'Freedom Blues, Swing Jazz',
    artifacts_3_1: 'Freedom Blues',
    artifacts_3_2: 'Swing Jazz',
    artifacts_3_3: '',
    artifacts_3_app: 7.76,
    artifacts_3_round_sd: 94,
    artifacts_3_round_da: 29296,
    artifacts_4: 'Swing Jazz, Polar Metal',
    artifacts_4_1: 'Swing Jazz',
    artifacts_4_2: 'Polar Metal',
    artifacts_4_3: '',
    artifacts_4_app: 6.72,
    artifacts_4_round_sd: 121,
    artifacts_4_round_da: 21748,
    artifacts_5: 'Swing Jazz, Astral Voice',
    artifacts_5_1: 'Swing Jazz',
    artifacts_5_2: 'Astral Voice',
    artifacts_5_3: '',
    artifacts_5_app: 3.82,
    artifacts_5_round_sd: 126,
    artifacts_5_round_da: 20620,
    artifacts_6: 'Swing Jazz, Freedom Blues',
    artifacts_6_1: 'Swing Jazz',
    artifacts_6_2: 'Freedom Blues',
    artifacts_6_3: '',
    artifacts_6_app: 2.38,
    artifacts_6_round_sd: 92,
    artifacts_6_round_da: 22662,
    artifacts_7: "Freedom Blues, Phaethon's Melody",
    artifacts_7_1: 'Freedom Blues',
    artifacts_7_2: "Phaethon's Melody",
    artifacts_7_3: '',
    artifacts_7_app: 2.3,
    artifacts_7_round_sd: 95,
    artifacts_7_round_da: 33150,
    artifacts_8: 'Hormone Punk, Swing Jazz',
    artifacts_8_1: 'Hormone Punk',
    artifacts_8_2: 'Swing Jazz',
    artifacts_8_3: '',
    artifacts_8_app: 2.17,
    artifacts_8_round_sd: 120,
    artifacts_8_round_da: 19799,
    artifacts_9: 'Hormone Punk, Polar Metal',
    artifacts_9_1: 'Hormone Punk',
    artifacts_9_2: 'Polar Metal',
    artifacts_9_3: '',
    artifacts_9_app: 1.94,
    artifacts_9_round_sd: 125,
    artifacts_9_round_da: 17968,
    artifacts_10: '',
    artifacts_10_1: '',
    artifacts_10_2: '',
    artifacts_10_3: '',
    artifacts_10_app: 0,
    artifacts_10_round_sd: 600,
    artifacts_10_round_da: 0,
    drive_slot_4_1: 'Percent ATK',
    drive_slot_4_1_app: 59.38,
    drive_slot_4_2: 'CRIT Rate',
    drive_slot_4_2_app: 26.94,
    drive_slot_4_3: 'CRIT DMG',
    drive_slot_4_3_app: 6.22,
    drive_slot_5_1: 'Percent ATK',
    drive_slot_5_1_app: 71.38,
    drive_slot_5_2: 'Ice DMG Bonus',
    drive_slot_5_2_app: 22.4,
    drive_slot_5_3: 'PEN Ratio',
    drive_slot_5_3_app: 2.4,
    drive_slot_6_1: 'Percent ATK',
    drive_slot_6_1_app: 52.89,
    drive_slot_6_2: 'Energy Regen',
    drive_slot_6_2_app: 29.07,
    drive_slot_6_3: 'Anomaly Mastery',
    drive_slot_6_3_app: 14.67,
    char_level: 59.51,
    w_engine_level: 56.71,
    basic_atk: 7.33,
    special_atk: 10.29,
    dash: 6.5,
    ultimate: 9.24,
    core_skill: 6.6,
    assist: 7.98,
    base_hp: 11489.12,
    base_atk: 2883.08,
    base_def: 947.03,
    base_impact: 86.34,
    crit_rate: 27.86,
    crit_dmg: 87.5,
    anomaly_mastery: 97.07,
    anomaly_proficiency: 141.59,
    pen_ratio: 0.87,
    pen: 33.55,
    base_energy_regen: 206.98,
    dmg_bonus: 8.55,
    percent_hp_sub: 11.98,
    percent_atk_sub: 17.62,
    percent_def_sub: 21.02,
    crit_rate_sub: 15.81,
    crit_dmg_sub: 33.66,
    pen_sub: 33.55,
    anomaly_proficiency_sub: 36.72
  },
  {
    char: 'billy-kid',
    app_rate_sd: 0.23,
    app_rate_sd_e1: 0.02,
    app_rate_sd_s0: 0.1,
    avg_round_sd: 600,
    avg_round_sd_e1: 600,
    avg_round_sd_s0: 600,
    sample_sd: 11,
    sample_size_players_sd: 8,
    app_rate_da: 0.48,
    app_rate_da_e1: 0.02,
    app_rate_da_s0: 0.29,
    avg_round_da: 22395,
    avg_round_da_e1: 0,
    avg_round_da_s0: 0,
    app_rate_da_boss_1: 0.4,
    avg_round_da_boss_1: 21561,
    app_rate_da_boss_2: 0,
    avg_round_da_boss_2: 0,
    app_rate_da_boss_3: 0.11,
    avg_round_da_boss_3: 0,
    sample_da: 28,
    sample_size_players_da: 13,
    app_0: 1,
    round_0_sd: 600,
    round_0_da: 0,
    app_1: 1,
    round_1_sd: 600,
    round_1_da: 0,
    app_2: 1,
    round_2_sd: 600,
    round_2_da: 0,
    app_3: 1,
    round_3_sd: 600,
    round_3_da: 0,
    app_4: 7.41,
    round_4_sd: 600,
    round_4_da: 13890,
    app_5: 1,
    round_5_sd: 600,
    round_5_da: 0,
    app_6: 94.99,
    round_6_sd: 160,
    round_6_da: 23717,
    cons_avg: 5.9,
    weapons_1: 'Starlight Engine Replica',
    weapons_1_app: 41.82,
    weapons_1_round_sd: 179,
    weapons_1_round_da: 20157,
    weapons_2: 'The Brimstone',
    weapons_2_app: 21.35,
    weapons_2_round_sd: 116,
    weapons_2_round_da: 23315,
    weapons_3: 'Steel Cushion',
    weapons_3_app: 12.95,
    weapons_3_round_sd: 239,
    weapons_3_round_da: 21210,
    weapons_4: 'Severed Innocence',
    weapons_4_app: 7.95,
    weapons_4_round_sd: 108,
    weapons_4_round_da: 28748,
    weapons_5: 'Cannon Rotor',
    weapons_5_app: 5.44,
    weapons_5_round_sd: 186,
    weapons_5_round_da: 20066,
    weapons_6: '[Lunar] Pleniluna',
    weapons_6_app: 5.44,
    weapons_6_round_sd: 117,
    weapons_6_round_da: 42826,
    weapons_7: 'Heartstring Nocturne',
    weapons_7_app: 2.5,
    weapons_7_round_sd: 600,
    weapons_7_round_da: 34517,
    weapons_8: 'Riot Suppressor Mark VI',
    weapons_8_app: 2.5,
    weapons_8_round_sd: 600,
    weapons_8_round_da: 18941,
    weapons_9: '',
    weapons_9_app: 0,
    weapons_9_round_sd: 600,
    weapons_9_round_da: 0,
    weapons_10: '',
    weapons_10_app: 0,
    weapons_10_round_sd: 600,
    weapons_10_round_da: 0,
    artifacts_1: 'Woodpecker Electro, Branch & Blade Song',
    artifacts_1_1: 'Woodpecker Electro',
    artifacts_1_2: 'Branch & Blade Song',
    artifacts_1_3: '',
    artifacts_1_app: 28.86,
    artifacts_1_round_sd: 120,
    artifacts_1_round_da: 28666,
    artifacts_2: 'Woodpecker Electro, Fanged Metal',
    artifacts_2_1: 'Woodpecker Electro',
    artifacts_2_2: 'Fanged Metal',
    artifacts_2_3: '',
    artifacts_2_app: 26.36,
    artifacts_2_round_sd: 156,
    artifacts_2_round_da: 24603,
    artifacts_3: 'Woodpecker Electro, Hormone Punk',
    artifacts_3_1: 'Woodpecker Electro',
    artifacts_3_2: 'Hormone Punk',
    artifacts_3_3: '',
    artifacts_3_app: 10.9,
    artifacts_3_round_sd: 116,
    artifacts_3_round_da: 28606,
    artifacts_4: 'Puffer Electro, Woodpecker Electro',
    artifacts_4_1: 'Puffer Electro',
    artifacts_4_2: 'Woodpecker Electro',
    artifacts_4_3: '',
    artifacts_4_app: 5.44,
    artifacts_4_round_sd: 239,
    artifacts_4_round_da: 13117,
    artifacts_5: 'Woodpecker Electro, Astral Voice',
    artifacts_5_1: 'Woodpecker Electro',
    artifacts_5_2: 'Astral Voice',
    artifacts_5_3: '',
    artifacts_5_app: 5.01,
    artifacts_5_round_sd: 600,
    artifacts_5_round_da: 23467,
    artifacts_6: 'Woodpecker Electro, Puffer Electro',
    artifacts_6_1: 'Woodpecker Electro',
    artifacts_6_2: 'Puffer Electro',
    artifacts_6_3: '',
    artifacts_6_app: 2.94,
    artifacts_6_round_sd: 106,
    artifacts_6_round_da: 0,
    artifacts_7: 'Puffer Electro, Fanged Metal',
    artifacts_7_1: 'Puffer Electro',
    artifacts_7_2: 'Fanged Metal',
    artifacts_7_3: '',
    artifacts_7_app: 2.94,
    artifacts_7_round_sd: 349,
    artifacts_7_round_da: 0,
    artifacts_8: 'ATK +10%, Fanged Metal, Woodpecker Electro',
    artifacts_8_1: 'ATK +10%',
    artifacts_8_2: 'Fanged Metal',
    artifacts_8_3: 'Woodpecker Electro',
    artifacts_8_app: 2.5,
    artifacts_8_round_sd: 600,
    artifacts_8_round_da: 14375,
    artifacts_9: 'Branch & Blade Song, Woodpecker Electro, Flex',
    artifacts_9_1: 'Branch & Blade Song',
    artifacts_9_2: 'Woodpecker Electro',
    artifacts_9_3: 'Flex',
    artifacts_9_app: 2.5,
    artifacts_9_round_sd: 600,
    artifacts_9_round_da: 27895,
    artifacts_10: 'Fanged Metal, Woodpecker Electro, Flex',
    artifacts_10_1: 'Fanged Metal',
    artifacts_10_2: 'Woodpecker Electro',
    artifacts_10_3: 'Flex',
    artifacts_10_app: 2.5,
    artifacts_10_round_sd: 600,
    artifacts_10_round_da: 14664,
    drive_slot_4_1: 'CRIT Rate',
    drive_slot_4_1_app: 48.56,
    drive_slot_4_2: 'CRIT DMG',
    drive_slot_4_2_app: 46.25,
    drive_slot_4_3: '',
    drive_slot_4_3_app: 5.2,
    drive_slot_5_1: 'Percent ATK',
    drive_slot_5_1_app: 47.4,
    drive_slot_5_2: 'Physical DMG Bonus',
    drive_slot_5_2_app: 28.9,
    drive_slot_5_3: 'PEN Ratio',
    drive_slot_5_3_app: 23.7,
    drive_slot_6_1: 'Percent ATK',
    drive_slot_6_1_app: 94.8,
    drive_slot_6_2: 'Energy Regen',
    drive_slot_6_2_app: 5.2,
    drive_slot_6_3: '',
    drive_slot_6_3_app: 0,
    char_level: 60,
    w_engine_level: 58.15,
    basic_atk: 11.75,
    special_atk: 11.66,
    dash: 11.18,
    ultimate: 11.95,
    core_skill: 7,
    assist: 10.72,
    base_hp: 9942.76,
    base_atk: 2937.68,
    base_def: 888.21,
    base_impact: 91,
    crit_rate: 70.95,
    crit_dmg: 145.71,
    anomaly_mastery: 92,
    anomaly_proficiency: 113.21,
    pen_ratio: 6.01,
    pen: 34.59,
    base_energy_regen: 123.75,
    dmg_bonus: 12.49,
    percent_hp_sub: 8.19,
    percent_atk_sub: 19.56,
    percent_def_sub: 9.68,
    crit_rate_sub: 27.55,
    crit_dmg_sub: 60.29,
    pen_sub: 34.59,
    anomaly_proficiency_sub: 22.21
  },
  {
    char: 'grace-howard',
    app_rate_sd: 2.35,
    app_rate_sd_e1: 0.71,
    app_rate_sd_s0: 0.54,
    avg_round_sd: 155,
    avg_round_sd_e1: 136,
    avg_round_sd_s0: 156,
    sample_sd: 113,
    sample_size_players_sd: 26,
    app_rate_da: 3.55,
    app_rate_da_e1: 1.13,
    app_rate_da_s0: 0.99,
    avg_round_da: 19353,
    avg_round_da_e1: 27269,
    avg_round_da_s0: 18289,
    app_rate_da_boss_1: 0.29,
    avg_round_da_boss_1: 0,
    app_rate_da_boss_2: 1.73,
    avg_round_da_boss_2: 20738,
    app_rate_da_boss_3: 1.9,
    avg_round_da_boss_3: 18542,
    sample_da: 208,
    sample_size_players_da: 33,
    app_0: 42.35,
    round_0_sd: 158,
    round_0_da: 17585,
    app_1: 29.63,
    round_1_sd: 176,
    round_1_da: 20139,
    app_2: 16.78,
    round_2_sd: 138,
    round_2_da: 21236,
    app_3: 7.45,
    round_3_sd: 111,
    round_3_da: 22068,
    app_4: 2.57,
    round_4_sd: 128,
    round_4_da: 23793,
    app_5: 1,
    round_5_sd: 600,
    round_5_da: 0,
    app_6: 1.22,
    round_6_sd: 139,
    round_6_da: 37431,
    cons_avg: 1.04,
    weapons_1: 'Fusion Compiler',
    weapons_1_app: 40.1,
    weapons_1_round_sd: 155,
    weapons_1_round_da: 19651,
    weapons_2: 'Weeping Gemini',
    weapons_2_app: 23.18,
    weapons_2_round_sd: 165,
    weapons_2_round_da: 19845,
    weapons_3: 'Rainforest Gourmet',
    weapons_3_app: 11.87,
    weapons_3_round_sd: 166,
    weapons_3_round_da: 18282,
    weapons_4: 'Electro-Lip Gloss',
    weapons_4_app: 7.57,
    weapons_4_round_sd: 141,
    weapons_4_round_da: 20476,
    weapons_5: 'Roaring Ride',
    weapons_5_app: 4.02,
    weapons_5_round_sd: 139,
    weapons_5_round_da: 19746,
    weapons_6: 'Timeweaver',
    weapons_6_app: 3.49,
    weapons_6_round_sd: 92,
    weapons_6_round_da: 31428,
    weapons_7: '[Magnetic Storm] Alpha',
    weapons_7_app: 0.87,
    weapons_7_round_sd: 600,
    weapons_7_round_da: 16928,
    weapons_8: 'Flight of Fancy',
    weapons_8_app: 0.64,
    weapons_8_round_sd: 600,
    weapons_8_round_da: 0,
    weapons_9: 'Bashful Demon',
    weapons_9_app: 0.35,
    weapons_9_round_sd: 159,
    weapons_9_round_da: 0,
    weapons_10: 'Flamemaker Shaker',
    weapons_10_app: 0.35,
    weapons_10_round_sd: 600,
    weapons_10_round_da: 0,
    artifacts_1: 'Freedom Blues, Thunder Metal',
    artifacts_1_1: 'Freedom Blues',
    artifacts_1_2: 'Thunder Metal',
    artifacts_1_3: '',
    artifacts_1_app: 34.37,
    artifacts_1_round_sd: 159,
    artifacts_1_round_da: 18726,
    artifacts_2: 'Thunder Metal, Freedom Blues',
    artifacts_2_1: 'Thunder Metal',
    artifacts_2_2: 'Freedom Blues',
    artifacts_2_3: '',
    artifacts_2_app: 15.13,
    artifacts_2_round_sd: 158,
    artifacts_2_round_da: 18704,
    artifacts_3: 'Chaos Jazz, Freedom Blues',
    artifacts_3_1: 'Chaos Jazz',
    artifacts_3_2: 'Freedom Blues',
    artifacts_3_3: '',
    artifacts_3_app: 7.64,
    artifacts_3_round_sd: 174,
    artifacts_3_round_da: 19052,
    artifacts_4: 'Freedom Blues, Swing Jazz',
    artifacts_4_1: 'Freedom Blues',
    artifacts_4_2: 'Swing Jazz',
    artifacts_4_3: '',
    artifacts_4_app: 5.98,
    artifacts_4_round_sd: 114,
    artifacts_4_round_da: 15535,
    artifacts_5: "Freedom Blues, Phaethon's Melody",
    artifacts_5_1: 'Freedom Blues',
    artifacts_5_2: "Phaethon's Melody",
    artifacts_5_3: '',
    artifacts_5_app: 5.94,
    artifacts_5_round_sd: 126,
    artifacts_5_round_da: 20733,
    artifacts_6: 'Freedom Blues, Chaos Jazz',
    artifacts_6_1: 'Freedom Blues',
    artifacts_6_2: 'Chaos Jazz',
    artifacts_6_3: '',
    artifacts_6_app: 4.24,
    artifacts_6_round_sd: 191,
    artifacts_6_round_da: 20008,
    artifacts_7: 'Thunder Metal, Chaos Jazz',
    artifacts_7_1: 'Thunder Metal',
    artifacts_7_2: 'Chaos Jazz',
    artifacts_7_3: '',
    artifacts_7_app: 4.08,
    artifacts_7_round_sd: 132,
    artifacts_7_round_da: 24668,
    artifacts_8: "Chaos Jazz, Phaethon's Melody",
    artifacts_8_1: 'Chaos Jazz',
    artifacts_8_2: "Phaethon's Melody",
    artifacts_8_3: '',
    artifacts_8_app: 2.5,
    artifacts_8_round_sd: 155,
    artifacts_8_round_da: 25821,
    artifacts_9: 'Chaos Jazz, Thunder Metal',
    artifacts_9_1: 'Chaos Jazz',
    artifacts_9_2: 'Thunder Metal',
    artifacts_9_3: '',
    artifacts_9_app: 1.73,
    artifacts_9_round_sd: 600,
    artifacts_9_round_da: 26282,
    artifacts_10: 'Chaos Jazz, Puffer Electro',
    artifacts_10_1: 'Chaos Jazz',
    artifacts_10_2: 'Puffer Electro',
    artifacts_10_3: '',
    artifacts_10_app: 1.06,
    artifacts_10_round_sd: 90,
    artifacts_10_round_da: 0,
    drive_slot_4_1: 'Anomaly Proficiency',
    drive_slot_4_1_app: 100,
    drive_slot_4_2: '',
    drive_slot_4_2_app: 0,
    drive_slot_4_3: '',
    drive_slot_4_3_app: 0,
    drive_slot_5_1: 'Electric DMG Bonus',
    drive_slot_5_1_app: 54.85,
    drive_slot_5_2: 'PEN Ratio',
    drive_slot_5_2_app: 20.13,
    drive_slot_5_3: 'Percent ATK',
    drive_slot_5_3_app: 19.84,
    drive_slot_6_1: 'Anomaly Mastery',
    drive_slot_6_1_app: 86.58,
    drive_slot_6_2: 'Percent ATK',
    drive_slot_6_2_app: 8.25,
    drive_slot_6_3: 'Energy Regen',
    drive_slot_6_3_app: 3.35,
    char_level: 59.77,
    w_engine_level: 55.01,
    basic_atk: 10.34,
    special_atk: 10.88,
    dash: 7.63,
    ultimate: 9.49,
    core_skill: 6.74,
    assist: 7.65,
    base_hp: 10815.32,
    base_atk: 2404.05,
    base_def: 930.55,
    base_impact: 83.05,
    crit_rate: 15.99,
    crit_dmg: 69.1,
    anomaly_mastery: 190.61,
    anomaly_proficiency: 348.44,
    pen_ratio: 14.94,
    pen: 39.43,
    base_energy_regen: 123.22,
    dmg_bonus: 21.93,
    percent_hp_sub: 9.66,
    percent_atk_sub: 25.58,
    percent_def_sub: 20.34,
    crit_rate_sub: 10.99,
    crit_dmg_sub: 19.1,
    pen_sub: 39.43,
    anomaly_proficiency_sub: 91.26
  },
  {
    char: 'anby-demara',
    app_rate_sd: 1.93,
    app_rate_sd_e1: 0.62,
    app_rate_sd_s0: 0.67,
    avg_round_sd: 190,
    avg_round_sd_e1: 156,
    avg_round_sd_s0: 194,
    sample_sd: 93,
    sample_size_players_sd: 10,
    app_rate_da: 5.4,
    app_rate_da_e1: 0.85,
    app_rate_da_s0: 2.68,
    avg_round_da: 17750,
    avg_round_da_e1: 23922,
    avg_round_da_s0: 17259,
    app_rate_da_boss_1: 1.97,
    avg_round_da_boss_1: 18810,
    app_rate_da_boss_2: 0.16,
    avg_round_da_boss_2: 0,
    app_rate_da_boss_3: 3.67,
    avg_round_da_boss_3: 17132,
    sample_da: 316,
    sample_size_players_da: 27,
    app_0: 0.32,
    round_0_sd: 600,
    round_0_da: 15904,
    app_1: 1.08,
    round_1_sd: 200,
    round_1_da: 0,
    app_2: 1.27,
    round_2_sd: 315,
    round_2_da: 15140,
    app_3: 2.72,
    round_3_sd: 215,
    round_3_da: 14277,
    app_4: 3.89,
    round_4_sd: 202,
    round_4_da: 15213,
    app_5: 3.24,
    round_5_sd: 198,
    round_5_da: 15789,
    app_6: 88.37,
    round_6_sd: 184,
    round_6_da: 18111,
    cons_avg: 5.73,
    weapons_1: 'Demara Battery Mark II',
    weapons_1_app: 69.68,
    weapons_1_round_sd: 194,
    weapons_1_round_da: 17107,
    weapons_2: 'Steam Oven',
    weapons_2_app: 12.61,
    weapons_2_round_sd: 166,
    weapons_2_round_da: 18550,
    weapons_3: 'Hellfire Gears',
    weapons_3_app: 6.94,
    weapons_3_round_sd: 204,
    weapons_3_round_da: 19531,
    weapons_4: 'The Restrained',
    weapons_4_app: 5.01,
    weapons_4_round_sd: 158,
    weapons_4_round_da: 20128,
    weapons_5: 'Precious Fossilized Core',
    weapons_5_app: 2.91,
    weapons_5_round_sd: 159,
    weapons_5_round_da: 18181,
    weapons_6: 'Deep Sea Visitor',
    weapons_6_app: 0.52,
    weapons_6_round_sd: 600,
    weapons_6_round_da: 0,
    weapons_7: 'Six Shooter',
    weapons_7_app: 0.46,
    weapons_7_round_sd: 600,
    weapons_7_round_da: 13816,
    weapons_8: 'Hailstorm Shrine',
    weapons_8_app: 0.24,
    weapons_8_round_sd: 600,
    weapons_8_round_da: 30919,
    weapons_9: '[Vortex] Arrow',
    weapons_9_app: 0.24,
    weapons_9_round_sd: 600,
    weapons_9_round_da: 27001,
    weapons_10: '',
    weapons_10_app: 0,
    weapons_10_round_sd: 600,
    weapons_10_round_da: 0,
    artifacts_1: 'Shockstar Disco, Swing Jazz',
    artifacts_1_1: 'Shockstar Disco',
    artifacts_1_2: 'Swing Jazz',
    artifacts_1_3: '',
    artifacts_1_app: 37.51,
    artifacts_1_round_sd: 179,
    artifacts_1_round_da: 19107,
    artifacts_2: 'Shockstar Disco, Thunder Metal',
    artifacts_2_1: 'Shockstar Disco',
    artifacts_2_2: 'Thunder Metal',
    artifacts_2_3: '',
    artifacts_2_app: 36.62,
    artifacts_2_round_sd: 192,
    artifacts_2_round_da: 16448,
    artifacts_3: 'Shockstar Disco, Woodpecker Electro',
    artifacts_3_1: 'Shockstar Disco',
    artifacts_3_2: 'Woodpecker Electro',
    artifacts_3_3: '',
    artifacts_3_app: 3.61,
    artifacts_3_round_sd: 157,
    artifacts_3_round_da: 17376,
    artifacts_4: 'Shockstar Disco, Flex',
    artifacts_4_1: 'Shockstar Disco',
    artifacts_4_2: 'Flex',
    artifacts_4_3: '',
    artifacts_4_app: 2.68,
    artifacts_4_round_sd: 215,
    artifacts_4_round_da: 16609,
    artifacts_5: 'Astral Voice, Shockstar Disco',
    artifacts_5_1: 'Astral Voice',
    artifacts_5_2: 'Shockstar Disco',
    artifacts_5_3: '',
    artifacts_5_app: 2.02,
    artifacts_5_round_sd: 171,
    artifacts_5_round_da: 22013,
    artifacts_6: 'Swing Jazz, Shockstar Disco',
    artifacts_6_1: 'Swing Jazz',
    artifacts_6_2: 'Shockstar Disco',
    artifacts_6_3: '',
    artifacts_6_app: 1.74,
    artifacts_6_round_sd: 237,
    artifacts_6_round_da: 19050,
    artifacts_7: 'Shockstar Disco, Swing Jazz, Flex',
    artifacts_7_1: 'Shockstar Disco',
    artifacts_7_2: 'Swing Jazz',
    artifacts_7_3: 'Flex',
    artifacts_7_app: 1.4,
    artifacts_7_round_sd: 600,
    artifacts_7_round_da: 17060,
    artifacts_8: 'Shockstar Disco, Flex',
    artifacts_8_1: 'Shockstar Disco',
    artifacts_8_2: 'Flex',
    artifacts_8_3: '',
    artifacts_8_app: 1.17,
    artifacts_8_round_sd: 600,
    artifacts_8_round_da: 20259,
    artifacts_9: 'Shockstar Disco, Hormone Punk',
    artifacts_9_1: 'Shockstar Disco',
    artifacts_9_2: 'Hormone Punk',
    artifacts_9_3: '',
    artifacts_9_app: 0.94,
    artifacts_9_round_sd: 600,
    artifacts_9_round_da: 17649,
    artifacts_10: 'Shockstar Disco, Thunder Metal, Flex',
    artifacts_10_1: 'Shockstar Disco',
    artifacts_10_2: 'Thunder Metal',
    artifacts_10_3: 'Flex',
    artifacts_10_app: 0.57,
    artifacts_10_round_sd: 600,
    artifacts_10_round_da: 0,
    drive_slot_4_1: 'CRIT Rate',
    drive_slot_4_1_app: 67.55,
    drive_slot_4_2: 'CRIT DMG',
    drive_slot_4_2_app: 18.91,
    drive_slot_4_3: 'Percent ATK',
    drive_slot_4_3_app: 10.81,
    drive_slot_5_1: 'Electric DMG Bonus',
    drive_slot_5_1_app: 62.09,
    drive_slot_5_2: 'PEN Ratio',
    drive_slot_5_2_app: 16.27,
    drive_slot_5_3: 'Percent ATK',
    drive_slot_5_3_app: 16.27,
    drive_slot_6_1: 'Impact',
    drive_slot_6_1_app: 81.09,
    drive_slot_6_2: 'Percent ATK',
    drive_slot_6_2_app: 13.54,
    drive_slot_6_3: 'Energy Regen',
    drive_slot_6_3_app: 5.36,
    char_level: 59.74,
    w_engine_level: 58.66,
    basic_atk: 11.06,
    special_atk: 11.09,
    dash: 10.11,
    ultimate: 10.65,
    core_skill: 6.92,
    assist: 10.14,
    base_hp: 10954.16,
    base_atk: 2113.78,
    base_def: 938.65,
    base_impact: 177.26,
    crit_rate: 43.68,
    crit_dmg: 101.97,
    anomaly_mastery: 94,
    anomaly_proficiency: 127.68,
    pen_ratio: 3.78,
    pen: 38.64,
    base_energy_regen: 145.29,
    dmg_bonus: 18.5,
    percent_hp_sub: 12.13,
    percent_atk_sub: 22.58,
    percent_def_sub: 16.63,
    crit_rate_sub: 19.01,
    crit_dmg_sub: 41.16,
    pen_sub: 38.64,
    anomaly_proficiency_sub: 32.18
  },
  {
    char: 'nicole-demara',
    app_rate_sd: 42,
    app_rate_sd_e1: 13.16,
    app_rate_sd_s0: 8.96,
    avg_round_sd: 128,
    avg_round_sd_e1: 94,
    avg_round_sd_s0: 147,
    sample_sd: 2020,
    sample_size_players_sd: 185,
    app_rate_da: 57.32,
    app_rate_da_e1: 14.84,
    app_rate_da_s0: 18.54,
    avg_round_da: 26160,
    avg_round_da_e1: 35574,
    avg_round_da_s0: 24287,
    app_rate_da_boss_1: 29.36,
    avg_round_da_boss_1: 26249,
    app_rate_da_boss_2: 8.7,
    avg_round_da_boss_2: 27266,
    app_rate_da_boss_3: 23.72,
    avg_round_da_boss_3: 25782,
    sample_da: 3354,
    sample_size_players_da: 274,
    app_0: 0.06,
    round_0_sd: 600,
    round_0_da: 15481,
    app_1: 0.16,
    round_1_sd: 178,
    round_1_da: 21278,
    app_2: 0.24,
    round_2_sd: 123,
    round_2_da: 25332,
    app_3: 0.98,
    round_3_sd: 135,
    round_3_da: 22711,
    app_4: 0.81,
    round_4_sd: 140,
    round_4_da: 22039,
    app_5: 1.45,
    round_5_sd: 121,
    round_5_da: 22898,
    app_6: 96.33,
    round_6_sd: 128,
    round_6_da: 26328,
    cons_avg: 5.92,
    weapons_1: 'The Vault',
    weapons_1_app: 92.57,
    weapons_1_round_sd: 128,
    weapons_1_round_da: 26282,
    weapons_2: 'Weeping Cradle',
    weapons_2_app: 2.46,
    weapons_2_round_sd: 126,
    weapons_2_round_da: 24643,
    weapons_3: 'Kaboom the Cannon',
    weapons_3_app: 2.22,
    weapons_3_round_sd: 118,
    weapons_3_round_da: 25925,
    weapons_4: 'Slice of Time',
    weapons_4_app: 0.98,
    weapons_4_round_sd: 131,
    weapons_4_round_da: 24843,
    weapons_5: '[Reverb] Mark II',
    weapons_5_app: 0.45,
    weapons_5_round_sd: 129,
    weapons_5_round_da: 25253,
    weapons_6: 'Unfettered Game Ball',
    weapons_6_app: 0.44,
    weapons_6_round_sd: 128,
    weapons_6_round_da: 22970,
    weapons_7: 'Bashful Demon',
    weapons_7_app: 0.15,
    weapons_7_round_sd: 94,
    weapons_7_round_da: 25290,
    weapons_8: '[Reverb] Mark III',
    weapons_8_app: 0.07,
    weapons_8_round_sd: 132,
    weapons_8_round_da: 35584,
    weapons_9: 'Elegant Vanity',
    weapons_9_app: 0.02,
    weapons_9_round_sd: 600,
    weapons_9_round_da: 0,
    weapons_10: '',
    weapons_10_app: 0,
    weapons_10_round_sd: 600,
    weapons_10_round_da: 0,
    artifacts_1: 'Swing Jazz, Chaotic Metal',
    artifacts_1_1: 'Swing Jazz',
    artifacts_1_2: 'Chaotic Metal',
    artifacts_1_3: '',
    artifacts_1_app: 36.19,
    artifacts_1_round_sd: 132,
    artifacts_1_round_da: 25143,
    artifacts_2: 'Swing Jazz, Freedom Blues',
    artifacts_2_1: 'Swing Jazz',
    artifacts_2_2: 'Freedom Blues',
    artifacts_2_3: '',
    artifacts_2_app: 15.41,
    artifacts_2_round_sd: 134,
    artifacts_2_round_da: 26144,
    artifacts_3: 'Astral Voice, Swing Jazz',
    artifacts_3_1: 'Astral Voice',
    artifacts_3_2: 'Swing Jazz',
    artifacts_3_3: '',
    artifacts_3_app: 14.7,
    artifacts_3_round_sd: 125,
    artifacts_3_round_da: 26831,
    artifacts_4: 'Freedom Blues, Swing Jazz',
    artifacts_4_1: 'Freedom Blues',
    artifacts_4_2: 'Swing Jazz',
    artifacts_4_3: '',
    artifacts_4_app: 4.26,
    artifacts_4_round_sd: 104,
    artifacts_4_round_da: 29640,
    artifacts_5: 'Swing Jazz, Astral Voice',
    artifacts_5_1: 'Swing Jazz',
    artifacts_5_2: 'Astral Voice',
    artifacts_5_3: '',
    artifacts_5_app: 3.34,
    artifacts_5_round_sd: 115,
    artifacts_5_round_da: 29965,
    artifacts_6: "Swing Jazz, Phaethon's Melody",
    artifacts_6_1: 'Swing Jazz',
    artifacts_6_2: "Phaethon's Melody",
    artifacts_6_3: '',
    artifacts_6_app: 3.11,
    artifacts_6_round_sd: 111,
    artifacts_6_round_da: 30484,
    artifacts_7: 'Swing Jazz, Woodpecker Electro',
    artifacts_7_1: 'Swing Jazz',
    artifacts_7_2: 'Woodpecker Electro',
    artifacts_7_3: '',
    artifacts_7_app: 3.01,
    artifacts_7_round_sd: 121,
    artifacts_7_round_da: 28102,
    artifacts_8: 'Chaotic Metal, Swing Jazz',
    artifacts_8_1: 'Chaotic Metal',
    artifacts_8_2: 'Swing Jazz',
    artifacts_8_3: '',
    artifacts_8_app: 2.47,
    artifacts_8_round_sd: 142,
    artifacts_8_round_da: 20491,
    artifacts_9: 'Swing Jazz, Chaos Jazz',
    artifacts_9_1: 'Swing Jazz',
    artifacts_9_2: 'Chaos Jazz',
    artifacts_9_3: '',
    artifacts_9_app: 1.24,
    artifacts_9_round_sd: 600,
    artifacts_9_round_da: 30072,
    artifacts_10: 'Swing Jazz, Flex',
    artifacts_10_1: 'Swing Jazz',
    artifacts_10_2: 'Flex',
    artifacts_10_3: '',
    artifacts_10_app: 1.03,
    artifacts_10_round_sd: 136,
    artifacts_10_round_da: 0,
    drive_slot_4_1: 'Anomaly Proficiency',
    drive_slot_4_1_app: 58.21,
    drive_slot_4_2: 'CRIT Rate',
    drive_slot_4_2_app: 22.68,
    drive_slot_4_3: 'Percent ATK',
    drive_slot_4_3_app: 9.79,
    drive_slot_5_1: 'Ether DMG Bonus',
    drive_slot_5_1_app: 63.6,
    drive_slot_5_2: 'Percent ATK',
    drive_slot_5_2_app: 28.34,
    drive_slot_5_3: 'PEN Ratio',
    drive_slot_5_3_app: 3.07,
    drive_slot_6_1: 'Energy Regen',
    drive_slot_6_1_app: 71.47,
    drive_slot_6_2: 'Anomaly Mastery',
    drive_slot_6_2_app: 19.65,
    drive_slot_6_3: 'Percent ATK',
    drive_slot_6_3_app: 6.94,
    char_level: 59.67,
    w_engine_level: 56.59,
    basic_atk: 5.49,
    special_atk: 10.02,
    dash: 4.93,
    ultimate: 9.32,
    core_skill: 6.79,
    assist: 7.29,
    base_hp: 11679.64,
    base_atk: 2007.25,
    base_def: 964,
    base_impact: 88.18,
    crit_rate: 25.87,
    crit_dmg: 83.75,
    anomaly_mastery: 95.67,
    anomaly_proficiency: 205.56,
    pen_ratio: 1.44,
    pen: 36.2,
    base_energy_regen: 321.59,
    dmg_bonus: 21.77,
    percent_hp_sub: 13.25,
    percent_atk_sub: 17.26,
    percent_def_sub: 19.25,
    crit_rate_sub: 14.98,
    crit_dmg_sub: 30.68,
    pen_sub: 36.2,
    anomaly_proficiency_sub: 52.41
  },
  {
    char: 'piper',
    app_rate_sd: 3.08,
    app_rate_sd_e1: 0.71,
    app_rate_sd_s0: 0.79,
    avg_round_sd: 163,
    avg_round_sd_e1: 140,
    avg_round_sd_s0: 175,
    sample_sd: 148,
    sample_size_players_sd: 34,
    app_rate_da: 6.31,
    app_rate_da_e1: 1.44,
    app_rate_da_s0: 1.97,
    avg_round_da: 22878,
    avg_round_da_e1: 27705,
    avg_round_da_s0: 20625,
    app_rate_da_boss_1: 3.39,
    avg_round_da_boss_1: 25368,
    app_rate_da_boss_2: 2.25,
    avg_round_da_boss_2: 20103,
    app_rate_da_boss_3: 1.22,
    avg_round_da_boss_3: 19344,
    sample_da: 369,
    sample_size_players_da: 65,
    app_0: 0.27,
    round_0_sd: 600,
    round_0_da: 14531,
    app_1: 1,
    round_1_sd: 600,
    round_1_da: 0,
    app_2: 1,
    round_2_sd: 600,
    round_2_da: 0,
    app_3: 1.36,
    round_3_sd: 217,
    round_3_da: 15345,
    app_4: 2.45,
    round_4_sd: 184,
    round_4_da: 15934,
    app_5: 1.18,
    round_5_sd: 161,
    round_5_da: 16521,
    app_6: 94.83,
    round_6_sd: 162,
    round_6_da: 23332,
    cons_avg: 5.89,
    weapons_1: 'Roaring Ride',
    weapons_1_app: 88.24,
    weapons_1_round_sd: 163,
    weapons_1_round_da: 22938,
    weapons_2: 'Weeping Gemini',
    weapons_2_app: 3.08,
    weapons_2_round_sd: 183,
    weapons_2_round_da: 21144,
    weapons_3: 'Rainforest Gourmet',
    weapons_3_app: 2.39,
    weapons_3_round_sd: 148,
    weapons_3_round_da: 21423,
    weapons_4: 'Fusion Compiler',
    weapons_4_app: 2.17,
    weapons_4_round_sd: 180,
    weapons_4_round_da: 28444,
    weapons_5: 'Sharpened Stinger',
    weapons_5_app: 0.99,
    weapons_5_round_sd: 126,
    weapons_5_round_da: 35393,
    weapons_6: 'Electro-Lip Gloss',
    weapons_6_app: 0.73,
    weapons_6_round_sd: 600,
    weapons_6_round_da: 22375,
    weapons_7: '[Magnetic Storm] Bravo',
    weapons_7_app: 0.36,
    weapons_7_round_sd: 600,
    weapons_7_round_da: 13366,
    weapons_8: 'Flamemaker Shaker',
    weapons_8_app: 0.18,
    weapons_8_round_sd: 600,
    weapons_8_round_da: 0,
    weapons_9: '[Magnetic Storm] Alpha',
    weapons_9_app: 0.18,
    weapons_9_round_sd: 600,
    weapons_9_round_da: 10435,
    weapons_10: '',
    weapons_10_app: 0,
    weapons_10_round_sd: 600,
    weapons_10_round_da: 0,
    artifacts_1: 'Freedom Blues, Fanged Metal',
    artifacts_1_1: 'Freedom Blues',
    artifacts_1_2: 'Fanged Metal',
    artifacts_1_3: '',
    artifacts_1_app: 32.43,
    artifacts_1_round_sd: 172,
    artifacts_1_round_da: 21609,
    artifacts_2: 'Fanged Metal, Freedom Blues',
    artifacts_2_1: 'Fanged Metal',
    artifacts_2_2: 'Freedom Blues',
    artifacts_2_3: '',
    artifacts_2_app: 25.56,
    artifacts_2_round_sd: 159,
    artifacts_2_round_da: 24084,
    artifacts_3: 'Freedom Blues, Swing Jazz',
    artifacts_3_1: 'Freedom Blues',
    artifacts_3_2: 'Swing Jazz',
    artifacts_3_3: '',
    artifacts_3_app: 9.31,
    artifacts_3_round_sd: 154,
    artifacts_3_round_da: 22427,
    artifacts_4: 'Fanged Metal, Chaos Jazz',
    artifacts_4_1: 'Fanged Metal',
    artifacts_4_2: 'Chaos Jazz',
    artifacts_4_3: '',
    artifacts_4_app: 5.32,
    artifacts_4_round_sd: 139,
    artifacts_4_round_da: 31384,
    artifacts_5: 'Freedom Blues, Chaos Jazz',
    artifacts_5_1: 'Freedom Blues',
    artifacts_5_2: 'Chaos Jazz',
    artifacts_5_3: '',
    artifacts_5_app: 4.4,
    artifacts_5_round_sd: 170,
    artifacts_5_round_da: 21972,
    artifacts_6: "Freedom Blues, Phaethon's Melody",
    artifacts_6_1: 'Freedom Blues',
    artifacts_6_2: "Phaethon's Melody",
    artifacts_6_3: '',
    artifacts_6_app: 3.48,
    artifacts_6_round_sd: 189,
    artifacts_6_round_da: 20324,
    artifacts_7: "Fanged Metal, Phaethon's Melody",
    artifacts_7_1: 'Fanged Metal',
    artifacts_7_2: "Phaethon's Melody",
    artifacts_7_3: '',
    artifacts_7_app: 2.21,
    artifacts_7_round_sd: 155,
    artifacts_7_round_da: 32542,
    artifacts_8: 'Freedom Blues, Flex',
    artifacts_8_1: 'Freedom Blues',
    artifacts_8_2: 'Flex',
    artifacts_8_3: '',
    artifacts_8_app: 1.46,
    artifacts_8_round_sd: 600,
    artifacts_8_round_da: 18245,
    artifacts_9: 'Fanged Metal, Astral Voice',
    artifacts_9_1: 'Fanged Metal',
    artifacts_9_2: 'Astral Voice',
    artifacts_9_3: '',
    artifacts_9_app: 0.91,
    artifacts_9_round_sd: 600,
    artifacts_9_round_da: 26231,
    artifacts_10: 'Freedom Blues, Hormone Punk',
    artifacts_10_1: 'Freedom Blues',
    artifacts_10_2: 'Hormone Punk',
    artifacts_10_3: '',
    artifacts_10_app: 0.67,
    artifacts_10_round_sd: 160,
    artifacts_10_round_da: 0,
    drive_slot_4_1: 'Anomaly Proficiency',
    drive_slot_4_1_app: 96.97,
    drive_slot_4_2: 'CRIT Rate',
    drive_slot_4_2_app: 1.99,
    drive_slot_4_3: 'CRIT DMG',
    drive_slot_4_3_app: 1.03,
    drive_slot_5_1: 'Physical DMG Bonus',
    drive_slot_5_1_app: 56.45,
    drive_slot_5_2: 'Percent ATK',
    drive_slot_5_2_app: 32.53,
    drive_slot_5_3: 'PEN Ratio',
    drive_slot_5_3_app: 11.03,
    drive_slot_6_1: 'Anomaly Mastery',
    drive_slot_6_1_app: 82.77,
    drive_slot_6_2: 'Percent ATK',
    drive_slot_6_2_app: 12.13,
    drive_slot_6_3: 'Energy Regen',
    drive_slot_6_3_app: 4.06,
    char_level: 60,
    w_engine_level: 59.08,
    basic_atk: 8.79,
    special_atk: 11.1,
    dash: 7.42,
    ultimate: 10.03,
    core_skill: 6.95,
    assist: 8.26,
    base_hp: 10260.54,
    base_atk: 2597.14,
    base_def: 954.25,
    base_impact: 86.31,
    crit_rate: 16.13,
    crit_dmg: 70.22,
    anomaly_mastery: 144.41,
    anomaly_proficiency: 334.52,
    pen_ratio: 4.11,
    pen: 39.03,
    base_energy_regen: 162.92,
    dmg_bonus: 24.71,
    percent_hp_sub: 9.94,
    percent_atk_sub: 24.14,
    percent_def_sub: 18.31,
    crit_rate_sub: 10.41,
    crit_dmg_sub: 19.73,
    pen_sub: 39.03,
    anomaly_proficiency_sub: 96.38
  },
  {
    char: 'nekomata',
    app_rate_sd: 0.4,
    app_rate_sd_e1: 0.12,
    app_rate_sd_s0: 0.15,
    avg_round_sd: 600,
    avg_round_sd_e1: 600,
    avg_round_sd_s0: 600,
    sample_sd: 19,
    sample_size_players_sd: 14,
    app_rate_da: 1.15,
    app_rate_da_e1: 0.27,
    app_rate_da_s0: 0.6,
    avg_round_da: 22522,
    avg_round_da_e1: 0,
    avg_round_da_s0: 21624,
    app_rate_da_boss_1: 0.78,
    avg_round_da_boss_1: 24274,
    app_rate_da_boss_2: 0.06,
    avg_round_da_boss_2: 0,
    app_rate_da_boss_3: 0.39,
    avg_round_da_boss_3: 18690,
    sample_da: 67,
    sample_size_players_da: 36,
    app_0: 18.22,
    round_0_sd: 160,
    round_0_da: 20006,
    app_1: 43.23,
    round_1_sd: 121,
    round_1_da: 22483,
    app_2: 20.69,
    round_2_sd: 154,
    round_2_da: 24809,
    app_3: 6.89,
    round_3_sd: 163,
    round_3_da: 21958,
    app_4: 3.82,
    round_4_sd: 241,
    round_4_da: 0,
    app_5: 2.46,
    round_5_sd: 193,
    round_5_da: 21270,
    app_6: 4.68,
    round_6_sd: 89,
    round_6_da: 0,
    cons_avg: 1.61,
    weapons_1: 'Steel Cushion',
    weapons_1_app: 72.42,
    weapons_1_round_sd: 149,
    weapons_1_round_da: 23405,
    weapons_2: 'The Brimstone',
    weapons_2_app: 12.68,
    weapons_2_round_sd: 128,
    weapons_2_round_da: 21612,
    weapons_3: 'Starlight Engine',
    weapons_3_app: 9.11,
    weapons_3_round_sd: 163,
    weapons_3_round_da: 21661,
    weapons_4: 'Heartstring Nocturne',
    weapons_4_app: 2.47,
    weapons_4_round_sd: 193,
    weapons_4_round_da: 21270,
    weapons_5: 'Cannon Rotor',
    weapons_5_app: 1.11,
    weapons_5_round_sd: 600,
    weapons_5_round_da: 6020,
    weapons_6: 'Marcato Desire',
    weapons_6_app: 1.11,
    weapons_6_round_sd: 600,
    weapons_6_round_da: 20951,
    weapons_7: '',
    weapons_7_app: 0,
    weapons_7_round_sd: 600,
    weapons_7_round_da: 0,
    weapons_8: '',
    weapons_8_app: 0,
    weapons_8_round_sd: 600,
    weapons_8_round_da: 0,
    weapons_9: '',
    weapons_9_app: 0,
    weapons_9_round_sd: 600,
    weapons_9_round_da: 0,
    weapons_10: '',
    weapons_10_app: 0,
    weapons_10_round_sd: 600,
    weapons_10_round_da: 0,
    artifacts_1: 'Woodpecker Electro, Fanged Metal',
    artifacts_1_1: 'Woodpecker Electro',
    artifacts_1_2: 'Fanged Metal',
    artifacts_1_3: '',
    artifacts_1_app: 33.11,
    artifacts_1_round_sd: 126,
    artifacts_1_round_da: 22514,
    artifacts_2: 'Fanged Metal, Woodpecker Electro',
    artifacts_2_1: 'Fanged Metal',
    artifacts_2_2: 'Woodpecker Electro',
    artifacts_2_3: '',
    artifacts_2_app: 17.61,
    artifacts_2_round_sd: 171,
    artifacts_2_round_da: 19138,
    artifacts_3: 'Woodpecker Electro, Branch & Blade Song',
    artifacts_3_1: 'Woodpecker Electro',
    artifacts_3_2: 'Branch & Blade Song',
    artifacts_3_3: '',
    artifacts_3_app: 15.39,
    artifacts_3_round_sd: 128,
    artifacts_3_round_da: 26056,
    artifacts_4: 'Fanged Metal, Branch & Blade Song',
    artifacts_4_1: 'Fanged Metal',
    artifacts_4_2: 'Branch & Blade Song',
    artifacts_4_3: '',
    artifacts_4_app: 8.5,
    artifacts_4_round_sd: 158,
    artifacts_4_round_da: 28253,
    artifacts_5: 'Branch & Blade Song, Fanged Metal, Woodpecker Electro',
    artifacts_5_1: 'Branch & Blade Song',
    artifacts_5_2: 'Fanged Metal',
    artifacts_5_3: 'Woodpecker Electro',
    artifacts_5_app: 5.79,
    artifacts_5_round_sd: 180,
    artifacts_5_round_da: 25039,
    artifacts_6: 'Woodpecker Electro, Puffer Electro',
    artifacts_6_1: 'Woodpecker Electro',
    artifacts_6_2: 'Puffer Electro',
    artifacts_6_3: '',
    artifacts_6_app: 3.58,
    artifacts_6_round_sd: 600,
    artifacts_6_round_da: 22495,
    artifacts_7: 'Fanged Metal, Hormone Punk',
    artifacts_7_1: 'Fanged Metal',
    artifacts_7_2: 'Hormone Punk',
    artifacts_7_3: '',
    artifacts_7_app: 2.72,
    artifacts_7_round_sd: 138,
    artifacts_7_round_da: 0,
    artifacts_8: 'Woodpecker Electro, Astral Voice',
    artifacts_8_1: 'Woodpecker Electro',
    artifacts_8_2: 'Astral Voice',
    artifacts_8_3: '',
    artifacts_8_app: 2.22,
    artifacts_8_round_sd: 600,
    artifacts_8_round_da: 35722,
    artifacts_9: 'Hormone Punk, Fanged Metal',
    artifacts_9_1: 'Hormone Punk',
    artifacts_9_2: 'Fanged Metal',
    artifacts_9_3: '',
    artifacts_9_app: 2.22,
    artifacts_9_round_sd: 600,
    artifacts_9_round_da: 0,
    artifacts_10: 'AP +30, ATK +10%, Woodpecker Electro',
    artifacts_10_1: 'AP +30',
    artifacts_10_2: 'ATK +10%',
    artifacts_10_3: 'Woodpecker Electro',
    artifacts_10_app: 1.11,
    artifacts_10_round_sd: 600,
    artifacts_10_round_da: 6020,
    drive_slot_4_1: 'CRIT DMG',
    drive_slot_4_1_app: 84.17,
    drive_slot_4_2: 'CRIT Rate',
    drive_slot_4_2_app: 11.93,
    drive_slot_4_3: 'Percent ATK',
    drive_slot_4_3_app: 3.9,
    drive_slot_5_1: 'Physical DMG Bonus',
    drive_slot_5_1_app: 45.87,
    drive_slot_5_2: 'Percent ATK',
    drive_slot_5_2_app: 38.07,
    drive_slot_5_3: 'PEN Ratio',
    drive_slot_5_3_app: 16.06,
    drive_slot_6_1: 'Percent ATK',
    drive_slot_6_1_app: 100,
    drive_slot_6_2: '',
    drive_slot_6_2_app: 0,
    drive_slot_6_3: '',
    drive_slot_6_3_app: 0,
    char_level: 60,
    w_engine_level: 60,
    basic_atk: 11.71,
    special_atk: 11.75,
    dash: 11.38,
    ultimate: 11.73,
    core_skill: 7,
    assist: 10.33,
    base_hp: 10541.34,
    base_atk: 2994.31,
    base_def: 888.46,
    base_impact: 92,
    crit_rate: 79.03,
    crit_dmg: 155.01,
    anomaly_mastery: 97,
    anomaly_proficiency: 123.81,
    pen_ratio: 4.16,
    pen: 35.47,
    base_energy_regen: 120,
    dmg_bonus: 20.37,
    percent_hp_sub: 7.24,
    percent_atk_sub: 17.13,
    percent_def_sub: 14.5,
    crit_rate_sub: 29.82,
    crit_dmg_sub: 57.93,
    pen_sub: 35.47,
    anomaly_proficiency_sub: 27.81
  },
  {
    char: 'zhu-yuan',
    app_rate_sd: 17.36,
    app_rate_sd_e1: 5.05,
    app_rate_sd_s0: 5.47,
    avg_round_sd: 145,
    avg_round_sd_e1: 118,
    avg_round_sd_s0: 150,
    sample_sd: 835,
    sample_size_players_sd: 526,
    app_rate_da: 34.3,
    app_rate_da_e1: 8.67,
    app_rate_da_s0: 12.89,
    avg_round_da: 25495,
    avg_round_da_e1: 33303,
    avg_round_da_s0: 24666,
    app_rate_da_boss_1: 24.52,
    avg_round_da_boss_1: 25641,
    app_rate_da_boss_2: 0.14,
    avg_round_da_boss_2: 0,
    app_rate_da_boss_3: 11.93,
    avg_round_da_boss_3: 25250,
    sample_da: 2007,
    sample_size_players_da: 1114,
    app_0: 81.07,
    round_0_sd: 145,
    round_0_da: 25495,
    app_1: 13.98,
    round_1_sd: 126,
    round_1_da: 31263,
    app_2: 2.68,
    round_2_sd: 100,
    round_2_da: 34951,
    app_3: 0.54,
    round_3_sd: 128,
    round_3_da: 36828,
    app_4: 0.53,
    round_4_sd: 134,
    round_4_da: 38639,
    app_5: 1,
    round_5_sd: 600,
    round_5_da: 0,
    app_6: 1.2,
    round_6_sd: 80,
    round_6_da: 51700,
    cons_avg: 0.3,
    weapons_1: 'Riot Suppressor Mark VI',
    weapons_1_app: 46.15,
    weapons_1_round_sd: 143,
    weapons_1_round_da: 26113,
    weapons_2: 'Starlight Engine',
    weapons_2_app: 22.55,
    weapons_2_round_sd: 145,
    weapons_2_round_da: 25586,
    weapons_3: 'The Brimstone',
    weapons_3_app: 15.21,
    weapons_3_round_sd: 139,
    weapons_3_round_da: 26468,
    weapons_4: 'Marcato Desire',
    weapons_4_app: 5.65,
    weapons_4_round_sd: 156,
    weapons_4_round_da: 23791,
    weapons_5: 'Cannon Rotor',
    weapons_5_app: 3.25,
    weapons_5_round_sd: 163,
    weapons_5_round_da: 21509,
    weapons_6: 'Gilded Blossom',
    weapons_6_app: 2.89,
    weapons_6_round_sd: 174,
    weapons_6_round_da: 21867,
    weapons_7: 'Steel Cushion',
    weapons_7_app: 1.23,
    weapons_7_round_sd: 155,
    weapons_7_round_da: 24996,
    weapons_8: 'Heartstring Nocturne',
    weapons_8_app: 0.75,
    weapons_8_round_sd: 115,
    weapons_8_round_da: 31026,
    weapons_9: 'Street Superstar',
    weapons_9_app: 0.67,
    weapons_9_round_sd: 148,
    weapons_9_round_da: 21218,
    weapons_10: '',
    weapons_10_app: 0,
    weapons_10_round_sd: 600,
    weapons_10_round_da: 0,
    artifacts_1: 'Chaotic Metal, Woodpecker Electro',
    artifacts_1_1: 'Chaotic Metal',
    artifacts_1_2: 'Woodpecker Electro',
    artifacts_1_3: '',
    artifacts_1_app: 72.03,
    artifacts_1_round_sd: 147,
    artifacts_1_round_da: 24796,
    artifacts_2: 'Chaotic Metal, Branch & Blade Song',
    artifacts_2_1: 'Chaotic Metal',
    artifacts_2_2: 'Branch & Blade Song',
    artifacts_2_3: '',
    artifacts_2_app: 10.53,
    artifacts_2_round_sd: 135,
    artifacts_2_round_da: 28995,
    artifacts_3: 'Chaotic Metal, Hormone Punk',
    artifacts_3_1: 'Chaotic Metal',
    artifacts_3_2: 'Hormone Punk',
    artifacts_3_3: '',
    artifacts_3_app: 3.73,
    artifacts_3_round_sd: 144,
    artifacts_3_round_da: 26509,
    artifacts_4: 'Woodpecker Electro, Chaotic Metal',
    artifacts_4_1: 'Woodpecker Electro',
    artifacts_4_2: 'Chaotic Metal',
    artifacts_4_3: '',
    artifacts_4_app: 2.29,
    artifacts_4_round_sd: 151,
    artifacts_4_round_da: 28210,
    artifacts_5: 'Chaotic Metal, Swing Jazz',
    artifacts_5_1: 'Chaotic Metal',
    artifacts_5_2: 'Swing Jazz',
    artifacts_5_3: '',
    artifacts_5_app: 1.97,
    artifacts_5_round_sd: 145,
    artifacts_5_round_da: 23329,
    artifacts_6: 'Chaotic Metal, Astral Voice',
    artifacts_6_1: 'Chaotic Metal',
    artifacts_6_2: 'Astral Voice',
    artifacts_6_3: '',
    artifacts_6_app: 1.95,
    artifacts_6_round_sd: 115,
    artifacts_6_round_da: 30498,
    artifacts_7: 'Chaotic Metal, Flex',
    artifacts_7_1: 'Chaotic Metal',
    artifacts_7_2: 'Flex',
    artifacts_7_3: '',
    artifacts_7_app: 1.69,
    artifacts_7_round_sd: 151,
    artifacts_7_round_da: 25467,
    artifacts_8: 'Hormone Punk, Chaotic Metal',
    artifacts_8_1: 'Hormone Punk',
    artifacts_8_2: 'Chaotic Metal',
    artifacts_8_3: '',
    artifacts_8_app: 0.88,
    artifacts_8_round_sd: 101,
    artifacts_8_round_da: 28229,
    artifacts_9: 'Hormone Punk, Branch & Blade Song',
    artifacts_9_1: 'Hormone Punk',
    artifacts_9_2: 'Branch & Blade Song',
    artifacts_9_3: '',
    artifacts_9_app: 0.84,
    artifacts_9_round_sd: 142,
    artifacts_9_round_da: 30729,
    artifacts_10: '',
    artifacts_10_1: '',
    artifacts_10_2: '',
    artifacts_10_3: '',
    artifacts_10_app: 0,
    artifacts_10_round_sd: 600,
    artifacts_10_round_da: 0,
    drive_slot_4_1: 'CRIT DMG',
    drive_slot_4_1_app: 64.57,
    drive_slot_4_2: 'CRIT Rate',
    drive_slot_4_2_app: 32.73,
    drive_slot_4_3: 'Percent ATK',
    drive_slot_4_3_app: 2.7,
    drive_slot_5_1: 'Ether DMG Bonus',
    drive_slot_5_1_app: 76.23,
    drive_slot_5_2: 'Percent ATK',
    drive_slot_5_2_app: 20.28,
    drive_slot_5_3: 'PEN Ratio',
    drive_slot_5_3_app: 3.13,
    drive_slot_6_1: 'Percent ATK',
    drive_slot_6_1_app: 98.04,
    drive_slot_6_2: 'Anomaly Mastery',
    drive_slot_6_2_app: 0.86,
    drive_slot_6_3: 'Energy Regen',
    drive_slot_6_3_app: 0.68,
    char_level: 59.99,
    w_engine_level: 59.46,
    basic_atk: 11.78,
    special_atk: 11.21,
    dash: 9.17,
    ultimate: 11.64,
    core_skill: 6.97,
    assist: 9.18,
    base_hp: 10785.42,
    base_atk: 2971.81,
    base_def: 922.47,
    base_impact: 90.01,
    crit_rate: 46.45,
    crit_dmg: 186.86,
    anomaly_mastery: 93.23,
    anomaly_proficiency: 121.85,
    pen_ratio: 0.81,
    pen: 32.76,
    base_energy_regen: 121.05,
    dmg_bonus: 32.48,
    percent_hp_sub: 10.3,
    percent_atk_sub: 15.59,
    percent_def_sub: 16.15,
    crit_rate_sub: 25.95,
    crit_dmg_sub: 50.54,
    pen_sub: 32.76,
    anomaly_proficiency_sub: 29.8
  },
  {
    char: 'lycaon',
    app_rate_sd: 10.79,
    app_rate_sd_e1: 5.22,
    app_rate_sd_s0: 0.62,
    avg_round_sd: 125,
    avg_round_sd_e1: 97,
    avg_round_sd_s0: 155,
    sample_sd: 519,
    sample_size_players_sd: 91,
    app_rate_da: 35.7,
    app_rate_da_e1: 12.56,
    app_rate_da_s0: 5.02,
    avg_round_da: 22317,
    avg_round_da_e1: 29827,
    avg_round_da_s0: 18632,
    app_rate_da_boss_1: 21.17,
    avg_round_da_boss_1: 21821,
    app_rate_da_boss_2: 17.28,
    avg_round_da_boss_2: 23229,
    app_rate_da_boss_3: 0.55,
    avg_round_da_boss_3: 16846,
    sample_da: 2089,
    sample_size_players_da: 294,
    app_0: 41.66,
    round_0_sd: 123,
    round_0_da: 21833,
    app_1: 35.7,
    round_1_sd: 124,
    round_1_da: 22831,
    app_2: 15.07,
    round_2_sd: 140,
    round_2_da: 22439,
    app_3: 5.2,
    round_3_sd: 120,
    round_3_da: 22117,
    app_4: 1.48,
    round_4_sd: 214,
    round_4_da: 25701,
    app_5: 0.69,
    round_5_sd: 600,
    round_5_da: 25437,
    app_6: 0.19,
    round_6_sd: 600,
    round_6_da: 0,
    cons_avg: 0.92,
    weapons_1: 'The Restrained',
    weapons_1_app: 38.22,
    weapons_1_round_sd: 128,
    weapons_1_round_da: 21469,
    weapons_2: 'Steam Oven',
    weapons_2_app: 24.13,
    weapons_2_round_sd: 118,
    weapons_2_round_da: 23724,
    weapons_3: 'Precious Fossilized Core',
    weapons_3_app: 14.55,
    weapons_3_round_sd: 119,
    weapons_3_round_da: 21552,
    weapons_4: 'Hellfire Gears',
    weapons_4_app: 14.12,
    weapons_4_round_sd: 135,
    weapons_4_round_da: 23403,
    weapons_5: 'Six Shooter',
    weapons_5_app: 3.2,
    weapons_5_round_sd: 116,
    weapons_5_round_da: 21516,
    weapons_6: 'Demara Battery Mark II',
    weapons_6_app: 1.47,
    weapons_6_round_sd: 116,
    weapons_6_round_da: 21623,
    weapons_7: '[Vortex] Arrow',
    weapons_7_app: 0.5,
    weapons_7_round_sd: 126,
    weapons_7_round_da: 18425,
    weapons_8: 'Blazing Laurel',
    weapons_8_app: 0.39,
    weapons_8_round_sd: 117,
    weapons_8_round_da: 25905,
    weapons_9: 'Box Cutter',
    weapons_9_app: 0.22,
    weapons_9_round_sd: 600,
    weapons_9_round_da: 23261,
    weapons_10: 'Ice-Jade Teapot',
    weapons_10_app: 0.13,
    weapons_10_round_sd: 156,
    weapons_10_round_da: 0,
    artifacts_1: 'Shockstar Disco, Polar Metal',
    artifacts_1_1: 'Shockstar Disco',
    artifacts_1_2: 'Polar Metal',
    artifacts_1_3: '',
    artifacts_1_app: 34.81,
    artifacts_1_round_sd: 131,
    artifacts_1_round_da: 20221,
    artifacts_2: 'Shockstar Disco, Swing Jazz',
    artifacts_2_1: 'Shockstar Disco',
    artifacts_2_2: 'Swing Jazz',
    artifacts_2_3: '',
    artifacts_2_app: 33.95,
    artifacts_2_round_sd: 132,
    artifacts_2_round_da: 22340,
    artifacts_3: 'Shockstar Disco, Woodpecker Electro',
    artifacts_3_1: 'Shockstar Disco',
    artifacts_3_2: 'Woodpecker Electro',
    artifacts_3_3: '',
    artifacts_3_app: 4.77,
    artifacts_3_round_sd: 138,
    artifacts_3_round_da: 22156,
    artifacts_4: 'Astral Voice, Shockstar Disco',
    artifacts_4_1: 'Astral Voice',
    artifacts_4_2: 'Shockstar Disco',
    artifacts_4_3: '',
    artifacts_4_app: 3.86,
    artifacts_4_round_sd: 99,
    artifacts_4_round_da: 31552,
    artifacts_5: 'Swing Jazz, Shockstar Disco',
    artifacts_5_1: 'Swing Jazz',
    artifacts_5_2: 'Shockstar Disco',
    artifacts_5_3: '',
    artifacts_5_app: 2.47,
    artifacts_5_round_sd: 105,
    artifacts_5_round_da: 26414,
    artifacts_6: 'Astral Voice, Swing Jazz',
    artifacts_6_1: 'Astral Voice',
    artifacts_6_2: 'Swing Jazz',
    artifacts_6_3: '',
    artifacts_6_app: 2.08,
    artifacts_6_round_sd: 94,
    artifacts_6_round_da: 34058,
    artifacts_7: 'Freedom Blues, Shockstar Disco',
    artifacts_7_1: 'Freedom Blues',
    artifacts_7_2: 'Shockstar Disco',
    artifacts_7_3: '',
    artifacts_7_app: 1.65,
    artifacts_7_round_sd: 99,
    artifacts_7_round_da: 23327,
    artifacts_8: 'Shockstar Disco, Flex',
    artifacts_8_1: 'Shockstar Disco',
    artifacts_8_2: 'Flex',
    artifacts_8_3: '',
    artifacts_8_app: 1.64,
    artifacts_8_round_sd: 131,
    artifacts_8_round_da: 21401,
    artifacts_9: 'Proto Punk, Shockstar Disco',
    artifacts_9_1: 'Proto Punk',
    artifacts_9_2: 'Shockstar Disco',
    artifacts_9_3: '',
    artifacts_9_app: 1.4,
    artifacts_9_round_sd: 600,
    artifacts_9_round_da: 25129,
    artifacts_10: 'Shockstar Disco, Branch & Blade Song',
    artifacts_10_1: 'Shockstar Disco',
    artifacts_10_2: 'Branch & Blade Song',
    artifacts_10_3: '',
    artifacts_10_app: 0.27,
    artifacts_10_round_sd: 106,
    artifacts_10_round_da: 0,
    drive_slot_4_1: 'CRIT Rate',
    drive_slot_4_1_app: 63.11,
    drive_slot_4_2: 'CRIT DMG',
    drive_slot_4_2_app: 16.61,
    drive_slot_4_3: 'Percent ATK',
    drive_slot_4_3_app: 10.41,
    drive_slot_5_1: 'Ice DMG Bonus',
    drive_slot_5_1_app: 68.32,
    drive_slot_5_2: 'Percent ATK',
    drive_slot_5_2_app: 18.7,
    drive_slot_5_3: 'PEN Ratio',
    drive_slot_5_3_app: 6.74,
    drive_slot_6_1: 'Impact',
    drive_slot_6_1_app: 91.97,
    drive_slot_6_2: 'Percent ATK',
    drive_slot_6_2_app: 2.85,
    drive_slot_6_3: 'Anomaly Mastery',
    drive_slot_6_3_app: 2.09,
    char_level: 59.85,
    w_engine_level: 57.12,
    basic_atk: 10.78,
    special_atk: 10.91,
    dash: 8.39,
    ultimate: 9.79,
    core_skill: 6.82,
    assist: 8.95,
    base_hp: 12096.25,
    base_atk: 2055.96,
    base_def: 964.17,
    base_impact: 184.26,
    crit_rate: 37.83,
    crit_dmg: 95.7,
    anomaly_mastery: 91.85,
    anomaly_proficiency: 133.63,
    pen_ratio: 1.63,
    pen: 39.79,
    base_energy_regen: 142.88,
    dmg_bonus: 23.61,
    percent_hp_sub: 12.92,
    percent_atk_sub: 15.88,
    percent_def_sub: 19.62,
    crit_rate_sub: 17.04,
    crit_dmg_sub: 37.05,
    pen_sub: 39.79,
    anomaly_proficiency_sub: 37.97
  },
  {
    char: 'anton',
    app_rate_sd: 0.25,
    app_rate_sd_e1: 0.02,
    app_rate_sd_s0: 0.17,
    avg_round_sd: 600,
    avg_round_sd_e1: 600,
    avg_round_sd_s0: 600,
    sample_sd: 12,
    sample_size_players_sd: 6,
    app_rate_da: 0.51,
    app_rate_da_e1: 0.1,
    app_rate_da_s0: 0.32,
    avg_round_da: 23071,
    avg_round_da_e1: 0,
    avg_round_da_s0: 0,
    app_rate_da_boss_1: 0.04,
    avg_round_da_boss_1: 0,
    app_rate_da_boss_2: 0,
    avg_round_da_boss_2: 0,
    app_rate_da_boss_3: 0.52,
    avg_round_da_boss_3: 23157,
    sample_da: 30,
    sample_size_players_da: 14,
    app_0: 1,
    round_0_sd: 600,
    round_0_da: 0,
    app_1: 1,
    round_1_sd: 600,
    round_1_da: 0,
    app_2: 1,
    round_2_sd: 600,
    round_2_da: 0,
    app_3: 4.97,
    round_3_sd: 155,
    round_3_da: 8065,
    app_4: 1,
    round_4_sd: 600,
    round_4_da: 0,
    app_5: 1,
    round_5_sd: 600,
    round_5_da: 0,
    app_6: 95.03,
    round_6_sd: 157,
    round_6_da: 23724,
    cons_avg: 5.85,
    weapons_1: 'The Brimstone',
    weapons_1_app: 24.38,
    weapons_1_round_sd: 157,
    weapons_1_round_da: 22178,
    weapons_2: 'Starlight Engine',
    weapons_2_app: 20.64,
    weapons_2_round_sd: 155,
    weapons_2_round_da: 22986,
    weapons_3: 'Street Superstar',
    weapons_3_app: 17.17,
    weapons_3_round_sd: 198,
    weapons_3_round_da: 22350,
    weapons_4: 'Drill Rig - Red Axis',
    weapons_4_app: 16.16,
    weapons_4_round_sd: 207,
    weapons_4_round_da: 15071,
    weapons_5: 'Heartstring Nocturne',
    weapons_5_app: 4.97,
    weapons_5_round_sd: 102,
    weapons_5_round_da: 47759,
    weapons_6: 'Marcato Desire',
    weapons_6_app: 4.97,
    weapons_6_round_sd: 166,
    weapons_6_round_da: 16161,
    weapons_7: 'Severed Innocence',
    weapons_7_app: 4.97,
    weapons_7_round_sd: 65,
    weapons_7_round_da: 43648,
    weapons_8: 'Cannon Rotor',
    weapons_8_app: 4.48,
    weapons_8_round_sd: 600,
    weapons_8_round_da: 26255,
    weapons_9: 'Zanshin Herb Case',
    weapons_9_app: 2.23,
    weapons_9_round_sd: 600,
    weapons_9_round_da: 20930,
    weapons_10: '',
    weapons_10_app: 0,
    weapons_10_round_sd: 600,
    weapons_10_round_da: 0,
    artifacts_1: 'Thunder Metal, Woodpecker Electro',
    artifacts_1_1: 'Thunder Metal',
    artifacts_1_2: 'Woodpecker Electro',
    artifacts_1_3: '',
    artifacts_1_app: 54.98,
    artifacts_1_round_sd: 155,
    artifacts_1_round_da: 21724,
    artifacts_2: 'Branch & Blade Song, Thunder Metal, Woodpecker Electro',
    artifacts_2_1: 'Branch & Blade Song',
    artifacts_2_2: 'Thunder Metal',
    artifacts_2_3: 'Woodpecker Electro',
    artifacts_2_app: 9.45,
    artifacts_2_round_sd: 156,
    artifacts_2_round_da: 21029,
    artifacts_3: 'Hormone Punk, Astral Voice',
    artifacts_3_1: 'Hormone Punk',
    artifacts_3_2: 'Astral Voice',
    artifacts_3_3: '',
    artifacts_3_app: 4.97,
    artifacts_3_round_sd: 102,
    artifacts_3_round_da: 47759,
    artifacts_4: 'Thunder Metal, Hormone Punk',
    artifacts_4_1: 'Thunder Metal',
    artifacts_4_2: 'Hormone Punk',
    artifacts_4_3: '',
    artifacts_4_app: 4.97,
    artifacts_4_round_sd: 166,
    artifacts_4_round_da: 0,
    artifacts_5: 'Woodpecker Electro, Branch & Blade Song',
    artifacts_5_1: 'Woodpecker Electro',
    artifacts_5_2: 'Branch & Blade Song',
    artifacts_5_3: '',
    artifacts_5_app: 4.48,
    artifacts_5_round_sd: 600,
    artifacts_5_round_da: 26255,
    artifacts_6: 'Thunder Metal, Branch & Blade Song',
    artifacts_6_1: 'Thunder Metal',
    artifacts_6_2: 'Branch & Blade Song',
    artifacts_6_3: '',
    artifacts_6_app: 4.48,
    artifacts_6_round_sd: 600,
    artifacts_6_round_da: 21307,
    artifacts_7: 'Hormone Punk, Thunder Metal',
    artifacts_7_1: 'Hormone Punk',
    artifacts_7_2: 'Thunder Metal',
    artifacts_7_3: '',
    artifacts_7_app: 4.48,
    artifacts_7_round_sd: 600,
    artifacts_7_round_da: 20515,
    artifacts_8: 'Woodpecker Electro, Thunder Metal',
    artifacts_8_1: 'Woodpecker Electro',
    artifacts_8_2: 'Thunder Metal',
    artifacts_8_3: '',
    artifacts_8_app: 2.74,
    artifacts_8_round_sd: 214,
    artifacts_8_round_da: 0,
    artifacts_9: 'Thunder Metal, Flex',
    artifacts_9_1: 'Thunder Metal',
    artifacts_9_2: 'Flex',
    artifacts_9_3: '',
    artifacts_9_app: 2.23,
    artifacts_9_round_sd: 600,
    artifacts_9_round_da: 24331,
    artifacts_10: 'Chaos Jazz, Branch & Blade Song',
    artifacts_10_1: 'Chaos Jazz',
    artifacts_10_2: 'Branch & Blade Song',
    artifacts_10_3: '',
    artifacts_10_app: 2.23,
    artifacts_10_round_sd: 600,
    artifacts_10_round_da: 25105,
    drive_slot_4_1: 'CRIT DMG',
    drive_slot_4_1_app: 50,
    drive_slot_4_2: 'CRIT Rate',
    drive_slot_4_2_app: 29.44,
    drive_slot_4_3: 'Percent ATK',
    drive_slot_4_3_app: 9.59,
    drive_slot_5_1: 'Electric DMG Bonus',
    drive_slot_5_1_app: 60.27,
    drive_slot_5_2: 'PEN Ratio',
    drive_slot_5_2_app: 30.13,
    drive_slot_5_3: 'Percent ATK',
    drive_slot_5_3_app: 9.59,
    drive_slot_6_1: 'Percent ATK',
    drive_slot_6_1_app: 94.52,
    drive_slot_6_2: '',
    drive_slot_6_2_app: 5.48,
    drive_slot_6_3: '',
    drive_slot_6_3_app: 0,
    char_level: 60,
    w_engine_level: 60,
    basic_atk: 10.86,
    special_atk: 8.37,
    dash: 9.91,
    ultimate: 11.47,
    core_skill: 6.91,
    assist: 11,
    base_hp: 9983,
    base_atk: 2823.68,
    base_def: 910.33,
    base_impact: 95,
    crit_rate: 64.34,
    crit_dmg: 141.74,
    anomaly_mastery: 86,
    anomaly_proficiency: 114.24,
    pen_ratio: 7.23,
    pen: 26.94,
    base_energy_regen: 125.75,
    dmg_bonus: 24.59,
    percent_hp_sub: 6.25,
    percent_atk_sub: 18.49,
    percent_def_sub: 13.51,
    crit_rate_sub: 27.52,
    crit_dmg_sub: 58.98,
    pen_sub: 26.94,
    anomaly_proficiency_sub: 22.81
  },
  {
    char: 'soldier-11',
    app_rate_sd: 1.16,
    app_rate_sd_e1: 0.48,
    app_rate_sd_s0: 0.31,
    avg_round_sd: 177,
    avg_round_sd_e1: 139,
    avg_round_sd_s0: 600,
    sample_sd: 56,
    sample_size_players_sd: 39,
    app_rate_da: 2.94,
    app_rate_da_e1: 0.75,
    app_rate_da_s0: 1.25,
    avg_round_da: 20329,
    avg_round_da_e1: 27541,
    avg_round_da_s0: 17404,
    app_rate_da_boss_1: 2.12,
    avg_round_da_boss_1: 21697,
    app_rate_da_boss_2: 0.21,
    avg_round_da_boss_2: 0,
    app_rate_da_boss_3: 0.81,
    avg_round_da_boss_3: 18417,
    sample_da: 172,
    sample_size_players_da: 67,
    app_0: 30.96,
    round_0_sd: 185,
    round_0_da: 18720,
    app_1: 27.97,
    round_1_sd: 187,
    round_1_da: 16870,
    app_2: 22.92,
    round_2_sd: 168,
    round_2_da: 24422,
    app_3: 13.19,
    round_3_sd: 158,
    round_3_da: 26240,
    app_4: 4.03,
    round_4_sd: 116,
    round_4_da: 28236,
    app_5: 0.92,
    round_5_sd: 221,
    round_5_da: 18214,
    app_6: 1,
    round_6_sd: 600,
    round_6_da: 0,
    cons_avg: 1.34,
    weapons_1: 'The Brimstone',
    weapons_1_app: 49.37,
    weapons_1_round_sd: 179,
    weapons_1_round_da: 20107,
    weapons_2: 'Marcato Desire',
    weapons_2_app: 14.28,
    weapons_2_round_sd: 166,
    weapons_2_round_da: 24307,
    weapons_3: 'Heartstring Nocturne',
    weapons_3_app: 12.1,
    weapons_3_round_sd: 169,
    weapons_3_round_da: 23416,
    weapons_4: 'Starlight Engine',
    weapons_4_app: 11.84,
    weapons_4_round_sd: 198,
    weapons_4_round_da: 19330,
    weapons_5: 'Gilded Blossom',
    weapons_5_app: 3.36,
    weapons_5_round_sd: 600,
    weapons_5_round_da: 11993,
    weapons_6: 'Cannon Rotor',
    weapons_6_app: 2.6,
    weapons_6_round_sd: 600,
    weapons_6_round_da: 19202,
    weapons_7: 'Steel Cushion',
    weapons_7_app: 1.76,
    weapons_7_round_sd: 177,
    weapons_7_round_da: 16225,
    weapons_8: 'Street Superstar',
    weapons_8_app: 0.84,
    weapons_8_round_sd: 600,
    weapons_8_round_da: 9209,
    weapons_9: 'Housekeeper',
    weapons_9_app: 0.84,
    weapons_9_round_sd: 600,
    weapons_9_round_da: 21772,
    weapons_10: 'Riot Suppressor Mark VI',
    weapons_10_app: 0.51,
    weapons_10_round_sd: 116,
    weapons_10_round_da: 0,
    artifacts_1: 'Inferno Metal, Woodpecker Electro',
    artifacts_1_1: 'Inferno Metal',
    artifacts_1_2: 'Woodpecker Electro',
    artifacts_1_3: '',
    artifacts_1_app: 53.91,
    artifacts_1_round_sd: 188,
    artifacts_1_round_da: 18487,
    artifacts_2: 'Inferno Metal, Branch & Blade Song',
    artifacts_2_1: 'Inferno Metal',
    artifacts_2_2: 'Branch & Blade Song',
    artifacts_2_3: '',
    artifacts_2_app: 11.66,
    artifacts_2_round_sd: 157,
    artifacts_2_round_da: 24103,
    artifacts_3: 'Inferno Metal, Puffer Electro',
    artifacts_3_1: 'Inferno Metal',
    artifacts_3_2: 'Puffer Electro',
    artifacts_3_3: '',
    artifacts_3_app: 10.33,
    artifacts_3_round_sd: 124,
    artifacts_3_round_da: 22841,
    artifacts_4: 'Woodpecker Electro, Branch & Blade Song',
    artifacts_4_1: 'Woodpecker Electro',
    artifacts_4_2: 'Branch & Blade Song',
    artifacts_4_3: '',
    artifacts_4_app: 5.38,
    artifacts_4_round_sd: 150,
    artifacts_4_round_da: 23854,
    artifacts_5: 'Branch & Blade Song, Inferno Metal, Woodpecker Electro',
    artifacts_5_1: 'Branch & Blade Song',
    artifacts_5_2: 'Inferno Metal',
    artifacts_5_3: 'Woodpecker Electro',
    artifacts_5_app: 2.09,
    artifacts_5_round_sd: 600,
    artifacts_5_round_da: 22782,
    artifacts_6: 'Inferno Metal, Astral Voice',
    artifacts_6_1: 'Inferno Metal',
    artifacts_6_2: 'Astral Voice',
    artifacts_6_3: '',
    artifacts_6_app: 1.76,
    artifacts_6_round_sd: 127,
    artifacts_6_round_da: 24234,
    artifacts_7: 'Inferno Metal, Flex',
    artifacts_7_1: 'Inferno Metal',
    artifacts_7_2: 'Flex',
    artifacts_7_3: '',
    artifacts_7_app: 1.76,
    artifacts_7_round_sd: 192,
    artifacts_7_round_da: 15463,
    artifacts_8: 'Inferno Metal, Hormone Punk',
    artifacts_8_1: 'Inferno Metal',
    artifacts_8_2: 'Hormone Punk',
    artifacts_8_3: '',
    artifacts_8_app: 1.68,
    artifacts_8_round_sd: 600,
    artifacts_8_round_da: 19571,
    artifacts_9: 'Woodpecker Electro, Inferno Metal',
    artifacts_9_1: 'Woodpecker Electro',
    artifacts_9_2: 'Inferno Metal',
    artifacts_9_3: '',
    artifacts_9_app: 1.68,
    artifacts_9_round_sd: 600,
    artifacts_9_round_da: 17328,
    artifacts_10: 'ATK +10%, Branch & Blade Song, Woodpecker Electro',
    artifacts_10_1: 'ATK +10%',
    artifacts_10_2: 'Branch & Blade Song',
    artifacts_10_3: 'Woodpecker Electro',
    artifacts_10_app: 0.51,
    artifacts_10_round_sd: 600,
    artifacts_10_round_da: 0,
    drive_slot_4_1: 'CRIT DMG',
    drive_slot_4_1_app: 77.07,
    drive_slot_4_2: 'CRIT Rate',
    drive_slot_4_2_app: 20.07,
    drive_slot_4_3: 'Percent ATK',
    drive_slot_4_3_app: 2.86,
    drive_slot_5_1: 'Fire DMG Bonus',
    drive_slot_5_1_app: 63.43,
    drive_slot_5_2: 'PEN Ratio',
    drive_slot_5_2_app: 22.59,
    drive_slot_5_3: 'Percent ATK',
    drive_slot_5_3_app: 13.98,
    drive_slot_6_1: 'Percent ATK',
    drive_slot_6_1_app: 98.93,
    drive_slot_6_2: 'Impact',
    drive_slot_6_2_app: 1.07,
    drive_slot_6_3: '',
    drive_slot_6_3_app: 0,
    char_level: 60,
    w_engine_level: 59.46,
    basic_atk: 11.78,
    special_atk: 11.43,
    dash: 10.6,
    ultimate: 11.63,
    core_skill: 7,
    assist: 10.25,
    base_hp: 10762.27,
    base_atk: 3026.35,
    base_def: 911.85,
    base_impact: 93.17,
    crit_rate: 64.74,
    crit_dmg: 149,
    anomaly_mastery: 94,
    anomaly_proficiency: 125.89,
    pen_ratio: 7.08,
    pen: 31.24,
    base_energy_regen: 120,
    dmg_bonus: 27.6,
    percent_hp_sub: 8.11,
    percent_atk_sub: 16.92,
    percent_def_sub: 12.85,
    crit_rate_sub: 27.94,
    crit_dmg_sub: 55.82,
    pen_sub: 31.24,
    anomaly_proficiency_sub: 32.89
  },
  {
    char: 'ben',
    app_rate_sd: 0.21,
    app_rate_sd_e1: 0.02,
    app_rate_sd_s0: 0.04,
    avg_round_sd: 600,
    avg_round_sd_e1: 600,
    avg_round_sd_s0: 600,
    sample_sd: 10,
    sample_size_players_sd: 7,
    app_rate_da: 0.34,
    app_rate_da_e1: 0.07,
    app_rate_da_s0: 0.14,
    avg_round_da: 19696,
    avg_round_da_e1: 0,
    avg_round_da_s0: 0,
    app_rate_da_boss_1: 0.25,
    avg_round_da_boss_1: 0,
    app_rate_da_boss_2: 0.02,
    avg_round_da_boss_2: 0,
    app_rate_da_boss_3: 0.09,
    avg_round_da_boss_3: 0,
    sample_da: 20,
    sample_size_players_da: 9,
    app_0: 1,
    round_0_sd: 600,
    round_0_da: 0,
    app_1: 6.91,
    round_1_sd: 233,
    round_1_da: 15181,
    app_2: 1,
    round_2_sd: 600,
    round_2_da: 0,
    app_3: 1,
    round_3_sd: 600,
    round_3_da: 0,
    app_4: 1,
    round_4_sd: 600,
    round_4_da: 0,
    app_5: 1,
    round_5_sd: 600,
    round_5_da: 0,
    app_6: 93.09,
    round_6_sd: 137,
    round_6_da: 19997,
    cons_avg: 5.65,
    weapons_1: 'Big Cylinder',
    weapons_1_app: 57.81,
    weapons_1_round_sd: 149,
    weapons_1_round_da: 18401,
    weapons_2: 'Bunny Band',
    weapons_2_app: 14.54,
    weapons_2_round_sd: 170,
    weapons_2_round_da: 22310,
    weapons_3: 'Zanshin Herb Case',
    weapons_3_app: 10.73,
    weapons_3_round_sd: 132,
    weapons_3_round_da: 25142,
    weapons_4: 'Tusks of Fury',
    weapons_4_app: 6.91,
    weapons_4_round_sd: 110,
    weapons_4_round_da: 25088,
    weapons_5: 'Hailstorm Shrine',
    weapons_5_app: 6.91,
    weapons_5_round_sd: 600,
    weapons_5_round_da: 0,
    weapons_6: 'Steel Cushion',
    weapons_6_app: 3.09,
    weapons_6_round_sd: 600,
    weapons_6_round_da: 21784,
    weapons_7: '',
    weapons_7_app: 0,
    weapons_7_round_sd: 600,
    weapons_7_round_da: 0,
    weapons_8: '',
    weapons_8_app: 0,
    weapons_8_round_sd: 600,
    weapons_8_round_da: 0,
    weapons_9: '',
    weapons_9_app: 0,
    weapons_9_round_sd: 600,
    weapons_9_round_da: 0,
    weapons_10: '',
    weapons_10_app: 0,
    weapons_10_round_sd: 600,
    weapons_10_round_da: 0,
    artifacts_1: 'Woodpecker Electro, Puffer Electro',
    artifacts_1_1: 'Woodpecker Electro',
    artifacts_1_2: 'Puffer Electro',
    artifacts_1_3: '',
    artifacts_1_app: 20.72,
    artifacts_1_round_sd: 161,
    artifacts_1_round_da: 26773,
    artifacts_2: 'Proto Punk, Swing Jazz',
    artifacts_2_1: 'Proto Punk',
    artifacts_2_2: 'Swing Jazz',
    artifacts_2_3: '',
    artifacts_2_app: 16.18,
    artifacts_2_round_sd: 233,
    artifacts_2_round_da: 18180,
    artifacts_3: 'Woodpecker Electro, Branch & Blade Song',
    artifacts_3_1: 'Woodpecker Electro',
    artifacts_3_2: 'Branch & Blade Song',
    artifacts_3_3: '',
    artifacts_3_app: 10,
    artifacts_3_round_sd: 136,
    artifacts_3_round_da: 25115,
    artifacts_4: 'Swing Jazz, Soul Rock',
    artifacts_4_1: 'Swing Jazz',
    artifacts_4_2: 'Soul Rock',
    artifacts_4_3: '',
    artifacts_4_app: 9.27,
    artifacts_4_round_sd: 600,
    artifacts_4_round_da: 15920,
    artifacts_5: 'Inferno Metal, Woodpecker Electro',
    artifacts_5_1: 'Inferno Metal',
    artifacts_5_2: 'Woodpecker Electro',
    artifacts_5_3: '',
    artifacts_5_app: 6.91,
    artifacts_5_round_sd: 177,
    artifacts_5_round_da: 0,
    artifacts_6: 'Inferno Metal, Branch & Blade Song',
    artifacts_6_1: 'Inferno Metal',
    artifacts_6_2: 'Branch & Blade Song',
    artifacts_6_3: '',
    artifacts_6_app: 6.18,
    artifacts_6_round_sd: 600,
    artifacts_6_round_da: 21444,
    artifacts_7: 'Woodpecker Electro, Inferno Metal',
    artifacts_7_1: 'Woodpecker Electro',
    artifacts_7_2: 'Inferno Metal',
    artifacts_7_3: '',
    artifacts_7_app: 3.82,
    artifacts_7_round_sd: 128,
    artifacts_7_round_da: 0,
    artifacts_8: 'Shockstar Disco, Soul Rock',
    artifacts_8_1: 'Shockstar Disco',
    artifacts_8_2: 'Soul Rock',
    artifacts_8_3: '',
    artifacts_8_app: 3.82,
    artifacts_8_round_sd: 110,
    artifacts_8_round_da: 0,
    artifacts_9: 'Swing Jazz, Inferno Metal',
    artifacts_9_1: 'Swing Jazz',
    artifacts_9_2: 'Inferno Metal',
    artifacts_9_3: '',
    artifacts_9_app: 3.82,
    artifacts_9_round_sd: 180,
    artifacts_9_round_da: 0,
    artifacts_10: 'Inferno Metal, Soul Rock, Flex',
    artifacts_10_1: 'Inferno Metal',
    artifacts_10_2: 'Soul Rock',
    artifacts_10_3: 'Flex',
    artifacts_10_app: 3.82,
    artifacts_10_round_sd: 45,
    artifacts_10_round_da: 0,
    drive_slot_4_1: 'CRIT DMG',
    drive_slot_4_1_app: 57.57,
    drive_slot_4_2: 'CRIT Rate',
    drive_slot_4_2_app: 24.65,
    drive_slot_4_3: 'Percent DEF',
    drive_slot_4_3_app: 17.78,
    drive_slot_5_1: 'Fire DMG Bonus',
    drive_slot_5_1_app: 43.83,
    drive_slot_5_2: 'PEN Ratio',
    drive_slot_5_2_app: 38.38,
    drive_slot_5_3: 'Percent DEF',
    drive_slot_5_3_app: 17.78,
    drive_slot_6_1: 'Percent ATK',
    drive_slot_6_1_app: 49.29,
    drive_slot_6_2: 'Percent DEF',
    drive_slot_6_2_app: 31.51,
    drive_slot_6_3: 'Energy Regen',
    drive_slot_6_3_app: 13.74,
    char_level: 60,
    w_engine_level: 60,
    basic_atk: 11.69,
    special_atk: 11.81,
    dash: 11.49,
    ultimate: 11.81,
    core_skill: 7,
    assist: 11.71,
    base_hp: 12788,
    base_atk: 2045.35,
    base_def: 1611.22,
    base_impact: 98.64,
    crit_rate: 48.26,
    crit_dmg: 148.73,
    anomaly_mastery: 86,
    anomaly_proficiency: 114.16,
    pen_ratio: 11.73,
    pen: 19,
    base_energy_regen: 172.6,
    dmg_bonus: 15.62,
    percent_hp_sub: 5.88,
    percent_atk_sub: 13.62,
    percent_def_sub: 33.06,
    crit_rate_sub: 28.57,
    crit_dmg_sub: 58.39,
    pen_sub: 19,
    anomaly_proficiency_sub: 24.16
  },
  {
    char: 'rina',
    app_rate_sd: 21.12,
    app_rate_sd_e1: 5.99,
    app_rate_sd_s0: 4.1,
    avg_round_sd: 145,
    avg_round_sd_e1: 111,
    avg_round_sd_s0: 166,
    sample_sd: 1016,
    sample_size_players_sd: 136,
    app_rate_da: 31.7,
    app_rate_da_e1: 8.78,
    app_rate_da_s0: 6.8,
    avg_round_da: 23554,
    avg_round_da_e1: 32411,
    avg_round_da_s0: 19683,
    app_rate_da_boss_1: 2.84,
    avg_round_da_boss_1: 22425,
    app_rate_da_boss_2: 12.35,
    avg_round_da_boss_2: 25114,
    app_rate_da_boss_3: 19.6,
    avg_round_da_boss_3: 22932,
    sample_da: 1855,
    sample_size_players_da: 184,
    app_0: 27.14,
    round_0_sd: 157,
    round_0_da: 21283,
    app_1: 43.04,
    round_1_sd: 139,
    round_1_da: 24266,
    app_2: 19.25,
    round_2_sd: 146,
    round_2_da: 24587,
    app_3: 7.21,
    round_3_sd: 138,
    round_3_da: 26356,
    app_4: 2.33,
    round_4_sd: 161,
    round_4_da: 27536,
    app_5: 0.45,
    round_5_sd: 88,
    round_5_da: 25428,
    app_6: 0.59,
    round_6_sd: 600,
    round_6_da: 20369,
    cons_avg: 1.18,
    weapons_1: 'Weeping Cradle',
    weapons_1_app: 56.54,
    weapons_1_round_sd: 142,
    weapons_1_round_da: 24486,
    weapons_2: 'Slice of Time',
    weapons_2_app: 36.92,
    weapons_2_round_sd: 149,
    weapons_2_round_da: 22621,
    weapons_3: 'Kaboom the Cannon',
    weapons_3_app: 4.29,
    weapons_3_round_sd: 156,
    weapons_3_round_da: 22904,
    weapons_4: 'Unfettered Game Ball',
    weapons_4_app: 0.66,
    weapons_4_round_sd: 155,
    weapons_4_round_da: 19216,
    weapons_5: '[Reverb] Mark II',
    weapons_5_app: 0.43,
    weapons_5_round_sd: 150,
    weapons_5_round_da: 19282,
    weapons_6: 'Bashful Demon',
    weapons_6_app: 0.24,
    weapons_6_round_sd: 151,
    weapons_6_round_da: 25756,
    weapons_7: 'Fusion Compiler',
    weapons_7_app: 0.17,
    weapons_7_round_sd: 600,
    weapons_7_round_da: 20104,
    weapons_8: '[Reverb] Mark I',
    weapons_8_app: 0.1,
    weapons_8_round_sd: 600,
    weapons_8_round_da: 20513,
    weapons_9: '[Reverb] Mark III',
    weapons_9_app: 0.07,
    weapons_9_round_sd: 600,
    weapons_9_round_da: 21892,
    weapons_10: 'The Vault',
    weapons_10_app: 0.04,
    weapons_10_round_sd: 145,
    weapons_10_round_da: 0,
    artifacts_1: 'Swing Jazz, Puffer Electro',
    artifacts_1_1: 'Swing Jazz',
    artifacts_1_2: 'Puffer Electro',
    artifacts_1_3: '',
    artifacts_1_app: 49.35,
    artifacts_1_round_sd: 150,
    artifacts_1_round_da: 23521,
    artifacts_2: 'Astral Voice, Puffer Electro',
    artifacts_2_1: 'Astral Voice',
    artifacts_2_2: 'Puffer Electro',
    artifacts_2_3: '',
    artifacts_2_app: 12.86,
    artifacts_2_round_sd: 136,
    artifacts_2_round_da: 26122,
    artifacts_3: 'Freedom Blues, Puffer Electro',
    artifacts_3_1: 'Freedom Blues',
    artifacts_3_2: 'Puffer Electro',
    artifacts_3_3: '',
    artifacts_3_app: 11.85,
    artifacts_3_round_sd: 132,
    artifacts_3_round_da: 24465,
    artifacts_4: 'Astral Voice, Swing Jazz',
    artifacts_4_1: 'Astral Voice',
    artifacts_4_2: 'Swing Jazz',
    artifacts_4_3: '',
    artifacts_4_app: 10.8,
    artifacts_4_round_sd: 149,
    artifacts_4_round_da: 22553,
    artifacts_5: 'Freedom Blues, Swing Jazz',
    artifacts_5_1: 'Freedom Blues',
    artifacts_5_2: 'Swing Jazz',
    artifacts_5_3: '',
    artifacts_5_app: 2.34,
    artifacts_5_round_sd: 142,
    artifacts_5_round_da: 21294,
    artifacts_6: 'Swing Jazz, Freedom Blues',
    artifacts_6_1: 'Swing Jazz',
    artifacts_6_2: 'Freedom Blues',
    artifacts_6_3: '',
    artifacts_6_app: 1.7,
    artifacts_6_round_sd: 154,
    artifacts_6_round_da: 23621,
    artifacts_7: 'Puffer Electro, Swing Jazz, Flex',
    artifacts_7_1: 'Puffer Electro',
    artifacts_7_2: 'Swing Jazz',
    artifacts_7_3: 'Flex',
    artifacts_7_app: 1.09,
    artifacts_7_round_sd: 134,
    artifacts_7_round_da: 21616,
    artifacts_8: 'Puffer Electro, Swing Jazz',
    artifacts_8_1: 'Puffer Electro',
    artifacts_8_2: 'Swing Jazz',
    artifacts_8_3: '',
    artifacts_8_app: 0.98,
    artifacts_8_round_sd: 174,
    artifacts_8_round_da: 21991,
    artifacts_9: 'Freedom Blues, Thunder Metal',
    artifacts_9_1: 'Freedom Blues',
    artifacts_9_2: 'Thunder Metal',
    artifacts_9_3: '',
    artifacts_9_app: 0.29,
    artifacts_9_round_sd: 600,
    artifacts_9_round_da: 21697,
    artifacts_10: 'AP +30, Puffer Electro, Flex',
    artifacts_10_1: 'AP +30',
    artifacts_10_2: 'Puffer Electro',
    artifacts_10_3: 'Flex',
    artifacts_10_app: 0.24,
    artifacts_10_round_sd: 94,
    artifacts_10_round_da: 0,
    drive_slot_4_1: 'Anomaly Proficiency',
    drive_slot_4_1_app: 63.12,
    drive_slot_4_2: 'Percent ATK',
    drive_slot_4_2_app: 16.64,
    drive_slot_4_3: 'CRIT Rate',
    drive_slot_4_3_app: 16.19,
    drive_slot_5_1: 'PEN Ratio',
    drive_slot_5_1_app: 97.46,
    drive_slot_5_2: 'Percent ATK',
    drive_slot_5_2_app: 1.24,
    drive_slot_5_3: 'Electric DMG Bonus',
    drive_slot_5_3_app: 0.65,
    drive_slot_6_1: 'Energy Regen',
    drive_slot_6_1_app: 75.85,
    drive_slot_6_2: 'Anomaly Mastery',
    drive_slot_6_2_app: 12.86,
    drive_slot_6_3: 'Percent ATK',
    drive_slot_6_3_app: 10.31,
    char_level: 59.68,
    w_engine_level: 57.81,
    basic_atk: 5.77,
    special_atk: 10.17,
    dash: 5.37,
    ultimate: 9.27,
    core_skill: 6.75,
    assist: 7.19,
    base_hp: 12234.33,
    base_atk: 2080.72,
    base_def: 956.37,
    base_impact: 83,
    crit_rate: 22.13,
    crit_dmg: 76.77,
    anomaly_mastery: 96.08,
    anomaly_proficiency: 203.78,
    pen_ratio: 50.66,
    pen: 50.64,
    base_energy_regen: 193.61,
    dmg_bonus: 0.34,
    percent_hp_sub: 13.52,
    percent_atk_sub: 16.65,
    percent_def_sub: 20.87,
    crit_rate_sub: 13.28,
    crit_dmg_sub: 25.56,
    pen_sub: 50.64,
    anomaly_proficiency_sub: 48.81
  },
  {
    char: 'lucy',
    app_rate_sd: 18.69,
    app_rate_sd_e1: 5.86,
    app_rate_sd_s0: 2.64,
    avg_round_sd: 137,
    avg_round_sd_e1: 101,
    avg_round_sd_s0: 170,
    sample_sd: 899,
    sample_size_players_sd: 120,
    app_rate_da: 39.82,
    app_rate_da_e1: 11.47,
    app_rate_da_s0: 6.89,
    avg_round_da: 25511,
    avg_round_da_e1: 34544,
    avg_round_da_s0: 20797,
    app_rate_da_boss_1: 11.1,
    avg_round_da_boss_1: 24800,
    app_rate_da_boss_2: 25.83,
    avg_round_da_boss_2: 26963,
    app_rate_da_boss_3: 7.14,
    avg_round_da_boss_3: 22632,
    sample_da: 2330,
    sample_size_players_da: 215,
    app_0: 0.04,
    round_0_sd: 600,
    round_0_da: 14064,
    app_1: 0.5,
    round_1_sd: 252,
    round_1_da: 14205,
    app_2: 1.11,
    round_2_sd: 159,
    round_2_da: 21063,
    app_3: 1.49,
    round_3_sd: 183,
    round_3_da: 22761,
    app_4: 2.09,
    round_4_sd: 210,
    round_4_da: 19688,
    app_5: 3.21,
    round_5_sd: 143,
    round_5_da: 20970,
    app_6: 91.56,
    round_6_sd: 133,
    round_6_da: 26050,
    cons_avg: 5.81,
    weapons_1: 'Kaboom the Cannon',
    weapons_1_app: 88.55,
    weapons_1_round_sd: 137,
    weapons_1_round_da: 25566,
    weapons_2: 'Slice of Time',
    weapons_2_app: 3,
    weapons_2_round_sd: 154,
    weapons_2_round_da: 23222,
    weapons_3: 'Bashful Demon',
    weapons_3_app: 1.76,
    weapons_3_round_sd: 139,
    weapons_3_round_da: 30498,
    weapons_4: 'Weeping Cradle',
    weapons_4_app: 1.71,
    weapons_4_round_sd: 151,
    weapons_4_round_da: 24708,
    weapons_5: '[Reverb] Mark II',
    weapons_5_app: 1.18,
    weapons_5_round_sd: 143,
    weapons_5_round_da: 22501,
    weapons_6: 'The Vault',
    weapons_6_app: 0.82,
    weapons_6_round_sd: 122,
    weapons_6_round_da: 26121,
    weapons_7: 'Unfettered Game Ball',
    weapons_7_app: 0.71,
    weapons_7_round_sd: 92,
    weapons_7_round_da: 26380,
    weapons_8: 'Elegant Vanity',
    weapons_8_app: 0.19,
    weapons_8_round_sd: 155,
    weapons_8_round_da: 34117,
    weapons_9: '[Reverb] Mark I',
    weapons_9_app: 0.12,
    weapons_9_round_sd: 600,
    weapons_9_round_da: 18598,
    weapons_10: 'Marcato Desire',
    weapons_10_app: 0.04,
    weapons_10_round_sd: 99,
    weapons_10_round_da: 0,
    artifacts_1: 'Swing Jazz, Hormone Punk',
    artifacts_1_1: 'Swing Jazz',
    artifacts_1_2: 'Hormone Punk',
    artifacts_1_3: '',
    artifacts_1_app: 39.55,
    artifacts_1_round_sd: 142,
    artifacts_1_round_da: 24475,
    artifacts_2: 'Astral Voice, Swing Jazz',
    artifacts_2_1: 'Astral Voice',
    artifacts_2_2: 'Swing Jazz',
    artifacts_2_3: '',
    artifacts_2_app: 22.22,
    artifacts_2_round_sd: 132,
    artifacts_2_round_da: 27422,
    artifacts_3: 'Swing Jazz, Astral Voice',
    artifacts_3_1: 'Swing Jazz',
    artifacts_3_2: 'Astral Voice',
    artifacts_3_3: '',
    artifacts_3_app: 6.73,
    artifacts_3_round_sd: 136,
    artifacts_3_round_da: 24086,
    artifacts_4: 'Swing Jazz, Woodpecker Electro',
    artifacts_4_1: 'Swing Jazz',
    artifacts_4_2: 'Woodpecker Electro',
    artifacts_4_3: '',
    artifacts_4_app: 4.11,
    artifacts_4_round_sd: 137,
    artifacts_4_round_da: 27272,
    artifacts_5: 'Astral Voice, Hormone Punk',
    artifacts_5_1: 'Astral Voice',
    artifacts_5_2: 'Hormone Punk',
    artifacts_5_3: '',
    artifacts_5_app: 3.07,
    artifacts_5_round_sd: 131,
    artifacts_5_round_da: 24968,
    artifacts_6: 'Swing Jazz, Freedom Blues',
    artifacts_6_1: 'Swing Jazz',
    artifacts_6_2: 'Freedom Blues',
    artifacts_6_3: '',
    artifacts_6_app: 2.5,
    artifacts_6_round_sd: 129,
    artifacts_6_round_da: 26516,
    artifacts_7: 'Hormone Punk, Swing Jazz',
    artifacts_7_1: 'Hormone Punk',
    artifacts_7_2: 'Swing Jazz',
    artifacts_7_3: '',
    artifacts_7_app: 1.94,
    artifacts_7_round_sd: 137,
    artifacts_7_round_da: 21937,
    artifacts_8: 'Astral Voice, Woodpecker Electro',
    artifacts_8_1: 'Astral Voice',
    artifacts_8_2: 'Woodpecker Electro',
    artifacts_8_3: '',
    artifacts_8_app: 1.93,
    artifacts_8_round_sd: 132,
    artifacts_8_round_da: 28146,
    artifacts_9: 'Freedom Blues, Swing Jazz',
    artifacts_9_1: 'Freedom Blues',
    artifacts_9_2: 'Swing Jazz',
    artifacts_9_3: '',
    artifacts_9_app: 0.88,
    artifacts_9_round_sd: 600,
    artifacts_9_round_da: 30400,
    artifacts_10: 'Astral Voice, Branch & Blade Song',
    artifacts_10_1: 'Astral Voice',
    artifacts_10_2: 'Branch & Blade Song',
    artifacts_10_3: '',
    artifacts_10_app: 0.36,
    artifacts_10_round_sd: 95,
    artifacts_10_round_da: 0,
    drive_slot_4_1: 'Percent ATK',
    drive_slot_4_1_app: 45.98,
    drive_slot_4_2: 'CRIT Rate',
    drive_slot_4_2_app: 42.16,
    drive_slot_4_3: 'CRIT DMG',
    drive_slot_4_3_app: 5.82,
    drive_slot_5_1: 'Percent ATK',
    drive_slot_5_1_app: 79.53,
    drive_slot_5_2: 'Fire DMG Bonus',
    drive_slot_5_2_app: 15.61,
    drive_slot_5_3: 'PEN Ratio',
    drive_slot_5_3_app: 1.48,
    drive_slot_6_1: 'Percent ATK',
    drive_slot_6_1_app: 51.11,
    drive_slot_6_2: 'Energy Regen',
    drive_slot_6_2_app: 39.9,
    drive_slot_6_3: 'Anomaly Mastery',
    drive_slot_6_3_app: 5.98,
    char_level: 59.61,
    w_engine_level: 57.31,
    basic_atk: 7.45,
    special_atk: 11.07,
    dash: 5.75,
    ultimate: 9.74,
    core_skill: 6.61,
    assist: 7.39,
    base_hp: 11539.1,
    base_atk: 2578.98,
    base_def: 951.02,
    base_impact: 86.28,
    crit_rate: 33.87,
    crit_dmg: 88.24,
    anomaly_mastery: 95.61,
    anomaly_proficiency: 138.85,
    pen_ratio: 1.18,
    pen: 33.86,
    base_energy_regen: 286.73,
    dmg_bonus: 4.72,
    percent_hp_sub: 13.24,
    percent_atk_sub: 15.76,
    percent_def_sub: 19.89,
    crit_rate_sub: 17.52,
    crit_dmg_sub: 35.21,
    pen_sub: 33.86,
    anomaly_proficiency_sub: 39.39
  },
  {
    char: 'koleda',
    app_rate_sd: 2.95,
    app_rate_sd_e1: 0.56,
    app_rate_sd_s0: 0.64,
    avg_round_sd: 164,
    avg_round_sd_e1: 116,
    avg_round_sd_s0: 203,
    sample_sd: 142,
    sample_size_players_sd: 13,
    app_rate_da: 7.86,
    app_rate_da_e1: 1.28,
    app_rate_da_s0: 2.27,
    avg_round_da: 24231,
    avg_round_da_e1: 31395,
    avg_round_da_s0: 20400,
    app_rate_da_boss_1: 6.27,
    avg_round_da_boss_1: 25484,
    app_rate_da_boss_2: 0.66,
    avg_round_da_boss_2: 16322,
    app_rate_da_boss_3: 1.48,
    avg_round_da_boss_3: 20948,
    sample_da: 460,
    sample_size_players_da: 31,
    app_0: 43.96,
    round_0_sd: 165,
    round_0_da: 24024,
    app_1: 27.53,
    round_1_sd: 172,
    round_1_da: 24050,
    app_2: 18.71,
    round_2_sd: 155,
    round_2_da: 25052,
    app_3: 8.65,
    round_3_sd: 153,
    round_3_da: 25127,
    app_4: 1.09,
    round_4_sd: 600,
    round_4_da: 24009,
    app_5: 0.35,
    round_5_sd: 600,
    round_5_da: 0,
    app_6: 1,
    round_6_sd: 600,
    round_6_da: 0,
    cons_avg: 0.96,
    weapons_1: 'Hellfire Gears',
    weapons_1_app: 43.48,
    weapons_1_round_sd: 154,
    weapons_1_round_da: 24338,
    weapons_2: 'Steam Oven',
    weapons_2_app: 35.42,
    weapons_2_round_sd: 176,
    weapons_2_round_da: 24812,
    weapons_3: 'Precious Fossilized Core',
    weapons_3_app: 11.57,
    weapons_3_round_sd: 160,
    weapons_3_round_da: 22770,
    weapons_4: 'The Restrained',
    weapons_4_app: 3.41,
    weapons_4_round_sd: 166,
    weapons_4_round_da: 24243,
    weapons_5: 'Demara Battery Mark II',
    weapons_5_app: 1.88,
    weapons_5_round_sd: 117,
    weapons_5_round_da: 25989,
    weapons_6: 'Six Shooter',
    weapons_6_app: 1.33,
    weapons_6_round_sd: 600,
    weapons_6_round_da: 27195,
    weapons_7: '[Vortex] Arrow',
    weapons_7_app: 0.48,
    weapons_7_round_sd: 600,
    weapons_7_round_da: 18771,
    weapons_8: 'Blazing Laurel',
    weapons_8_app: 0.32,
    weapons_8_round_sd: 600,
    weapons_8_round_da: 24744,
    weapons_9: 'Ice-Jade Teapot',
    weapons_9_app: 0.19,
    weapons_9_round_sd: 175,
    weapons_9_round_da: 0,
    weapons_10: 'Kaboom the Cannon',
    weapons_10_app: 0.16,
    weapons_10_round_sd: 600,
    weapons_10_round_da: 32075,
    artifacts_1: 'Shockstar Disco, Swing Jazz',
    artifacts_1_1: 'Shockstar Disco',
    artifacts_1_2: 'Swing Jazz',
    artifacts_1_3: '',
    artifacts_1_app: 70.77,
    artifacts_1_round_sd: 166,
    artifacts_1_round_da: 24874,
    artifacts_2: 'Shockstar Disco, Inferno Metal',
    artifacts_2_1: 'Shockstar Disco',
    artifacts_2_2: 'Inferno Metal',
    artifacts_2_3: '',
    artifacts_2_app: 5.42,
    artifacts_2_round_sd: 181,
    artifacts_2_round_da: 20842,
    artifacts_3: 'Swing Jazz, Shockstar Disco',
    artifacts_3_1: 'Swing Jazz',
    artifacts_3_2: 'Shockstar Disco',
    artifacts_3_3: '',
    artifacts_3_app: 4.88,
    artifacts_3_round_sd: 134,
    artifacts_3_round_da: 25287,
    artifacts_4: 'Shockstar Disco, Woodpecker Electro',
    artifacts_4_1: 'Shockstar Disco',
    artifacts_4_2: 'Woodpecker Electro',
    artifacts_4_3: '',
    artifacts_4_app: 3.15,
    artifacts_4_round_sd: 177,
    artifacts_4_round_da: 26239,
    artifacts_5: 'Shockstar Disco, Flex',
    artifacts_5_1: 'Shockstar Disco',
    artifacts_5_2: 'Flex',
    artifacts_5_3: '',
    artifacts_5_app: 2.44,
    artifacts_5_round_sd: 157,
    artifacts_5_round_da: 19115,
    artifacts_6: 'Shockstar Disco, Freedom Blues',
    artifacts_6_1: 'Shockstar Disco',
    artifacts_6_2: 'Freedom Blues',
    artifacts_6_3: '',
    artifacts_6_app: 2.23,
    artifacts_6_round_sd: 165,
    artifacts_6_round_da: 23183,
    artifacts_7: 'Shockstar Disco, Swing Jazz, Flex',
    artifacts_7_1: 'Shockstar Disco',
    artifacts_7_2: 'Swing Jazz',
    artifacts_7_3: 'Flex',
    artifacts_7_app: 0.95,
    artifacts_7_round_sd: 600,
    artifacts_7_round_da: 22226,
    artifacts_8: 'Proto Punk, Swing Jazz',
    artifacts_8_1: 'Proto Punk',
    artifacts_8_2: 'Swing Jazz',
    artifacts_8_3: '',
    artifacts_8_app: 0.64,
    artifacts_8_round_sd: 600,
    artifacts_8_round_da: 21138,
    artifacts_9: 'Shockstar Disco, Astral Voice',
    artifacts_9_1: 'Shockstar Disco',
    artifacts_9_2: 'Astral Voice',
    artifacts_9_3: '',
    artifacts_9_app: 0.64,
    artifacts_9_round_sd: 600,
    artifacts_9_round_da: 18325,
    artifacts_10: 'Proto Punk, Shockstar Disco',
    artifacts_10_1: 'Proto Punk',
    artifacts_10_2: 'Shockstar Disco',
    artifacts_10_3: '',
    artifacts_10_app: 0.58,
    artifacts_10_round_sd: 172,
    artifacts_10_round_da: 0,
    drive_slot_4_1: 'CRIT Rate',
    drive_slot_4_1_app: 72.83,
    drive_slot_4_2: 'Percent ATK',
    drive_slot_4_2_app: 11.48,
    drive_slot_4_3: 'CRIT DMG',
    drive_slot_4_3_app: 11.24,
    drive_slot_5_1: 'Fire DMG Bonus',
    drive_slot_5_1_app: 68.64,
    drive_slot_5_2: 'Percent ATK',
    drive_slot_5_2_app: 15.68,
    drive_slot_5_3: 'PEN Ratio',
    drive_slot_5_3_app: 6.3,
    drive_slot_6_1: 'Impact',
    drive_slot_6_1_app: 100,
    drive_slot_6_2: '',
    drive_slot_6_2_app: 0,
    drive_slot_6_3: '',
    drive_slot_6_3_app: 0,
    char_level: 59.9,
    w_engine_level: 58.71,
    basic_atk: 10.46,
    special_atk: 11.04,
    dash: 9.08,
    ultimate: 10.33,
    core_skill: 6.77,
    assist: 9.47,
    base_hp: 11321.24,
    base_atk: 2049.52,
    base_def: 933.44,
    base_impact: 178.81,
    crit_rate: 39.05,
    crit_dmg: 91.5,
    anomaly_mastery: 97,
    anomaly_proficiency: 137.35,
    pen_ratio: 1.27,
    pen: 29.59,
    base_energy_regen: 161.39,
    dmg_bonus: 21.81,
    percent_hp_sub: 10.39,
    percent_atk_sub: 16.69,
    percent_def_sub: 19.95,
    crit_rate_sub: 17.88,
    crit_dmg_sub: 35.78,
    pen_sub: 29.59,
    anomaly_proficiency_sub: 37.54
  },
  {
    char: 'ellen',
    app_rate_sd: 1.85,
    app_rate_sd_e1: 1.16,
    app_rate_sd_s0: 0.08,
    avg_round_sd: 186,
    avg_round_sd_e1: 141,
    avg_round_sd_s0: 600,
    sample_sd: 89,
    sample_size_players_sd: 60,
    app_rate_da: 25.43,
    app_rate_da_e1: 8.84,
    app_rate_da_s0: 4.44,
    avg_round_da: 20525,
    avg_round_da_e1: 25545,
    avg_round_da_s0: 17703,
    app_rate_da_boss_1: 24.78,
    avg_round_da_boss_1: 20940,
    app_rate_da_boss_2: 1.79,
    avg_round_da_boss_2: 14541,
    app_rate_da_boss_3: 0.52,
    avg_round_da_boss_3: 15891,
    sample_da: 1488,
    sample_size_players_da: 709,
    app_0: 66.46,
    round_0_sd: 186,
    round_0_da: 20525,
    app_1: 16.73,
    round_1_sd: 156,
    round_1_da: 23199,
    app_2: 10.09,
    round_2_sd: 151,
    round_2_da: 25960,
    app_3: 1.99,
    round_3_sd: 149,
    round_3_da: 28935,
    app_4: 0.39,
    round_4_sd: 144,
    round_4_da: 28000,
    app_5: 0.14,
    round_5_sd: 145,
    round_5_da: 17401,
    app_6: 4.21,
    round_6_sd: 102,
    round_6_da: 33681,
    cons_avg: 0.71,
    weapons_1: 'Deep Sea Visitor',
    weapons_1_app: 76.04,
    weapons_1_round_sd: 184,
    weapons_1_round_da: 21600,
    weapons_2: 'Starlight Engine',
    weapons_2_app: 4.92,
    weapons_2_round_sd: 213,
    weapons_2_round_da: 17421,
    weapons_3: 'Gilded Blossom',
    weapons_3_app: 4.23,
    weapons_3_round_sd: 221,
    weapons_3_round_da: 16735,
    weapons_4: 'The Brimstone',
    weapons_4_app: 3.88,
    weapons_4_round_sd: 184,
    weapons_4_round_da: 19635,
    weapons_5: 'Marcato Desire',
    weapons_5_app: 3.79,
    weapons_5_round_sd: 183,
    weapons_5_round_da: 18738,
    weapons_6: 'Cannon Rotor',
    weapons_6_app: 1.84,
    weapons_6_round_sd: 600,
    weapons_6_round_da: 18556,
    weapons_7: 'Steel Cushion',
    weapons_7_app: 1.71,
    weapons_7_round_sd: 122,
    weapons_7_round_da: 18982,
    weapons_8: 'Street Superstar',
    weapons_8_app: 1.16,
    weapons_8_round_sd: 259,
    weapons_8_round_da: 14323,
    weapons_9: 'Riot Suppressor Mark VI',
    weapons_9_app: 0.25,
    weapons_9_round_sd: 600,
    weapons_9_round_da: 21709,
    weapons_10: '',
    weapons_10_app: 0,
    weapons_10_round_sd: 600,
    weapons_10_round_da: 0,
    artifacts_1: 'Polar Metal, Woodpecker Electro',
    artifacts_1_1: 'Polar Metal',
    artifacts_1_2: 'Woodpecker Electro',
    artifacts_1_3: '',
    artifacts_1_app: 46.37,
    artifacts_1_round_sd: 193,
    artifacts_1_round_da: 19846,
    artifacts_2: 'Polar Metal, Branch & Blade Song',
    artifacts_2_1: 'Polar Metal',
    artifacts_2_2: 'Branch & Blade Song',
    artifacts_2_3: '',
    artifacts_2_app: 15.87,
    artifacts_2_round_sd: 159,
    artifacts_2_round_da: 21789,
    artifacts_3: 'Woodpecker Electro, Polar Metal',
    artifacts_3_1: 'Woodpecker Electro',
    artifacts_3_2: 'Polar Metal',
    artifacts_3_3: '',
    artifacts_3_app: 7.81,
    artifacts_3_round_sd: 600,
    artifacts_3_round_da: 21237,
    artifacts_4: 'Polar Metal, Puffer Electro',
    artifacts_4_1: 'Polar Metal',
    artifacts_4_2: 'Puffer Electro',
    artifacts_4_3: '',
    artifacts_4_app: 6,
    artifacts_4_round_sd: 226,
    artifacts_4_round_da: 21669,
    artifacts_5: 'Woodpecker Electro, Puffer Electro',
    artifacts_5_1: 'Woodpecker Electro',
    artifacts_5_2: 'Puffer Electro',
    artifacts_5_3: '',
    artifacts_5_app: 5.74,
    artifacts_5_round_sd: 166,
    artifacts_5_round_da: 20811,
    artifacts_6: 'Woodpecker Electro, Branch & Blade Song',
    artifacts_6_1: 'Woodpecker Electro',
    artifacts_6_2: 'Branch & Blade Song',
    artifacts_6_3: '',
    artifacts_6_app: 4.61,
    artifacts_6_round_sd: 157,
    artifacts_6_round_da: 22231,
    artifacts_7: 'Polar Metal, Flex',
    artifacts_7_1: 'Polar Metal',
    artifacts_7_2: 'Flex',
    artifacts_7_3: '',
    artifacts_7_app: 2.39,
    artifacts_7_round_sd: 600,
    artifacts_7_round_da: 17383,
    artifacts_8: 'Polar Metal, Hormone Punk',
    artifacts_8_1: 'Polar Metal',
    artifacts_8_2: 'Hormone Punk',
    artifacts_8_3: '',
    artifacts_8_app: 1.95,
    artifacts_8_round_sd: 176,
    artifacts_8_round_da: 21884,
    artifacts_9: 'Branch & Blade Song, Polar Metal',
    artifacts_9_1: 'Branch & Blade Song',
    artifacts_9_2: 'Polar Metal',
    artifacts_9_3: '',
    artifacts_9_app: 0.91,
    artifacts_9_round_sd: 208,
    artifacts_9_round_da: 18813,
    artifacts_10: 'Woodpecker Electro, Hormone Punk',
    artifacts_10_1: 'Woodpecker Electro',
    artifacts_10_2: 'Hormone Punk',
    artifacts_10_3: '',
    artifacts_10_app: 0.08,
    artifacts_10_round_sd: 216,
    artifacts_10_round_da: 0,
    drive_slot_4_1: 'CRIT DMG',
    drive_slot_4_1_app: 90.35,
    drive_slot_4_2: 'CRIT Rate',
    drive_slot_4_2_app: 7.87,
    drive_slot_4_3: 'Percent ATK',
    drive_slot_4_3_app: 1.03,
    drive_slot_5_1: 'Ice DMG Bonus',
    drive_slot_5_1_app: 70.36,
    drive_slot_5_2: 'Percent ATK',
    drive_slot_5_2_app: 15.05,
    drive_slot_5_3: 'PEN Ratio',
    drive_slot_5_3_app: 14.07,
    drive_slot_6_1: 'Percent ATK',
    drive_slot_6_1_app: 97.24,
    drive_slot_6_2: 'Anomaly Mastery',
    drive_slot_6_2_app: 1.18,
    drive_slot_6_3: 'Energy Regen',
    drive_slot_6_3_app: 0.79,
    char_level: 59.98,
    w_engine_level: 59.26,
    basic_atk: 11.75,
    special_atk: 11.54,
    dash: 10.34,
    ultimate: 11.49,
    core_skill: 6.98,
    assist: 9.75,
    base_hp: 10996.43,
    base_atk: 2871.9,
    base_def: 925.65,
    base_impact: 93.02,
    crit_rate: 72.03,
    crit_dmg: 151.26,
    anomaly_mastery: 94.34,
    anomaly_proficiency: 120.38,
    pen_ratio: 4.63,
    pen: 33.98,
    base_energy_regen: 120.66,
    dmg_bonus: 29.33,
    percent_hp_sub: 10.64,
    percent_atk_sub: 16.16,
    percent_def_sub: 15.6,
    crit_rate_sub: 23.84,
    crit_dmg_sub: 53.28,
    pen_sub: 33.98,
    anomaly_proficiency_sub: 27.29
  },
  {
    char: 'qingyi',
    app_rate_sd: 23.2,
    app_rate_sd_e1: 7.26,
    app_rate_sd_s0: 6.05,
    avg_round_sd: 164,
    avg_round_sd_e1: 135,
    avg_round_sd_s0: 170,
    sample_sd: 1116,
    sample_size_players_sd: 480,
    app_rate_da: 40.06,
    app_rate_da_e1: 11.08,
    app_rate_da_s0: 13.14,
    avg_round_da: 24448,
    avg_round_da_e1: 31350,
    avg_round_da_s0: 23328,
    app_rate_da_boss_1: 17.41,
    avg_round_da_boss_1: 25002,
    app_rate_da_boss_2: 0.58,
    avg_round_da_boss_2: 15454,
    app_rate_da_boss_3: 24.98,
    avg_round_da_boss_3: 24171,
    sample_da: 2344,
    sample_size_players_da: 875,
    app_0: 84.34,
    round_0_sd: 164,
    round_0_da: 24448,
    app_1: 10.83,
    round_1_sd: 138,
    round_1_da: 31055,
    app_2: 2.6,
    round_2_sd: 113,
    round_2_da: 37057,
    app_3: 0.62,
    round_3_sd: 128,
    round_3_da: 32251,
    app_4: 0.24,
    round_4_sd: 88,
    round_4_da: 42726,
    app_5: 1,
    round_5_sd: 600,
    round_5_da: 0,
    app_6: 1.37,
    round_6_sd: 74,
    round_6_da: 49274,
    cons_avg: 0.27,
    weapons_1: 'Ice-Jade Teapot',
    weapons_1_app: 36.21,
    weapons_1_round_sd: 160,
    weapons_1_round_da: 25850,
    weapons_2: 'Steam Oven',
    weapons_2_app: 18.36,
    weapons_2_round_sd: 172,
    weapons_2_round_da: 23193,
    weapons_3: 'The Restrained',
    weapons_3_app: 16.04,
    weapons_3_round_sd: 158,
    weapons_3_round_da: 24658,
    weapons_4: 'Demara Battery Mark II',
    weapons_4_app: 10.7,
    weapons_4_round_sd: 178,
    weapons_4_round_da: 23231,
    weapons_5: 'Hellfire Gears',
    weapons_5_app: 8.77,
    weapons_5_round_sd: 171,
    weapons_5_round_da: 24172,
    weapons_6: 'Precious Fossilized Core',
    weapons_6_app: 7.67,
    weapons_6_round_sd: 146,
    weapons_6_round_da: 25166,
    weapons_7: 'Six Shooter',
    weapons_7_app: 0.93,
    weapons_7_round_sd: 172,
    weapons_7_round_da: 20746,
    weapons_8: 'Hailstorm Shrine',
    weapons_8_app: 0.07,
    weapons_8_round_sd: 600,
    weapons_8_round_da: 0,
    weapons_9: '[Vortex] Arrow',
    weapons_9_app: 0.06,
    weapons_9_round_sd: 600,
    weapons_9_round_da: 19333,
    weapons_10: 'Blazing Laurel',
    weapons_10_app: 0.06,
    weapons_10_round_sd: 600,
    weapons_10_round_da: 29988,
    artifacts_1: 'Shockstar Disco, Thunder Metal',
    artifacts_1_1: 'Shockstar Disco',
    artifacts_1_2: 'Thunder Metal',
    artifacts_1_3: '',
    artifacts_1_app: 40.67,
    artifacts_1_round_sd: 169,
    artifacts_1_round_da: 23215,
    artifacts_2: 'Shockstar Disco, Swing Jazz',
    artifacts_2_1: 'Shockstar Disco',
    artifacts_2_2: 'Swing Jazz',
    artifacts_2_3: '',
    artifacts_2_app: 34.99,
    artifacts_2_round_sd: 160,
    artifacts_2_round_da: 24906,
    artifacts_3: 'Shockstar Disco, Woodpecker Electro',
    artifacts_3_1: 'Shockstar Disco',
    artifacts_3_2: 'Woodpecker Electro',
    artifacts_3_3: '',
    artifacts_3_app: 9.07,
    artifacts_3_round_sd: 171,
    artifacts_3_round_da: 25290,
    artifacts_4: 'Astral Voice, Shockstar Disco',
    artifacts_4_1: 'Astral Voice',
    artifacts_4_2: 'Shockstar Disco',
    artifacts_4_3: '',
    artifacts_4_app: 3.43,
    artifacts_4_round_sd: 145,
    artifacts_4_round_da: 31025,
    artifacts_5: 'Shockstar Disco, Branch & Blade Song',
    artifacts_5_1: 'Shockstar Disco',
    artifacts_5_2: 'Branch & Blade Song',
    artifacts_5_3: '',
    artifacts_5_app: 1.88,
    artifacts_5_round_sd: 160,
    artifacts_5_round_da: 27548,
    artifacts_6: 'Shockstar Disco, Flex',
    artifacts_6_1: 'Shockstar Disco',
    artifacts_6_2: 'Flex',
    artifacts_6_3: '',
    artifacts_6_app: 1.15,
    artifacts_6_round_sd: 200,
    artifacts_6_round_da: 22321,
    artifacts_7: 'Swing Jazz, Shockstar Disco',
    artifacts_7_1: 'Swing Jazz',
    artifacts_7_2: 'Shockstar Disco',
    artifacts_7_3: '',
    artifacts_7_app: 0.8,
    artifacts_7_round_sd: 154,
    artifacts_7_round_da: 27694,
    artifacts_8: 'Shockstar Disco, Astral Voice',
    artifacts_8_1: 'Shockstar Disco',
    artifacts_8_2: 'Astral Voice',
    artifacts_8_3: '',
    artifacts_8_app: 0.77,
    artifacts_8_round_sd: 126,
    artifacts_8_round_da: 28436,
    artifacts_9: 'Shockstar Disco, Hormone Punk',
    artifacts_9_1: 'Shockstar Disco',
    artifacts_9_2: 'Hormone Punk',
    artifacts_9_3: '',
    artifacts_9_app: 0.69,
    artifacts_9_round_sd: 148,
    artifacts_9_round_da: 23437,
    artifacts_10: '',
    artifacts_10_1: '',
    artifacts_10_2: '',
    artifacts_10_3: '',
    artifacts_10_app: 0,
    artifacts_10_round_sd: 600,
    artifacts_10_round_da: 0,
    drive_slot_4_1: 'CRIT Rate',
    drive_slot_4_1_app: 76.3,
    drive_slot_4_2: 'CRIT DMG',
    drive_slot_4_2_app: 13.95,
    drive_slot_4_3: 'Percent ATK',
    drive_slot_4_3_app: 6.34,
    drive_slot_5_1: 'Electric DMG Bonus',
    drive_slot_5_1_app: 69.53,
    drive_slot_5_2: 'Percent ATK',
    drive_slot_5_2_app: 20.43,
    drive_slot_5_3: 'PEN Ratio',
    drive_slot_5_3_app: 6.87,
    drive_slot_6_1: 'Impact',
    drive_slot_6_1_app: 97.11,
    drive_slot_6_2: 'Percent ATK',
    drive_slot_6_2_app: 2.37,
    drive_slot_6_3: '',
    drive_slot_6_3_app: 0.23,
    char_level: 59.96,
    w_engine_level: 58.56,
    basic_atk: 11.53,
    special_atk: 10.83,
    dash: 9.59,
    ultimate: 10.41,
    core_skill: 6.95,
    assist: 8.94,
    base_hp: 11826.46,
    base_atk: 2166.4,
    base_def: 957.68,
    base_impact: 187.6,
    crit_rate: 44.24,
    crit_dmg: 98.85,
    anomaly_mastery: 94.07,
    anomaly_proficiency: 129.8,
    pen_ratio: 1.64,
    pen: 35.29,
    base_energy_regen: 136.39,
    dmg_bonus: 24.67,
    percent_hp_sub: 11.95,
    percent_atk_sub: 17.05,
    percent_def_sub: 19.01,
    crit_rate_sub: 19.94,
    crit_dmg_sub: 41.68,
    pen_sub: 35.29,
    anomaly_proficiency_sub: 34.93
  },
  {
    char: 'jane-doe',
    app_rate_sd: 14.97,
    app_rate_sd_e1: 4.95,
    app_rate_sd_s0: 2.81,
    avg_round_sd: 168,
    avg_round_sd_e1: 127,
    avg_round_sd_s0: 175,
    sample_sd: 720,
    sample_size_players_sd: 494,
    app_rate_da: 17.74,
    app_rate_da_e1: 5.83,
    app_rate_da_s0: 3.97,
    avg_round_da: 25552,
    avg_round_da_e1: 35258,
    avg_round_da_s0: 22802,
    app_rate_da_boss_1: 12.1,
    avg_round_da_boss_1: 28382,
    app_rate_da_boss_2: 1.5,
    avg_round_da_boss_2: 17020,
    app_rate_da_boss_3: 5.41,
    avg_round_da_boss_3: 21303,
    sample_da: 1038,
    sample_size_players_da: 639,
    app_0: 75.38,
    round_0_sd: 168,
    round_0_da: 25552,
    app_1: 9.79,
    round_1_sd: 153,
    round_1_da: 28892,
    app_2: 11.09,
    round_2_sd: 117,
    round_2_da: 40965,
    app_3: 0.8,
    round_3_sd: 114,
    round_3_da: 39068,
    app_4: 0.57,
    round_4_sd: 94,
    round_4_da: 25548,
    app_5: 1,
    round_5_sd: 600,
    round_5_da: 0,
    app_6: 2.37,
    round_6_sd: 67,
    round_6_da: 46385,
    cons_avg: 0.5,
    weapons_1: 'Sharpened Stinger',
    weapons_1_app: 61.92,
    weapons_1_round_sd: 167,
    weapons_1_round_da: 26754,
    weapons_2: 'Weeping Gemini',
    weapons_2_app: 14.48,
    weapons_2_round_sd: 168,
    weapons_2_round_da: 24811,
    weapons_3: 'Rainforest Gourmet',
    weapons_3_app: 10.22,
    weapons_3_round_sd: 178,
    weapons_3_round_da: 22720,
    weapons_4: 'Electro-Lip Gloss',
    weapons_4_app: 8.63,
    weapons_4_round_sd: 162,
    weapons_4_round_da: 27316,
    weapons_5: 'Fusion Compiler',
    weapons_5_app: 3.36,
    weapons_5_round_sd: 170,
    weapons_5_round_da: 21478,
    weapons_6: 'Roaring Ride',
    weapons_6_app: 0.74,
    weapons_6_round_sd: 143,
    weapons_6_round_da: 19107,
    weapons_7: 'Timeweaver',
    weapons_7_app: 0.05,
    weapons_7_round_sd: 600,
    weapons_7_round_da: 27185,
    weapons_8: '[Magnetic Storm] Bravo',
    weapons_8_app: 0.05,
    weapons_8_round_sd: 600,
    weapons_8_round_da: 14115,
    weapons_9: '',
    weapons_9_app: 0,
    weapons_9_round_sd: 600,
    weapons_9_round_da: 0,
    weapons_10: '',
    weapons_10_app: 0,
    weapons_10_round_sd: 600,
    weapons_10_round_da: 0,
    artifacts_1: 'Fanged Metal, Freedom Blues',
    artifacts_1_1: 'Fanged Metal',
    artifacts_1_2: 'Freedom Blues',
    artifacts_1_3: '',
    artifacts_1_app: 77.96,
    artifacts_1_round_sd: 172,
    artifacts_1_round_da: 24824,
    artifacts_2: 'Fanged Metal, Chaos Jazz',
    artifacts_2_1: 'Fanged Metal',
    artifacts_2_2: 'Chaos Jazz',
    artifacts_2_3: '',
    artifacts_2_app: 9.15,
    artifacts_2_round_sd: 149,
    artifacts_2_round_da: 27612,
    artifacts_3: "Fanged Metal, Phaethon's Melody",
    artifacts_3_1: 'Fanged Metal',
    artifacts_3_2: "Phaethon's Melody",
    artifacts_3_3: '',
    artifacts_3_app: 6.64,
    artifacts_3_round_sd: 146,
    artifacts_3_round_da: 32531,
    artifacts_4: 'Fanged Metal, Hormone Punk',
    artifacts_4_1: 'Fanged Metal',
    artifacts_4_2: 'Hormone Punk',
    artifacts_4_3: '',
    artifacts_4_app: 2.05,
    artifacts_4_round_sd: 183,
    artifacts_4_round_da: 22785,
    artifacts_5: 'Fanged Metal, Puffer Electro',
    artifacts_5_1: 'Fanged Metal',
    artifacts_5_2: 'Puffer Electro',
    artifacts_5_3: '',
    artifacts_5_app: 0.72,
    artifacts_5_round_sd: 95,
    artifacts_5_round_da: 30170,
    artifacts_6: 'Freedom Blues, Fanged Metal',
    artifacts_6_1: 'Freedom Blues',
    artifacts_6_2: 'Fanged Metal',
    artifacts_6_3: '',
    artifacts_6_app: 0.64,
    artifacts_6_round_sd: 175,
    artifacts_6_round_da: 14750,
    artifacts_7: 'Fanged Metal, Flex',
    artifacts_7_1: 'Fanged Metal',
    artifacts_7_2: 'Flex',
    artifacts_7_3: '',
    artifacts_7_app: 0.57,
    artifacts_7_round_sd: 154,
    artifacts_7_round_da: 22577,
    artifacts_8: 'Fanged Metal, Astral Voice',
    artifacts_8_1: 'Fanged Metal',
    artifacts_8_2: 'Astral Voice',
    artifacts_8_3: '',
    artifacts_8_app: 0.56,
    artifacts_8_round_sd: 600,
    artifacts_8_round_da: 41353,
    artifacts_9: 'AP +30, AP +30, Fanged Metal',
    artifacts_9_1: 'AP +30',
    artifacts_9_2: 'AP +30',
    artifacts_9_3: 'Fanged Metal',
    artifacts_9_app: 0.13,
    artifacts_9_round_sd: 168,
    artifacts_9_round_da: 0,
    artifacts_10: 'Freedom Blues, Chaos Jazz',
    artifacts_10_1: 'Freedom Blues',
    artifacts_10_2: 'Chaos Jazz',
    artifacts_10_3: '',
    artifacts_10_app: 0.1,
    artifacts_10_round_sd: 600,
    artifacts_10_round_da: 29946,
    drive_slot_4_1: 'Anomaly Proficiency',
    drive_slot_4_1_app: 99.56,
    drive_slot_4_2: 'Percent ATK',
    drive_slot_4_2_app: 0.37,
    drive_slot_4_3: 'CRIT Rate',
    drive_slot_4_3_app: 0.09,
    drive_slot_5_1: 'Physical DMG Bonus',
    drive_slot_5_1_app: 84.43,
    drive_slot_5_2: 'Percent ATK',
    drive_slot_5_2_app: 9.38,
    drive_slot_5_3: 'PEN Ratio',
    drive_slot_5_3_app: 5.77,
    drive_slot_6_1: 'Anomaly Mastery',
    drive_slot_6_1_app: 95.32,
    drive_slot_6_2: 'Percent ATK',
    drive_slot_6_2_app: 4.51,
    drive_slot_6_3: 'Percent HP',
    drive_slot_6_3_app: 0.09,
    char_level: 60,
    w_engine_level: 59.71,
    basic_atk: 11.4,
    special_atk: 10.71,
    dash: 10.45,
    ultimate: 10.67,
    core_skill: 6.96,
    assist: 8.49,
    base_hp: 11235.83,
    base_atk: 2467.34,
    base_def: 938.69,
    base_impact: 86,
    crit_rate: 14.7,
    crit_dmg: 68.48,
    anomaly_mastery: 190.88,
    anomaly_proficiency: 408.73,
    pen_ratio: 2.11,
    pen: 36.17,
    base_energy_regen: 120.09,
    dmg_bonus: 35.26,
    percent_hp_sub: 11.51,
    percent_atk_sub: 25.65,
    percent_def_sub: 17.27,
    crit_rate_sub: 9.67,
    crit_dmg_sub: 18.48,
    pen_sub: 36.17,
    anomaly_proficiency_sub: 103.82
  },
  {
    char: 'seth',
    app_rate_sd: 3.72,
    app_rate_sd_e1: 1.23,
    app_rate_sd_s0: 0.79,
    avg_round_sd: 196,
    avg_round_sd_e1: 151,
    avg_round_sd_s0: 201,
    sample_sd: 179,
    sample_size_players_sd: 15,
    app_rate_da: 6.02,
    app_rate_da_e1: 2.03,
    app_rate_da_s0: 1.67,
    avg_round_da: 18171,
    avg_round_da_e1: 24780,
    avg_round_da_s0: 16488,
    app_rate_da_boss_1: 2.3,
    avg_round_da_boss_1: 18914,
    app_rate_da_boss_2: 1.15,
    avg_round_da_boss_2: 16074,
    app_rate_da_boss_3: 3.06,
    avg_round_da_boss_3: 18406,
    sample_da: 352,
    sample_size_players_da: 18,
    app_0: 0.57,
    round_0_sd: 600,
    round_0_da: 15519,
    app_1: 1.42,
    round_1_sd: 600,
    round_1_da: 15481,
    app_2: 1.31,
    round_2_sd: 187,
    round_2_da: 18355,
    app_3: 3.89,
    round_3_sd: 206,
    round_3_da: 17469,
    app_4: 6.64,
    round_4_sd: 209,
    round_4_da: 17067,
    app_5: 8.11,
    round_5_sd: 180,
    round_5_da: 16696,
    app_6: 78.82,
    round_6_sd: 195,
    round_6_da: 18549,
    cons_avg: 5.55,
    weapons_1: 'Peacekeeper - Specialized',
    weapons_1_app: 90.67,
    weapons_1_round_sd: 196,
    weapons_1_round_da: 18170,
    weapons_2: 'Spring Embrace',
    weapons_2_app: 2.65,
    weapons_2_round_sd: 180,
    weapons_2_round_da: 18558,
    weapons_3: 'Bunny Band',
    weapons_3_app: 2.14,
    weapons_3_round_sd: 170,
    weapons_3_round_da: 17844,
    weapons_4: 'Original Transmorpher',
    weapons_4_app: 1.13,
    weapons_4_round_sd: 283,
    weapons_4_round_da: 16604,
    weapons_5: 'Tusks of Fury',
    weapons_5_app: 0.91,
    weapons_5_round_sd: 162,
    weapons_5_round_da: 23839,
    weapons_6: 'Big Cylinder',
    weapons_6_app: 0.53,
    weapons_6_round_sd: 600,
    weapons_6_round_da: 18851,
    weapons_7: 'Starlight Engine',
    weapons_7_app: 0.35,
    weapons_7_round_sd: 600,
    weapons_7_round_da: 22196,
    weapons_8: 'Gilded Blossom',
    weapons_8_app: 0.21,
    weapons_8_round_sd: 136,
    weapons_8_round_da: 0,
    weapons_9: 'The Restrained',
    weapons_9_app: 0.17,
    weapons_9_round_sd: 600,
    weapons_9_round_da: 13275,
    weapons_10: 'Precious Fossilized Core',
    weapons_10_app: 0.17,
    weapons_10_round_sd: 600,
    weapons_10_round_da: 8500,
    artifacts_1: 'Swing Jazz, Hormone Punk',
    artifacts_1_1: 'Swing Jazz',
    artifacts_1_2: 'Hormone Punk',
    artifacts_1_3: '',
    artifacts_1_app: 26.24,
    artifacts_1_round_sd: 203,
    artifacts_1_round_da: 17373,
    artifacts_2: 'Proto Punk, Hormone Punk',
    artifacts_2_1: 'Proto Punk',
    artifacts_2_2: 'Hormone Punk',
    artifacts_2_3: '',
    artifacts_2_app: 13.84,
    artifacts_2_round_sd: 179,
    artifacts_2_round_da: 20103,
    artifacts_3: 'Proto Punk, Swing Jazz',
    artifacts_3_1: 'Proto Punk',
    artifacts_3_2: 'Swing Jazz',
    artifacts_3_3: '',
    artifacts_3_app: 8.08,
    artifacts_3_round_sd: 197,
    artifacts_3_round_da: 19796,
    artifacts_4: 'Astral Voice, Swing Jazz',
    artifacts_4_1: 'Astral Voice',
    artifacts_4_2: 'Swing Jazz',
    artifacts_4_3: '',
    artifacts_4_app: 5.51,
    artifacts_4_round_sd: 182,
    artifacts_4_round_da: 20113,
    artifacts_5: 'Swing Jazz, Freedom Blues',
    artifacts_5_1: 'Swing Jazz',
    artifacts_5_2: 'Freedom Blues',
    artifacts_5_3: '',
    artifacts_5_app: 4.59,
    artifacts_5_round_sd: 228,
    artifacts_5_round_da: 16293,
    artifacts_6: 'Proto Punk, Shockstar Disco',
    artifacts_6_1: 'Proto Punk',
    artifacts_6_2: 'Shockstar Disco',
    artifacts_6_3: '',
    artifacts_6_app: 3.48,
    artifacts_6_round_sd: 188,
    artifacts_6_round_da: 19050,
    artifacts_7: 'Proto Punk, Astral Voice',
    artifacts_7_1: 'Proto Punk',
    artifacts_7_2: 'Astral Voice',
    artifacts_7_3: '',
    artifacts_7_app: 2.89,
    artifacts_7_round_sd: 219,
    artifacts_7_round_da: 22229,
    artifacts_8: 'ATK +10%, Swing Jazz, Flex',
    artifacts_8_1: 'ATK +10%',
    artifacts_8_2: 'Swing Jazz',
    artifacts_8_3: 'Flex',
    artifacts_8_app: 2.65,
    artifacts_8_round_sd: 217,
    artifacts_8_round_da: 22613,
    artifacts_9: 'Freedom Blues, Swing Jazz',
    artifacts_9_1: 'Freedom Blues',
    artifacts_9_2: 'Swing Jazz',
    artifacts_9_3: '',
    artifacts_9_app: 2.47,
    artifacts_9_round_sd: 173,
    artifacts_9_round_da: 20246,
    artifacts_10: '',
    artifacts_10_1: '',
    artifacts_10_2: '',
    artifacts_10_3: '',
    artifacts_10_app: 0,
    artifacts_10_round_sd: 600,
    artifacts_10_round_da: 0,
    drive_slot_4_1: 'Percent ATK',
    drive_slot_4_1_app: 63.23,
    drive_slot_4_2: 'CRIT Rate',
    drive_slot_4_2_app: 15.39,
    drive_slot_4_3: 'Anomaly Proficiency',
    drive_slot_4_3_app: 11.96,
    drive_slot_5_1: 'Percent ATK',
    drive_slot_5_1_app: 69.22,
    drive_slot_5_2: 'Electric DMG Bonus',
    drive_slot_5_2_app: 21.37,
    drive_slot_5_3: 'Percent HP',
    drive_slot_5_3_app: 3.44,
    drive_slot_6_1: 'Percent ATK',
    drive_slot_6_1_app: 54.71,
    drive_slot_6_2: 'Energy Regen',
    drive_slot_6_2_app: 13.73,
    drive_slot_6_3: 'Anomaly Mastery',
    drive_slot_6_3_app: 11.96,
    char_level: 59.36,
    w_engine_level: 57.28,
    basic_atk: 7.7,
    special_atk: 8.61,
    dash: 5.32,
    ultimate: 7.3,
    core_skill: 6.5,
    assist: 9.34,
    base_hp: 12032.26,
    base_atk: 2896.62,
    base_def: 1132.38,
    base_impact: 96.37,
    crit_rate: 23.11,
    crit_dmg: 84.8,
    anomaly_mastery: 88.99,
    anomaly_proficiency: 160.41,
    pen_ratio: 1.43,
    pen: 33.12,
    base_energy_regen: 193.73,
    dmg_bonus: 6.78,
    percent_hp_sub: 10.08,
    percent_atk_sub: 17.86,
    percent_def_sub: 22.09,
    crit_rate_sub: 13.94,
    crit_dmg_sub: 31.51,
    pen_sub: 33.12,
    anomaly_proficiency_sub: 52.99
  },
  {
    char: 'caesar',
    app_rate_sd: 23.95,
    app_rate_sd_e1: 9.13,
    app_rate_sd_s0: 2.6,
    avg_round_sd: 155,
    avg_round_sd_e1: 112,
    avg_round_sd_s0: 189,
    sample_sd: 1152,
    sample_size_players_sd: 518,
    app_rate_da: 33.46,
    app_rate_da_e1: 10.96,
    app_rate_da_s0: 4.92,
    avg_round_da: 24710,
    avg_round_da_e1: 33327,
    avg_round_da_s0: 21117,
    app_rate_da_boss_1: 15.2,
    avg_round_da_boss_1: 26171,
    app_rate_da_boss_2: 7.36,
    avg_round_da_boss_2: 20439,
    app_rate_da_boss_3: 13.66,
    avg_round_da_boss_3: 24774,
    sample_da: 1958,
    sample_size_players_da: 751,
    app_0: 88.26,
    round_0_sd: 155,
    round_0_da: 24710,
    app_1: 6.65,
    round_1_sd: 124,
    round_1_da: 30970,
    app_2: 3.65,
    round_2_sd: 102,
    round_2_da: 41324,
    app_3: 0.42,
    round_3_sd: 96,
    round_3_da: 46025,
    app_4: 0.12,
    round_4_sd: 76,
    round_4_da: 49212,
    app_5: 1,
    round_5_sd: 600,
    round_5_da: 0,
    app_6: 0.91,
    round_6_sd: 63,
    round_6_da: 54846,
    cons_avg: 0.21,
    weapons_1: 'Tusks of Fury',
    weapons_1_app: 50.85,
    weapons_1_round_sd: 147,
    weapons_1_round_da: 26367,
    weapons_2: 'Original Transmorpher',
    weapons_2_app: 20.37,
    weapons_2_round_sd: 168,
    weapons_2_round_da: 22843,
    weapons_3: 'Demara Battery Mark II',
    weapons_3_app: 7.48,
    weapons_3_round_sd: 156,
    weapons_3_round_da: 24213,
    weapons_4: 'Precious Fossilized Core',
    weapons_4_app: 5.83,
    weapons_4_round_sd: 149,
    weapons_4_round_da: 24188,
    weapons_5: 'Hellfire Gears',
    weapons_5_app: 4.37,
    weapons_5_round_sd: 157,
    weapons_5_round_da: 24228,
    weapons_6: 'The Restrained',
    weapons_6_app: 3.04,
    weapons_6_round_sd: 151,
    weapons_6_round_da: 25708,
    weapons_7: 'Spring Embrace',
    weapons_7_app: 2.55,
    weapons_7_round_sd: 167,
    weapons_7_round_da: 22950,
    weapons_8: 'Peacekeeper - Specialized',
    weapons_8_app: 2.25,
    weapons_8_round_sd: 140,
    weapons_8_round_da: 21842,
    weapons_9: 'Big Cylinder',
    weapons_9_app: 0.51,
    weapons_9_round_sd: 600,
    weapons_9_round_da: 21189,
    weapons_10: 'Six Shooter',
    weapons_10_app: 0.29,
    weapons_10_round_sd: 158,
    weapons_10_round_da: 0,
    artifacts_1: 'Proto Punk, Shockstar Disco',
    artifacts_1_1: 'Proto Punk',
    artifacts_1_2: 'Shockstar Disco',
    artifacts_1_3: '',
    artifacts_1_app: 86.5,
    artifacts_1_round_sd: 156,
    artifacts_1_round_da: 24695,
    artifacts_2: 'Proto Punk, Swing Jazz',
    artifacts_2_1: 'Proto Punk',
    artifacts_2_2: 'Swing Jazz',
    artifacts_2_3: '',
    artifacts_2_app: 6.49,
    artifacts_2_round_sd: 151,
    artifacts_2_round_da: 25189,
    artifacts_3: 'Proto Punk, Flex',
    artifacts_3_1: 'Proto Punk',
    artifacts_3_2: 'Flex',
    artifacts_3_3: '',
    artifacts_3_app: 0.97,
    artifacts_3_round_sd: 211,
    artifacts_3_round_da: 22927,
    artifacts_4: 'Freedom Blues, Shockstar Disco',
    artifacts_4_1: 'Freedom Blues',
    artifacts_4_2: 'Shockstar Disco',
    artifacts_4_3: '',
    artifacts_4_app: 0.81,
    artifacts_4_round_sd: 152,
    artifacts_4_round_da: 27356,
    artifacts_5: 'Swing Jazz, Shockstar Disco',
    artifacts_5_1: 'Swing Jazz',
    artifacts_5_2: 'Shockstar Disco',
    artifacts_5_3: '',
    artifacts_5_app: 0.72,
    artifacts_5_round_sd: 133,
    artifacts_5_round_da: 27620,
    artifacts_6: 'Proto Punk, Fanged Metal',
    artifacts_6_1: 'Proto Punk',
    artifacts_6_2: 'Fanged Metal',
    artifacts_6_3: '',
    artifacts_6_app: 0.51,
    artifacts_6_round_sd: 146,
    artifacts_6_round_da: 18829,
    artifacts_7: 'Shockstar Disco, Proto Punk',
    artifacts_7_1: 'Shockstar Disco',
    artifacts_7_2: 'Proto Punk',
    artifacts_7_3: '',
    artifacts_7_app: 0.42,
    artifacts_7_round_sd: 179,
    artifacts_7_round_da: 24284,
    artifacts_8: 'Proto Punk, Freedom Blues',
    artifacts_8_1: 'Proto Punk',
    artifacts_8_2: 'Freedom Blues',
    artifacts_8_3: '',
    artifacts_8_app: 0.42,
    artifacts_8_round_sd: 155,
    artifacts_8_round_da: 23092,
    artifacts_9: 'Proto Punk, Woodpecker Electro',
    artifacts_9_1: 'Proto Punk',
    artifacts_9_2: 'Woodpecker Electro',
    artifacts_9_3: '',
    artifacts_9_app: 0.27,
    artifacts_9_round_sd: 600,
    artifacts_9_round_da: 25343,
    artifacts_10: 'Shockstar Disco, Swing Jazz',
    artifacts_10_1: 'Shockstar Disco',
    artifacts_10_2: 'Swing Jazz',
    artifacts_10_3: '',
    artifacts_10_app: 0.15,
    artifacts_10_round_sd: 150,
    artifacts_10_round_da: 0,
    drive_slot_4_1: 'CRIT Rate',
    drive_slot_4_1_app: 63.37,
    drive_slot_4_2: 'Anomaly Proficiency',
    drive_slot_4_2_app: 12.69,
    drive_slot_4_3: 'CRIT DMG',
    drive_slot_4_3_app: 11.74,
    drive_slot_5_1: 'Physical DMG Bonus',
    drive_slot_5_1_app: 63.26,
    drive_slot_5_2: 'Percent ATK',
    drive_slot_5_2_app: 23.83,
    drive_slot_5_3: 'PEN Ratio',
    drive_slot_5_3_app: 7.71,
    drive_slot_6_1: 'Impact',
    drive_slot_6_1_app: 98.2,
    drive_slot_6_2: 'Energy Regen',
    drive_slot_6_2_app: 0.78,
    drive_slot_6_3: 'Percent ATK',
    drive_slot_6_3_app: 0.31,
    char_level: 59.97,
    w_engine_level: 57.21,
    basic_atk: 8.16,
    special_atk: 11.18,
    dash: 6.19,
    ultimate: 8.83,
    core_skill: 6.95,
    assist: 10.29,
    base_hp: 13804.33,
    base_atk: 2093.13,
    base_def: 1164.36,
    base_impact: 167.38,
    crit_rate: 36.93,
    crit_dmg: 90.1,
    anomaly_mastery: 87.04,
    anomaly_proficiency: 140.69,
    pen_ratio: 1.72,
    pen: 35.36,
    base_energy_regen: 122.94,
    dmg_bonus: 18.77,
    percent_hp_sub: 13.41,
    percent_atk_sub: 16.44,
    percent_def_sub: 21.61,
    crit_rate_sub: 16.87,
    crit_dmg_sub: 34.98,
    pen_sub: 35.36,
    anomaly_proficiency_sub: 39.48
  },
  {
    char: 'burnice',
    app_rate_sd: 26.26,
    app_rate_sd_e1: 8.17,
    app_rate_sd_s0: 4.62,
    avg_round_sd: 135,
    avg_round_sd_e1: 107,
    avg_round_sd_s0: 153,
    sample_sd: 1263,
    sample_size_players_sd: 813,
    app_rate_da: 42.85,
    app_rate_da_e1: 12.56,
    app_rate_da_s0: 6.87,
    avg_round_da: 27066,
    avg_round_da_e1: 35756,
    avg_round_da_s0: 22861,
    app_rate_da_boss_1: 11.1,
    avg_round_da_boss_1: 26987,
    app_rate_da_boss_2: 29.15,
    avg_round_da_boss_2: 27897,
    app_rate_da_boss_3: 7.25,
    avg_round_da_boss_3: 24293,
    sample_da: 2507,
    sample_size_players_da: 1435,
    app_0: 88.29,
    round_0_sd: 135,
    round_0_da: 27066,
    app_1: 7.56,
    round_1_sd: 123,
    round_1_da: 32363,
    app_2: 2.59,
    round_2_sd: 92,
    round_2_da: 40156,
    app_3: 0.61,
    round_3_sd: 100,
    round_3_da: 45687,
    app_4: 0.19,
    round_4_sd: 108,
    round_4_da: 34892,
    app_5: 0.06,
    round_5_sd: 104,
    round_5_da: 30125,
    app_6: 0.7,
    round_6_sd: 95,
    round_6_da: 49073,
    cons_avg: 0.2,
    weapons_1: 'Flamemaker Shaker',
    weapons_1_app: 40.81,
    weapons_1_round_sd: 135,
    weapons_1_round_da: 28835,
    weapons_2: 'Weeping Gemini',
    weapons_2_app: 21.27,
    weapons_2_round_sd: 134,
    weapons_2_round_da: 26377,
    weapons_3: 'Electro-Lip Gloss',
    weapons_3_app: 13.73,
    weapons_3_round_sd: 127,
    weapons_3_round_da: 28092,
    weapons_4: 'Roaring Ride',
    weapons_4_app: 8.48,
    weapons_4_round_sd: 143,
    weapons_4_round_da: 24669,
    weapons_5: 'Fusion Compiler',
    weapons_5_app: 8.12,
    weapons_5_round_sd: 128,
    weapons_5_round_da: 26094,
    weapons_6: 'Rainforest Gourmet',
    weapons_6_app: 6.16,
    weapons_6_round_sd: 149,
    weapons_6_round_da: 23985,
    weapons_7: 'Hailstorm Shrine',
    weapons_7_app: 0.05,
    weapons_7_round_sd: 93,
    weapons_7_round_da: 26600,
    weapons_8: '[Magnetic Storm] Bravo',
    weapons_8_app: 0.05,
    weapons_8_round_sd: 600,
    weapons_8_round_da: 23119,
    weapons_9: 'Timeweaver',
    weapons_9_app: 0.05,
    weapons_9_round_sd: 600,
    weapons_9_round_da: 20364,
    weapons_10: 'Starlight Engine',
    weapons_10_app: 0.03,
    weapons_10_round_sd: 135,
    weapons_10_round_da: 0,
    artifacts_1: 'Chaos Jazz, Freedom Blues',
    artifacts_1_1: 'Chaos Jazz',
    artifacts_1_2: 'Freedom Blues',
    artifacts_1_3: '',
    artifacts_1_app: 54.23,
    artifacts_1_round_sd: 137,
    artifacts_1_round_da: 26309,
    artifacts_2: 'Chaos Jazz, Inferno Metal',
    artifacts_2_1: 'Chaos Jazz',
    artifacts_2_2: 'Inferno Metal',
    artifacts_2_3: '',
    artifacts_2_app: 16.25,
    artifacts_2_round_sd: 131,
    artifacts_2_round_da: 27488,
    artifacts_3: 'Chaos Jazz, Swing Jazz',
    artifacts_3_1: 'Chaos Jazz',
    artifacts_3_2: 'Swing Jazz',
    artifacts_3_3: '',
    artifacts_3_app: 16,
    artifacts_3_round_sd: 132,
    artifacts_3_round_da: 27472,
    artifacts_4: "Chaos Jazz, Phaethon's Melody",
    artifacts_4_1: 'Chaos Jazz',
    artifacts_4_2: "Phaethon's Melody",
    artifacts_4_3: '',
    artifacts_4_app: 5.62,
    artifacts_4_round_sd: 131,
    artifacts_4_round_da: 30358,
    artifacts_5: 'Chaos Jazz, Hormone Punk',
    artifacts_5_1: 'Chaos Jazz',
    artifacts_5_2: 'Hormone Punk',
    artifacts_5_3: '',
    artifacts_5_app: 1.64,
    artifacts_5_round_sd: 137,
    artifacts_5_round_da: 29104,
    artifacts_6: 'Chaos Jazz, Astral Voice',
    artifacts_6_1: 'Chaos Jazz',
    artifacts_6_2: 'Astral Voice',
    artifacts_6_3: '',
    artifacts_6_app: 1.38,
    artifacts_6_round_sd: 127,
    artifacts_6_round_da: 29788,
    artifacts_7: 'Chaos Jazz, Puffer Electro',
    artifacts_7_1: 'Chaos Jazz',
    artifacts_7_2: 'Puffer Electro',
    artifacts_7_3: '',
    artifacts_7_app: 1.35,
    artifacts_7_round_sd: 159,
    artifacts_7_round_da: 31584,
    artifacts_8: 'Chaos Jazz, Flex',
    artifacts_8_1: 'Chaos Jazz',
    artifacts_8_2: 'Flex',
    artifacts_8_3: '',
    artifacts_8_app: 0.69,
    artifacts_8_round_sd: 147,
    artifacts_8_round_da: 26482,
    artifacts_9: 'AP +30, AP +30, Flex',
    artifacts_9_1: 'AP +30',
    artifacts_9_2: 'AP +30',
    artifacts_9_3: 'Flex',
    artifacts_9_app: 0.42,
    artifacts_9_round_sd: 132,
    artifacts_9_round_da: 28120,
    artifacts_10: '',
    artifacts_10_1: '',
    artifacts_10_2: '',
    artifacts_10_3: '',
    artifacts_10_app: 0,
    artifacts_10_round_sd: 600,
    artifacts_10_round_da: 0,
    drive_slot_4_1: 'Anomaly Proficiency',
    drive_slot_4_1_app: 96.49,
    drive_slot_4_2: 'Percent ATK',
    drive_slot_4_2_app: 1.97,
    drive_slot_4_3: 'CRIT Rate',
    drive_slot_4_3_app: 0.52,
    drive_slot_5_1: 'Fire DMG Bonus',
    drive_slot_5_1_app: 80.15,
    drive_slot_5_2: 'Percent ATK',
    drive_slot_5_2_app: 11.63,
    drive_slot_5_3: 'PEN Ratio',
    drive_slot_5_3_app: 7.56,
    drive_slot_6_1: 'Anomaly Mastery',
    drive_slot_6_1_app: 82.56,
    drive_slot_6_2: 'Percent ATK',
    drive_slot_6_2_app: 10.08,
    drive_slot_6_3: 'Energy Regen',
    drive_slot_6_3_app: 7,
    char_level: 59.95,
    w_engine_level: 58.68,
    basic_atk: 8.93,
    special_atk: 11.33,
    dash: 6.03,
    ultimate: 10.52,
    core_skill: 6.92,
    assist: 7.94,
    base_hp: 10817.89,
    base_atk: 2667.73,
    base_def: 939.27,
    base_impact: 83,
    crit_rate: 16.38,
    crit_dmg: 72.34,
    anomaly_mastery: 147.45,
    anomaly_proficiency: 354.73,
    pen_ratio: 3.81,
    pen: 38.64,
    base_energy_regen: 166.65,
    dmg_bonus: 25.82,
    percent_hp_sub: 12.23,
    percent_atk_sub: 23,
    percent_def_sub: 18.36,
    crit_rate_sub: 11.16,
    crit_dmg_sub: 21.99,
    pen_sub: 38.64,
    anomaly_proficiency_sub: 86.31
  },
  {
    char: 'yanagi',
    app_rate_sd: 43.26,
    app_rate_sd_e1: 13.26,
    app_rate_sd_s0: 7.3,
    avg_round_sd: 120,
    avg_round_sd_e1: 86,
    avg_round_sd_s0: 144,
    sample_sd: 2081,
    sample_size_players_sd: 1473,
    app_rate_da: 46.92,
    app_rate_da_e1: 13.79,
    app_rate_da_s0: 7.3,
    avg_round_da: 26974,
    avg_round_da_e1: 37240,
    avg_round_da_s0: 23849,
    app_rate_da_boss_1: 4.09,
    avg_round_da_boss_1: 31312,
    app_rate_da_boss_2: 31.24,
    avg_round_da_boss_2: 26095,
    app_rate_da_boss_3: 16.8,
    avg_round_da_boss_3: 27321,
    sample_da: 2745,
    sample_size_players_da: 1749,
    app_0: 89.81,
    round_0_sd: 120,
    round_0_da: 26974,
    app_1: 5.21,
    round_1_sd: 95,
    round_1_da: 35373,
    app_2: 3.38,
    round_2_sd: 84,
    round_2_da: 40343,
    app_3: 0.46,
    round_3_sd: 73,
    round_3_da: 44382,
    app_4: 0.04,
    round_4_sd: 71,
    round_4_da: 47328,
    app_5: 1,
    round_5_sd: 600,
    round_5_da: 0,
    app_6: 1.11,
    round_6_sd: 56,
    round_6_da: 54504,
    cons_avg: 0.2,
    weapons_1: 'Timeweaver',
    weapons_1_app: 43.73,
    weapons_1_round_sd: 111,
    weapons_1_round_da: 29089,
    weapons_2: 'Weeping Gemini',
    weapons_2_app: 22.8,
    weapons_2_round_sd: 125,
    weapons_2_round_da: 25798,
    weapons_3: 'Fusion Compiler',
    weapons_3_app: 18.33,
    weapons_3_round_sd: 118,
    weapons_3_round_da: 26670,
    weapons_4: 'Electro-Lip Gloss',
    weapons_4_app: 10.43,
    weapons_4_round_sd: 130,
    weapons_4_round_da: 25780,
    weapons_5: 'Rainforest Gourmet',
    weapons_5_app: 3.24,
    weapons_5_round_sd: 145,
    weapons_5_round_da: 23360,
    weapons_6: 'Roaring Ride',
    weapons_6_app: 0.91,
    weapons_6_round_sd: 130,
    weapons_6_round_da: 24229,
    weapons_7: 'Flamemaker Shaker',
    weapons_7_app: 0.13,
    weapons_7_round_sd: 77,
    weapons_7_round_da: 26888,
    weapons_8: 'Kaboom the Cannon',
    weapons_8_app: 0.04,
    weapons_8_round_sd: 600,
    weapons_8_round_da: 0,
    weapons_9: 'Drill Rig - Red Axis',
    weapons_9_app: 0.02,
    weapons_9_round_sd: 600,
    weapons_9_round_da: 0,
    weapons_10: 'Flight of Fancy',
    weapons_10_app: 0.02,
    weapons_10_round_sd: 600,
    weapons_10_round_da: 24992,
    artifacts_1: 'Chaos Jazz, Freedom Blues',
    artifacts_1_1: 'Chaos Jazz',
    artifacts_1_2: 'Freedom Blues',
    artifacts_1_3: '',
    artifacts_1_app: 69.21,
    artifacts_1_round_sd: 118,
    artifacts_1_round_da: 26947,
    artifacts_2: 'Thunder Metal, Freedom Blues',
    artifacts_2_1: 'Thunder Metal',
    artifacts_2_2: 'Freedom Blues',
    artifacts_2_3: '',
    artifacts_2_app: 6.27,
    artifacts_2_round_sd: 143,
    artifacts_2_round_da: 24211,
    artifacts_3: 'Thunder Metal, Chaos Jazz',
    artifacts_3_1: 'Thunder Metal',
    artifacts_3_2: 'Chaos Jazz',
    artifacts_3_3: '',
    artifacts_3_app: 5.85,
    artifacts_3_round_sd: 132,
    artifacts_3_round_da: 26403,
    artifacts_4: 'Chaos Jazz, Thunder Metal',
    artifacts_4_1: 'Chaos Jazz',
    artifacts_4_2: 'Thunder Metal',
    artifacts_4_3: '',
    artifacts_4_app: 4.77,
    artifacts_4_round_sd: 114,
    artifacts_4_round_da: 26698,
    artifacts_5: 'Chaos Jazz, Puffer Electro',
    artifacts_5_1: 'Chaos Jazz',
    artifacts_5_2: 'Puffer Electro',
    artifacts_5_3: '',
    artifacts_5_app: 2.09,
    artifacts_5_round_sd: 98,
    artifacts_5_round_da: 32244,
    artifacts_6: 'Freedom Blues, Chaos Jazz',
    artifacts_6_1: 'Freedom Blues',
    artifacts_6_2: 'Chaos Jazz',
    artifacts_6_3: '',
    artifacts_6_app: 1.85,
    artifacts_6_round_sd: 118,
    artifacts_6_round_da: 29464,
    artifacts_7: "Chaos Jazz, Phaethon's Melody",
    artifacts_7_1: 'Chaos Jazz',
    artifacts_7_2: "Phaethon's Melody",
    artifacts_7_3: '',
    artifacts_7_app: 1.76,
    artifacts_7_round_sd: 112,
    artifacts_7_round_da: 29321,
    artifacts_8: 'Chaos Jazz, Swing Jazz',
    artifacts_8_1: 'Chaos Jazz',
    artifacts_8_2: 'Swing Jazz',
    artifacts_8_3: '',
    artifacts_8_app: 0.95,
    artifacts_8_round_sd: 117,
    artifacts_8_round_da: 26621,
    artifacts_9: 'AP +30, AP +30, Thunder Metal',
    artifacts_9_1: 'AP +30',
    artifacts_9_2: 'AP +30',
    artifacts_9_3: 'Thunder Metal',
    artifacts_9_app: 0.81,
    artifacts_9_round_sd: 123,
    artifacts_9_round_da: 29739,
    artifacts_10: '',
    artifacts_10_1: '',
    artifacts_10_2: '',
    artifacts_10_3: '',
    artifacts_10_app: 0,
    artifacts_10_round_sd: 600,
    artifacts_10_round_da: 0,
    drive_slot_4_1: 'Anomaly Proficiency',
    drive_slot_4_1_app: 98.61,
    drive_slot_4_2: 'Percent ATK',
    drive_slot_4_2_app: 1.03,
    drive_slot_4_3: 'CRIT Rate',
    drive_slot_4_3_app: 0.31,
    drive_slot_5_1: 'Electric DMG Bonus',
    drive_slot_5_1_app: 75.33,
    drive_slot_5_2: 'PEN Ratio',
    drive_slot_5_2_app: 18.19,
    drive_slot_5_3: 'Percent ATK',
    drive_slot_5_3_app: 6.2,
    drive_slot_6_1: 'Anomaly Mastery',
    drive_slot_6_1_app: 75.77,
    drive_slot_6_2: 'Percent ATK',
    drive_slot_6_2_app: 18.64,
    drive_slot_6_3: 'Energy Regen',
    drive_slot_6_3_app: 5.37,
    char_level: 59.98,
    w_engine_level: 59.7,
    basic_atk: 10.98,
    special_atk: 11.72,
    dash: 7.71,
    ultimate: 11.23,
    core_skill: 6.97,
    assist: 8.47,
    base_hp: 11281.71,
    base_atk: 2704.93,
    base_def: 957.75,
    base_impact: 86,
    crit_rate: 15.41,
    crit_dmg: 69.66,
    anomaly_mastery: 181.5,
    anomaly_proficiency: 360.7,
    pen_ratio: 8.88,
    pen: 40.78,
    base_energy_regen: 124.39,
    dmg_bonus: 24.53,
    percent_hp_sub: 11.87,
    percent_atk_sub: 22.26,
    percent_def_sub: 18.57,
    crit_rate_sub: 10.35,
    crit_dmg_sub: 19.64,
    pen_sub: 40.78,
    anomaly_proficiency_sub: 95.99
  },
  {
    char: 'lighter',
    app_rate_sd: 7.42,
    app_rate_sd_e1: 2.62,
    app_rate_sd_s0: 0.81,
    avg_round_sd: 128,
    avg_round_sd_e1: 100,
    avg_round_sd_s0: 157,
    sample_sd: 357,
    sample_size_players_sd: 205,
    app_rate_da: 13.84,
    app_rate_da_e1: 4.26,
    app_rate_da_s0: 2.03,
    avg_round_da: 27082,
    avg_round_da_e1: 36132,
    avg_round_da_s0: 22375,
    app_rate_da_boss_1: 9.49,
    avg_round_da_boss_1: 28964,
    app_rate_da_boss_2: 4,
    avg_round_da_boss_2: 23248,
    app_rate_da_boss_3: 1.48,
    avg_round_da_boss_3: 25630,
    sample_da: 810,
    sample_size_players_da: 396,
    app_0: 88.45,
    round_0_sd: 128,
    round_0_da: 27082,
    app_1: 5.39,
    round_1_sd: 90,
    round_1_da: 31295,
    app_2: 3.32,
    round_2_sd: 110,
    round_2_da: 41881,
    app_3: 1.38,
    round_3_sd: 87,
    round_3_da: 32594,
    app_4: 0.28,
    round_4_sd: 57,
    round_4_da: 0,
    app_5: 1,
    round_5_sd: 600,
    round_5_da: 0,
    app_6: 1.36,
    round_6_sd: 82,
    round_6_da: 51125,
    cons_avg: 0.25,
    weapons_1: 'Blazing Laurel',
    weapons_1_app: 50.65,
    weapons_1_round_sd: 122,
    weapons_1_round_da: 28546,
    weapons_2: 'Hellfire Gears',
    weapons_2_app: 17.87,
    weapons_2_round_sd: 124,
    weapons_2_round_da: 26025,
    weapons_3: 'Precious Fossilized Core',
    weapons_3_app: 9.97,
    weapons_3_round_sd: 137,
    weapons_3_round_da: 25055,
    weapons_4: 'Steam Oven',
    weapons_4_app: 8.64,
    weapons_4_round_sd: 156,
    weapons_4_round_da: 25509,
    weapons_5: 'The Restrained',
    weapons_5_app: 8.2,
    weapons_5_round_sd: 137,
    weapons_5_round_da: 26040,
    weapons_6: 'Ice-Jade Teapot',
    weapons_6_app: 2.69,
    weapons_6_round_sd: 106,
    weapons_6_round_da: 33386,
    weapons_7: 'Six Shooter',
    weapons_7_app: 0.68,
    weapons_7_round_sd: 166,
    weapons_7_round_da: 29646,
    weapons_8: 'Demara Battery Mark II',
    weapons_8_app: 0.6,
    weapons_8_round_sd: 154,
    weapons_8_round_da: 23386,
    weapons_9: 'Hailstorm Shrine',
    weapons_9_app: 0.18,
    weapons_9_round_sd: 82,
    weapons_9_round_da: 32287,
    weapons_10: '',
    weapons_10_app: 0,
    weapons_10_round_sd: 600,
    weapons_10_round_da: 0,
    artifacts_1: 'Shockstar Disco, Swing Jazz',
    artifacts_1_1: 'Shockstar Disco',
    artifacts_1_2: 'Swing Jazz',
    artifacts_1_3: '',
    artifacts_1_app: 54.9,
    artifacts_1_round_sd: 130,
    artifacts_1_round_da: 27075,
    artifacts_2: 'Shockstar Disco, Inferno Metal',
    artifacts_2_1: 'Shockstar Disco',
    artifacts_2_2: 'Inferno Metal',
    artifacts_2_3: '',
    artifacts_2_app: 12.4,
    artifacts_2_round_sd: 139,
    artifacts_2_round_da: 25929,
    artifacts_3: 'Shockstar Disco, Woodpecker Electro',
    artifacts_3_1: 'Shockstar Disco',
    artifacts_3_2: 'Woodpecker Electro',
    artifacts_3_3: '',
    artifacts_3_app: 7.39,
    artifacts_3_round_sd: 127,
    artifacts_3_round_da: 26891,
    artifacts_4: 'Proto Punk, Shockstar Disco',
    artifacts_4_1: 'Proto Punk',
    artifacts_4_2: 'Shockstar Disco',
    artifacts_4_3: '',
    artifacts_4_app: 5.06,
    artifacts_4_round_sd: 109,
    artifacts_4_round_da: 32729,
    artifacts_5: 'Swing Jazz, Shockstar Disco',
    artifacts_5_1: 'Swing Jazz',
    artifacts_5_2: 'Shockstar Disco',
    artifacts_5_3: '',
    artifacts_5_app: 3.16,
    artifacts_5_round_sd: 105,
    artifacts_5_round_da: 30375,
    artifacts_6: 'Shockstar Disco, Branch & Blade Song',
    artifacts_6_1: 'Shockstar Disco',
    artifacts_6_2: 'Branch & Blade Song',
    artifacts_6_3: '',
    artifacts_6_app: 2.19,
    artifacts_6_round_sd: 122,
    artifacts_6_round_da: 26538,
    artifacts_7: 'Inferno Metal, Shockstar Disco',
    artifacts_7_1: 'Inferno Metal',
    artifacts_7_2: 'Shockstar Disco',
    artifacts_7_3: '',
    artifacts_7_app: 2.14,
    artifacts_7_round_sd: 131,
    artifacts_7_round_da: 28009,
    artifacts_8: 'Woodpecker Electro, Shockstar Disco',
    artifacts_8_1: 'Woodpecker Electro',
    artifacts_8_2: 'Shockstar Disco',
    artifacts_8_3: '',
    artifacts_8_app: 1.52,
    artifacts_8_round_sd: 98,
    artifacts_8_round_da: 28628,
    artifacts_9: 'Shockstar Disco, Flex',
    artifacts_9_1: 'Shockstar Disco',
    artifacts_9_2: 'Flex',
    artifacts_9_3: '',
    artifacts_9_app: 0.81,
    artifacts_9_round_sd: 600,
    artifacts_9_round_da: 19638,
    artifacts_10: 'Inferno Metal, Woodpecker Electro',
    artifacts_10_1: 'Inferno Metal',
    artifacts_10_2: 'Woodpecker Electro',
    artifacts_10_3: '',
    artifacts_10_app: 0.59,
    artifacts_10_round_sd: 134,
    artifacts_10_round_da: 0,
    drive_slot_4_1: 'CRIT Rate',
    drive_slot_4_1_app: 74.7,
    drive_slot_4_2: 'CRIT DMG',
    drive_slot_4_2_app: 15.65,
    drive_slot_4_3: 'Percent ATK',
    drive_slot_4_3_app: 5.81,
    drive_slot_5_1: 'Fire DMG Bonus',
    drive_slot_5_1_app: 58.21,
    drive_slot_5_2: 'Percent ATK',
    drive_slot_5_2_app: 32.15,
    drive_slot_5_3: 'PEN Ratio',
    drive_slot_5_3_app: 8.48,
    drive_slot_6_1: 'Impact',
    drive_slot_6_1_app: 99.34,
    drive_slot_6_2: 'Percent ATK',
    drive_slot_6_2_app: 0.33,
    drive_slot_6_3: '',
    drive_slot_6_3_app: 0.33,
    char_level: 59.97,
    w_engine_level: 59.2,
    basic_atk: 11.44,
    special_atk: 11.15,
    dash: 7.83,
    ultimate: 10.39,
    core_skill: 6.94,
    assist: 9.53,
    base_hp: 11759.92,
    base_atk: 2256.17,
    base_def: 953.8,
    base_impact: 191.33,
    crit_rate: 44.83,
    crit_dmg: 102.06,
    anomaly_mastery: 91,
    anomaly_proficiency: 126.96,
    pen_ratio: 2.06,
    pen: 36.52,
    base_energy_regen: 136.75,
    dmg_bonus: 19.11,
    percent_hp_sub: 11.66,
    percent_atk_sub: 15.88,
    percent_def_sub: 17.87,
    crit_rate_sub: 21.03,
    crit_dmg_sub: 44.43,
    pen_sub: 36.52,
    anomaly_proficiency_sub: 33.21
  },
  {
    char: 'harumasa',
    app_rate_sd: 12.1,
    app_rate_sd_e1: 4.07,
    app_rate_sd_s0: 2.79,
    avg_round_sd: 176,
    avg_round_sd_e1: 143,
    avg_round_sd_s0: 190,
    sample_sd: 582,
    sample_size_players_sd: 243,
    app_rate_da: 17.95,
    app_rate_da_e1: 4.94,
    app_rate_da_s0: 5.54,
    avg_round_da: 22007,
    avg_round_da_e1: 29065,
    avg_round_da_s0: 20545,
    app_rate_da_boss_1: 0.54,
    avg_round_da_boss_1: 18083,
    app_rate_da_boss_2: 0.85,
    avg_round_da_boss_2: 0,
    app_rate_da_boss_3: 18.02,
    avg_round_da_boss_3: 22140,
    sample_da: 1050,
    sample_size_players_da: 362,
    app_0: 85.81,
    round_0_sd: 176,
    round_0_da: 22007,
    app_1: 8.11,
    round_1_sd: 160,
    round_1_da: 26589,
    app_2: 2.83,
    round_2_sd: 126,
    round_2_da: 29903,
    app_3: 1.01,
    round_3_sd: 112,
    round_3_da: 36950,
    app_4: 0.38,
    round_4_sd: 100,
    round_4_da: 39742,
    app_5: 0.38,
    round_5_sd: 133,
    round_5_da: 29009,
    app_6: 1.48,
    round_6_sd: 92,
    round_6_da: 40007,
    cons_avg: 0.29,
    weapons_1: 'Zanshin Herb Case',
    weapons_1_app: 39,
    weapons_1_round_sd: 163,
    weapons_1_round_da: 23274,
    weapons_2: 'Marcato Desire',
    weapons_2_app: 29.79,
    weapons_2_round_sd: 188,
    weapons_2_round_da: 21603,
    weapons_3: 'The Brimstone',
    weapons_3_app: 12.83,
    weapons_3_round_sd: 171,
    weapons_3_round_da: 22988,
    weapons_4: 'Starlight Engine',
    weapons_4_app: 5.74,
    weapons_4_round_sd: 181,
    weapons_4_round_da: 21031,
    weapons_5: 'Drill Rig - Red Axis',
    weapons_5_app: 2.65,
    weapons_5_round_sd: 242,
    weapons_5_round_da: 16513,
    weapons_6: 'Cannon Rotor',
    weapons_6_app: 2.31,
    weapons_6_round_sd: 171,
    weapons_6_round_da: 18029,
    weapons_7: 'Severed Innocence',
    weapons_7_app: 1.53,
    weapons_7_round_sd: 177,
    weapons_7_round_da: 24114,
    weapons_8: 'Heartstring Nocturne',
    weapons_8_app: 1.41,
    weapons_8_round_sd: 150,
    weapons_8_round_da: 25085,
    weapons_9: 'Gilded Blossom',
    weapons_9_app: 0.69,
    weapons_9_round_sd: 600,
    weapons_9_round_da: 16945,
    weapons_10: 'Steel Cushion',
    weapons_10_app: 0.41,
    weapons_10_round_sd: 177,
    weapons_10_round_da: 0,
    artifacts_1: 'Thunder Metal, Woodpecker Electro',
    artifacts_1_1: 'Thunder Metal',
    artifacts_1_2: 'Woodpecker Electro',
    artifacts_1_3: '',
    artifacts_1_app: 38.43,
    artifacts_1_round_sd: 183,
    artifacts_1_round_da: 20834,
    artifacts_2: 'Thunder Metal, Branch & Blade Song',
    artifacts_2_1: 'Thunder Metal',
    artifacts_2_2: 'Branch & Blade Song',
    artifacts_2_3: '',
    artifacts_2_app: 11.39,
    artifacts_2_round_sd: 180,
    artifacts_2_round_da: 22893,
    artifacts_3: 'Shadow Harmony, Branch & Blade Song',
    artifacts_3_1: 'Shadow Harmony',
    artifacts_3_2: 'Branch & Blade Song',
    artifacts_3_3: '',
    artifacts_3_app: 8.4,
    artifacts_3_round_sd: 167,
    artifacts_3_round_da: 22474,
    artifacts_4: 'Shadow Harmony, Woodpecker Electro',
    artifacts_4_1: 'Shadow Harmony',
    artifacts_4_2: 'Woodpecker Electro',
    artifacts_4_3: '',
    artifacts_4_app: 5.43,
    artifacts_4_round_sd: 174,
    artifacts_4_round_da: 25432,
    artifacts_5: 'Shadow Harmony, Thunder Metal',
    artifacts_5_1: 'Shadow Harmony',
    artifacts_5_2: 'Thunder Metal',
    artifacts_5_3: '',
    artifacts_5_app: 4.39,
    artifacts_5_round_sd: 147,
    artifacts_5_round_da: 26571,
    artifacts_6: 'Woodpecker Electro, Branch & Blade Song',
    artifacts_6_1: 'Woodpecker Electro',
    artifacts_6_2: 'Branch & Blade Song',
    artifacts_6_3: '',
    artifacts_6_app: 3.28,
    artifacts_6_round_sd: 192,
    artifacts_6_round_da: 20037,
    artifacts_7: 'Woodpecker Electro, Thunder Metal',
    artifacts_7_1: 'Woodpecker Electro',
    artifacts_7_2: 'Thunder Metal',
    artifacts_7_3: '',
    artifacts_7_app: 3.02,
    artifacts_7_round_sd: 165,
    artifacts_7_round_da: 20334,
    artifacts_8: 'Thunder Metal, Hormone Punk',
    artifacts_8_1: 'Thunder Metal',
    artifacts_8_2: 'Hormone Punk',
    artifacts_8_3: '',
    artifacts_8_app: 2.33,
    artifacts_8_round_sd: 178,
    artifacts_8_round_da: 21709,
    artifacts_9: 'Hormone Punk, Thunder Metal',
    artifacts_9_1: 'Hormone Punk',
    artifacts_9_2: 'Thunder Metal',
    artifacts_9_3: '',
    artifacts_9_app: 2.12,
    artifacts_9_round_sd: 167,
    artifacts_9_round_da: 21774,
    artifacts_10: '',
    artifacts_10_1: '',
    artifacts_10_2: '',
    artifacts_10_3: '',
    artifacts_10_app: 0,
    artifacts_10_round_sd: 600,
    artifacts_10_round_da: 0,
    drive_slot_4_1: 'CRIT DMG',
    drive_slot_4_1_app: 73.07,
    drive_slot_4_2: 'CRIT Rate',
    drive_slot_4_2_app: 18.01,
    drive_slot_4_3: 'Percent ATK',
    drive_slot_4_3_app: 8.26,
    drive_slot_5_1: 'Electric DMG Bonus',
    drive_slot_5_1_app: 64.63,
    drive_slot_5_2: 'Percent ATK',
    drive_slot_5_2_app: 21.82,
    drive_slot_5_3: 'PEN Ratio',
    drive_slot_5_3_app: 13.39,
    drive_slot_6_1: 'Percent ATK',
    drive_slot_6_1_app: 98.84,
    drive_slot_6_2: 'Anomaly Mastery',
    drive_slot_6_2_app: 0.5,
    drive_slot_6_3: '',
    drive_slot_6_3_app: 0.33,
    char_level: 59.95,
    w_engine_level: 59.32,
    basic_atk: 10.36,
    special_atk: 10.89,
    dash: 11.64,
    ultimate: 11.34,
    core_skill: 6.96,
    assist: 8.67,
    base_hp: 10633.34,
    base_atk: 2939.2,
    base_def: 914.47,
    base_impact: 90.05,
    crit_rate: 57.08,
    crit_dmg: 174.6,
    anomaly_mastery: 80.12,
    anomaly_proficiency: 123.41,
    pen_ratio: 3.5,
    pen: 30.42,
    base_energy_regen: 120.42,
    dmg_bonus: 26.28,
    percent_hp_sub: 9.46,
    percent_atk_sub: 16.56,
    percent_def_sub: 15.35,
    crit_rate_sub: 25.41,
    crit_dmg_sub: 55.3,
    pen_sub: 30.42,
    anomaly_proficiency_sub: 28.41
  },
  {
    char: 'miyabi',
    app_rate_sd: 77.17,
    app_rate_sd_e1: 33.45,
    app_rate_sd_s0: 3.72,
    avg_round_sd: 97,
    avg_round_sd_e1: 77,
    avg_round_sd_s0: 115,
    sample_sd: 3712,
    sample_size_players_sd: 2953,
    app_rate_da: 90.09,
    app_rate_da_e1: 35,
    app_rate_da_s0: 5.64,
    avg_round_da: 26861,
    avg_round_da_e1: 35815,
    avg_round_da_s0: 22025,
    app_rate_da_boss_1: 9.71,
    avg_round_da_boss_1: 29729,
    app_rate_da_boss_2: 91.46,
    avg_round_da_boss_2: 26515,
    app_rate_da_boss_3: 0.46,
    avg_round_da_boss_3: 27602,
    sample_da: 5271,
    sample_size_players_da: 3943,
    app_0: 63.09,
    round_0_sd: 97,
    round_0_da: 26861,
    app_1: 8.9,
    round_1_sd: 91,
    round_1_da: 29663,
    app_2: 18.06,
    round_2_sd: 77,
    round_2_da: 35123,
    app_3: 3.62,
    round_3_sd: 76,
    round_3_da: 36096,
    app_4: 0.94,
    round_4_sd: 73,
    round_4_da: 35291,
    app_5: 0.28,
    round_5_sd: 79,
    round_5_da: 36637,
    app_6: 5.12,
    round_6_sd: 53,
    round_6_da: 49607,
    cons_avg: 0.92,
    weapons_1: 'Hailstorm Shrine',
    weapons_1_app: 92.74,
    weapons_1_round_sd: 95,
    weapons_1_round_da: 27484,
    weapons_2: 'Fusion Compiler',
    weapons_2_app: 2.11,
    weapons_2_round_sd: 107,
    weapons_2_round_da: 22766,
    weapons_3: 'Rainforest Gourmet',
    weapons_3_app: 1.94,
    weapons_3_round_sd: 113,
    weapons_3_round_da: 21628,
    weapons_4: 'Weeping Gemini',
    weapons_4_app: 1,
    weapons_4_round_sd: 129,
    weapons_4_round_da: 21953,
    weapons_5: 'Roaring Ride',
    weapons_5_app: 0.72,
    weapons_5_round_sd: 135,
    weapons_5_round_da: 21736,
    weapons_6: 'Electro-Lip Gloss',
    weapons_6_app: 0.62,
    weapons_6_round_sd: 118,
    weapons_6_round_da: 21334,
    weapons_7: 'Steel Cushion',
    weapons_7_app: 0.32,
    weapons_7_round_sd: 108,
    weapons_7_round_da: 26663,
    weapons_8: 'Cannon Rotor',
    weapons_8_app: 0.12,
    weapons_8_round_sd: 106,
    weapons_8_round_da: 21834,
    weapons_9: 'Marcato Desire',
    weapons_9_app: 0.09,
    weapons_9_round_sd: 600,
    weapons_9_round_da: 20071,
    weapons_10: 'Deep Sea Visitor',
    weapons_10_app: 0.05,
    weapons_10_round_sd: 131,
    weapons_10_round_da: 0,
    artifacts_1: 'Branch & Blade Song, Woodpecker Electro',
    artifacts_1_1: 'Branch & Blade Song',
    artifacts_1_2: 'Woodpecker Electro',
    artifacts_1_3: '',
    artifacts_1_app: 73.45,
    artifacts_1_round_sd: 98,
    artifacts_1_round_da: 26513,
    artifacts_2: 'Branch & Blade Song, Polar Metal',
    artifacts_2_1: 'Branch & Blade Song',
    artifacts_2_2: 'Polar Metal',
    artifacts_2_3: '',
    artifacts_2_app: 14.19,
    artifacts_2_round_sd: 95,
    artifacts_2_round_da: 26973,
    artifacts_3: 'Branch & Blade Song, Astral Voice',
    artifacts_3_1: 'Branch & Blade Song',
    artifacts_3_2: 'Astral Voice',
    artifacts_3_3: '',
    artifacts_3_app: 7.13,
    artifacts_3_round_sd: 88,
    artifacts_3_round_da: 29431,
    artifacts_4: 'Branch & Blade Song, Hormone Punk',
    artifacts_4_1: 'Branch & Blade Song',
    artifacts_4_2: 'Hormone Punk',
    artifacts_4_3: '',
    artifacts_4_app: 1.72,
    artifacts_4_round_sd: 78,
    artifacts_4_round_da: 32611,
    artifacts_5: 'Branch & Blade Song, Puffer Electro',
    artifacts_5_1: 'Branch & Blade Song',
    artifacts_5_2: 'Puffer Electro',
    artifacts_5_3: '',
    artifacts_5_app: 1.52,
    artifacts_5_round_sd: 81,
    artifacts_5_round_da: 31006,
    artifacts_6: 'Branch & Blade Song, Flex',
    artifacts_6_1: 'Branch & Blade Song',
    artifacts_6_2: 'Flex',
    artifacts_6_3: '',
    artifacts_6_app: 0.56,
    artifacts_6_round_sd: 115,
    artifacts_6_round_da: 27393,
    artifacts_7: "Branch & Blade Song, Phaethon's Melody",
    artifacts_7_1: 'Branch & Blade Song',
    artifacts_7_2: "Phaethon's Melody",
    artifacts_7_3: '',
    artifacts_7_app: 0.4,
    artifacts_7_round_sd: 75,
    artifacts_7_round_da: 31706,
    artifacts_8: 'Branch & Blade Song, Freedom Blues',
    artifacts_8_1: 'Branch & Blade Song',
    artifacts_8_2: 'Freedom Blues',
    artifacts_8_3: '',
    artifacts_8_app: 0.24,
    artifacts_8_round_sd: 88,
    artifacts_8_round_da: 26264,
    artifacts_9: 'Branch & Blade Song, Woodpecker Electro, Flex',
    artifacts_9_1: 'Branch & Blade Song',
    artifacts_9_2: 'Woodpecker Electro',
    artifacts_9_3: 'Flex',
    artifacts_9_app: 0.13,
    artifacts_9_round_sd: 600,
    artifacts_9_round_da: 25864,
    artifacts_10: 'Woodpecker Electro, Branch & Blade Song',
    artifacts_10_1: 'Woodpecker Electro',
    artifacts_10_2: 'Branch & Blade Song',
    artifacts_10_3: '',
    artifacts_10_app: 0.05,
    artifacts_10_round_sd: 132,
    artifacts_10_round_da: 0,
    drive_slot_4_1: 'CRIT Rate',
    drive_slot_4_1_app: 52.61,
    drive_slot_4_2: 'CRIT DMG',
    drive_slot_4_2_app: 41.51,
    drive_slot_4_3: 'Percent ATK',
    drive_slot_4_3_app: 5.62,
    drive_slot_5_1: 'Ice DMG Bonus',
    drive_slot_5_1_app: 71.68,
    drive_slot_5_2: 'Percent ATK',
    drive_slot_5_2_app: 22.19,
    drive_slot_5_3: 'PEN Ratio',
    drive_slot_5_3_app: 5.94,
    drive_slot_6_1: 'Percent ATK',
    drive_slot_6_1_app: 93.42,
    drive_slot_6_2: 'Anomaly Mastery',
    drive_slot_6_2_app: 5.96,
    drive_slot_6_3: 'Energy Regen',
    drive_slot_6_3_app: 0.48,
    char_level: 59.99,
    w_engine_level: 59.95,
    basic_atk: 11.91,
    special_atk: 11.58,
    dash: 9.76,
    ultimate: 11.78,
    core_skill: 6.99,
    assist: 10.05,
    base_hp: 10863.64,
    base_atk: 2848.74,
    base_def: 912.7,
    base_impact: 86.01,
    crit_rate: 74.04,
    crit_dmg: 142.11,
    anomaly_mastery: 118.06,
    anomaly_proficiency: 273.05,
    pen_ratio: 1.92,
    pen: 29.46,
    base_energy_regen: 120.38,
    dmg_bonus: 22.97,
    percent_hp_sub: 9.17,
    percent_atk_sub: 15.18,
    percent_def_sub: 13.91,
    crit_rate_sub: 27.62,
    crit_dmg_sub: 56.21,
    pen_sub: 29.46,
    anomaly_proficiency_sub: 33.58
  },
  {
    char: 'astra-yao',
    app_rate_sd: 82.66,
    app_rate_sd_e1: 27.07,
    app_rate_sd_s0: 12.79,
    avg_round_sd: 112,
    avg_round_sd_e1: 80,
    avg_round_sd_s0: 137,
    sample_sd: 3976,
    sample_size_players_sd: 2261,
    app_rate_da: 78.23,
    app_rate_da_e1: 23.47,
    app_rate_da_s0: 16.61,
    avg_round_da: 30369,
    avg_round_da_e1: 41264,
    avg_round_da_s0: 26502,
    app_rate_da_boss_1: 34.99,
    avg_round_da_boss_1: 30782,
    app_rate_da_boss_2: 18.93,
    avg_round_da_boss_2: 30076,
    app_rate_da_boss_3: 30.83,
    avg_round_da_boss_3: 30065,
    sample_da: 4577,
    sample_size_players_da: 2623,
    app_0: 86.24,
    round_0_sd: 112,
    round_0_da: 30369,
    app_1: 10.33,
    round_1_sd: 84,
    round_1_da: 41383,
    app_2: 2.53,
    round_2_sd: 69,
    round_2_da: 49650,
    app_3: 0.2,
    round_3_sd: 74,
    round_3_da: 39811,
    app_4: 0.08,
    round_4_sd: 59,
    round_4_da: 52223,
    app_5: 1,
    round_5_sd: 600,
    round_5_da: 0,
    app_6: 0.62,
    round_6_sd: 42,
    round_6_da: 60822,
    cons_avg: 0.2,
    weapons_1: 'Bashful Demon',
    weapons_1_app: 36.82,
    weapons_1_round_sd: 111,
    weapons_1_round_da: 30052,
    weapons_2: 'Elegant Vanity',
    weapons_2_app: 26.59,
    weapons_2_round_sd: 106,
    weapons_2_round_da: 32548,
    weapons_3: 'Kaboom the Cannon',
    weapons_3_app: 22.64,
    weapons_3_round_sd: 110,
    weapons_3_round_da: 31247,
    weapons_4: 'The Vault',
    weapons_4_app: 10.17,
    weapons_4_round_sd: 124,
    weapons_4_round_da: 27482,
    weapons_5: 'Slice of Time',
    weapons_5_app: 1.23,
    weapons_5_round_sd: 144,
    weapons_5_round_da: 24899,
    weapons_6: 'Weeping Cradle',
    weapons_6_app: 0.92,
    weapons_6_round_sd: 117,
    weapons_6_round_da: 29049,
    weapons_7: 'Unfettered Game Ball',
    weapons_7_app: 0.79,
    weapons_7_round_sd: 116,
    weapons_7_round_da: 27411,
    weapons_8: '[Reverb] Mark II',
    weapons_8_app: 0.11,
    weapons_8_round_sd: 99,
    weapons_8_round_da: 29698,
    weapons_9: 'Starlight Engine',
    weapons_9_app: 0.03,
    weapons_9_round_sd: 600,
    weapons_9_round_da: 0,
    weapons_10: '[Reverb] Mark I',
    weapons_10_app: 0.03,
    weapons_10_round_sd: 600,
    weapons_10_round_da: 25361,
    artifacts_1: 'Astral Voice, Swing Jazz',
    artifacts_1_1: 'Astral Voice',
    artifacts_1_2: 'Swing Jazz',
    artifacts_1_3: '',
    artifacts_1_app: 85.51,
    artifacts_1_round_sd: 111,
    artifacts_1_round_da: 30566,
    artifacts_2: 'Astral Voice, Hormone Punk',
    artifacts_2_1: 'Astral Voice',
    artifacts_2_2: 'Hormone Punk',
    artifacts_2_3: '',
    artifacts_2_app: 12.4,
    artifacts_2_round_sd: 116,
    artifacts_2_round_da: 29505,
    artifacts_3: 'Astral Voice, Flex',
    artifacts_3_1: 'Astral Voice',
    artifacts_3_2: 'Flex',
    artifacts_3_3: '',
    artifacts_3_app: 0.57,
    artifacts_3_round_sd: 122,
    artifacts_3_round_da: 26231,
    artifacts_4: 'Swing Jazz, Astral Voice',
    artifacts_4_1: 'Swing Jazz',
    artifacts_4_2: 'Astral Voice',
    artifacts_4_3: '',
    artifacts_4_app: 0.3,
    artifacts_4_round_sd: 116,
    artifacts_4_round_da: 30989,
    artifacts_5: 'Astral Voice, Branch & Blade Song',
    artifacts_5_1: 'Astral Voice',
    artifacts_5_2: 'Branch & Blade Song',
    artifacts_5_3: '',
    artifacts_5_app: 0.17,
    artifacts_5_round_sd: 600,
    artifacts_5_round_da: 22317,
    artifacts_6: 'ATK +10%, Swing Jazz, Flex',
    artifacts_6_1: 'ATK +10%',
    artifacts_6_2: 'Swing Jazz',
    artifacts_6_3: 'Flex',
    artifacts_6_app: 0.17,
    artifacts_6_round_sd: 130,
    artifacts_6_round_da: 27762,
    artifacts_7: 'Astral Voice, Woodpecker Electro',
    artifacts_7_1: 'Astral Voice',
    artifacts_7_2: 'Woodpecker Electro',
    artifacts_7_3: '',
    artifacts_7_app: 0.12,
    artifacts_7_round_sd: 138,
    artifacts_7_round_da: 30726,
    artifacts_8: 'Astral Voice, Chaotic Metal',
    artifacts_8_1: 'Astral Voice',
    artifacts_8_2: 'Chaotic Metal',
    artifacts_8_3: '',
    artifacts_8_app: 0.11,
    artifacts_8_round_sd: 90,
    artifacts_8_round_da: 26509,
    artifacts_9: 'Astral Voice, Freedom Blues',
    artifacts_9_1: 'Astral Voice',
    artifacts_9_2: 'Freedom Blues',
    artifacts_9_3: '',
    artifacts_9_app: 0.05,
    artifacts_9_round_sd: 600,
    artifacts_9_round_da: 31947,
    artifacts_10: 'Astral Voice, Chaos Jazz',
    artifacts_10_1: 'Astral Voice',
    artifacts_10_2: 'Chaos Jazz',
    artifacts_10_3: '',
    artifacts_10_app: 0.04,
    artifacts_10_round_sd: 76,
    artifacts_10_round_da: 0,
    drive_slot_4_1: 'Percent ATK',
    drive_slot_4_1_app: 94.57,
    drive_slot_4_2: 'CRIT Rate',
    drive_slot_4_2_app: 3.29,
    drive_slot_4_3: 'CRIT DMG',
    drive_slot_4_3_app: 1.06,
    drive_slot_5_1: 'Percent ATK',
    drive_slot_5_1_app: 97.84,
    drive_slot_5_2: 'Ether DMG Bonus',
    drive_slot_5_2_app: 1.66,
    drive_slot_5_3: 'PEN Ratio',
    drive_slot_5_3_app: 0.29,
    drive_slot_6_1: 'Energy Regen',
    drive_slot_6_1_app: 78,
    drive_slot_6_2: 'Percent ATK',
    drive_slot_6_2_app: 21.55,
    drive_slot_6_3: 'Anomaly Mastery',
    drive_slot_6_3_app: 0.27,
    char_level: 59.99,
    w_engine_level: 59.26,
    basic_atk: 5.34,
    special_atk: 11.77,
    dash: 4.9,
    ultimate: 11.15,
    core_skill: 6.96,
    assist: 7.28,
    base_hp: 12273,
    base_atk: 3420.67,
    base_def: 951.7,
    base_impact: 83,
    crit_rate: 19.45,
    crit_dmg: 76.95,
    anomaly_mastery: 93.07,
    anomaly_proficiency: 131.75,
    pen_ratio: 0.39,
    pen: 33.91,
    base_energy_regen: 278.82,
    dmg_bonus: 0.5,
    percent_hp_sub: 12.56,
    percent_atk_sub: 26.29,
    percent_def_sub: 19.49,
    crit_rate_sub: 13.65,
    crit_dmg_sub: 26.39,
    pen_sub: 33.91,
    anomaly_proficiency_sub: 38.83
  },
  {
    char: 'evelyn',
    app_rate_sd: 14.57,
    app_rate_sd_e1: 3.78,
    app_rate_sd_s0: 2.02,
    avg_round_sd: 141,
    avg_round_sd_e1: 104,
    avg_round_sd_s0: 173,
    sample_sd: 701,
    sample_size_players_sd: 515,
    app_rate_da: 24.12,
    app_rate_da_e1: 5.49,
    app_rate_da_s0: 5.11,
    avg_round_da: 27991,
    avg_round_da_e1: 40257,
    avg_round_da_s0: 23245,
    app_rate_da_boss_1: 18.19,
    avg_round_da_boss_1: 29315,
    app_rate_da_boss_2: 1.92,
    avg_round_da_boss_2: 18297,
    app_rate_da_boss_3: 5.69,
    avg_round_da_boss_3: 26253,
    sample_da: 1411,
    sample_size_players_da: 999,
    app_0: 86.99,
    round_0_sd: 141,
    round_0_da: 27991,
    app_1: 7.08,
    round_1_sd: 109,
    round_1_da: 36188,
    app_2: 2.7,
    round_2_sd: 96,
    round_2_da: 44599,
    app_3: 0.95,
    round_3_sd: 73,
    round_3_da: 48115,
    app_4: 0.29,
    round_4_sd: 81,
    round_4_da: 50167,
    app_5: 0.24,
    round_5_sd: 41,
    round_5_da: 57083,
    app_6: 1.77,
    round_6_sd: 64,
    round_6_da: 57695,
    cons_avg: 0.28,
    weapons_1: 'Heartstring Nocturne',
    weapons_1_app: 70.56,
    weapons_1_round_sd: 129,
    weapons_1_round_da: 30159,
    weapons_2: 'Marcato Desire',
    weapons_2_app: 17.14,
    weapons_2_round_sd: 171,
    weapons_2_round_da: 24347,
    weapons_3: 'The Brimstone',
    weapons_3_app: 5.87,
    weapons_3_round_sd: 164,
    weapons_3_round_da: 23854,
    weapons_4: 'Starlight Engine',
    weapons_4_app: 2.61,
    weapons_4_round_sd: 170,
    weapons_4_round_da: 24993,
    weapons_5: 'Steel Cushion',
    weapons_5_app: 0.87,
    weapons_5_round_sd: 175,
    weapons_5_round_da: 24044,
    weapons_6: 'Gilded Blossom',
    weapons_6_app: 0.7,
    weapons_6_round_sd: 180,
    weapons_6_round_da: 23759,
    weapons_7: 'Cannon Rotor',
    weapons_7_app: 0.61,
    weapons_7_round_sd: 169,
    weapons_7_round_da: 22486,
    weapons_8: 'Zanshin Herb Case',
    weapons_8_app: 0.42,
    weapons_8_round_sd: 103,
    weapons_8_round_da: 28560,
    weapons_9: 'Riot Suppressor Mark VI',
    weapons_9_app: 0.17,
    weapons_9_round_sd: 600,
    weapons_9_round_da: 18118,
    weapons_10: 'Severed Innocence',
    weapons_10_app: 0.11,
    weapons_10_round_sd: 160,
    weapons_10_round_da: 0,
    artifacts_1: 'Woodpecker Electro, Branch & Blade Song',
    artifacts_1_1: 'Woodpecker Electro',
    artifacts_1_2: 'Branch & Blade Song',
    artifacts_1_3: '',
    artifacts_1_app: 51.13,
    artifacts_1_round_sd: 144,
    artifacts_1_round_da: 27431,
    artifacts_2: 'Woodpecker Electro, Inferno Metal',
    artifacts_2_1: 'Woodpecker Electro',
    artifacts_2_2: 'Inferno Metal',
    artifacts_2_3: '',
    artifacts_2_app: 16.08,
    artifacts_2_round_sd: 146,
    artifacts_2_round_da: 27908,
    artifacts_3: 'Woodpecker Electro, Puffer Electro',
    artifacts_3_1: 'Woodpecker Electro',
    artifacts_3_2: 'Puffer Electro',
    artifacts_3_3: '',
    artifacts_3_app: 4.42,
    artifacts_3_round_sd: 119,
    artifacts_3_round_da: 33673,
    artifacts_4: 'Branch & Blade Song, Inferno Metal, Woodpecker Electro',
    artifacts_4_1: 'Branch & Blade Song',
    artifacts_4_2: 'Inferno Metal',
    artifacts_4_3: 'Woodpecker Electro',
    artifacts_4_app: 1.92,
    artifacts_4_round_sd: 147,
    artifacts_4_round_da: 29127,
    artifacts_5: 'Inferno Metal, Branch & Blade Song',
    artifacts_5_1: 'Inferno Metal',
    artifacts_5_2: 'Branch & Blade Song',
    artifacts_5_3: '',
    artifacts_5_app: 1.83,
    artifacts_5_round_sd: 159,
    artifacts_5_round_da: 21425,
    artifacts_6: 'Hormone Punk, Inferno Metal',
    artifacts_6_1: 'Hormone Punk',
    artifacts_6_2: 'Inferno Metal',
    artifacts_6_3: '',
    artifacts_6_app: 1.83,
    artifacts_6_round_sd: 129,
    artifacts_6_round_da: 29842,
    artifacts_7: 'Branch & Blade Song, Woodpecker Electro, Inferno Metal',
    artifacts_7_1: 'Branch & Blade Song',
    artifacts_7_2: 'Woodpecker Electro',
    artifacts_7_3: 'Inferno Metal',
    artifacts_7_app: 1.78,
    artifacts_7_round_sd: 159,
    artifacts_7_round_da: 25295,
    artifacts_8: 'Puffer Electro, Branch & Blade Song',
    artifacts_8_1: 'Puffer Electro',
    artifacts_8_2: 'Branch & Blade Song',
    artifacts_8_3: '',
    artifacts_8_app: 1.52,
    artifacts_8_round_sd: 134,
    artifacts_8_round_da: 29803,
    artifacts_9: 'ATK +10%, Branch & Blade Song, Woodpecker Electro',
    artifacts_9_1: 'ATK +10%',
    artifacts_9_2: 'Branch & Blade Song',
    artifacts_9_3: 'Woodpecker Electro',
    artifacts_9_app: 1.51,
    artifacts_9_round_sd: 159,
    artifacts_9_round_da: 30376,
    artifacts_10: '',
    artifacts_10_1: '',
    artifacts_10_2: '',
    artifacts_10_3: '',
    artifacts_10_app: 0,
    artifacts_10_round_sd: 600,
    artifacts_10_round_da: 0,
    drive_slot_4_1: 'CRIT DMG',
    drive_slot_4_1_app: 94.71,
    drive_slot_4_2: 'CRIT Rate',
    drive_slot_4_2_app: 4.03,
    drive_slot_4_3: 'Percent ATK',
    drive_slot_4_3_app: 0.99,
    drive_slot_5_1: 'Fire DMG Bonus',
    drive_slot_5_1_app: 69.08,
    drive_slot_5_2: 'PEN Ratio',
    drive_slot_5_2_app: 19.99,
    drive_slot_5_3: 'Percent ATK',
    drive_slot_5_3_app: 10.67,
    drive_slot_6_1: 'Percent ATK',
    drive_slot_6_1_app: 98.83,
    drive_slot_6_2: '',
    drive_slot_6_2_app: 0.26,
    drive_slot_6_3: 'Energy Regen',
    drive_slot_6_3_app: 0.25,
    char_level: 59.98,
    w_engine_level: 59.69,
    basic_atk: 11.36,
    special_atk: 11.22,
    dash: 8.2,
    ultimate: 11.82,
    core_skill: 6.97,
    assist: 9.58,
    base_hp: 11071.52,
    base_atk: 2855.64,
    base_def: 929.8,
    base_impact: 93.04,
    crit_rate: 72.86,
    crit_dmg: 161.94,
    anomaly_mastery: 92.07,
    anomaly_proficiency: 117.77,
    pen_ratio: 6.01,
    pen: 33.21,
    base_energy_regen: 120.41,
    dmg_bonus: 23.66,
    percent_hp_sub: 9.99,
    percent_atk_sub: 16.71,
    percent_def_sub: 15.4,
    crit_rate_sub: 24.33,
    crit_dmg_sub: 55.19,
    pen_sub: 33.21,
    anomaly_proficiency_sub: 27.77
  },
  {
    char: 'pulchra',
    app_rate_sd: 6.32,
    app_rate_sd_e1: 1.46,
    app_rate_sd_s0: 1.06,
    avg_round_sd: 174,
    avg_round_sd_e1: 132,
    avg_round_sd_s0: 210,
    sample_sd: 304,
    sample_size_players_sd: 29,
    app_rate_da: 9.66,
    app_rate_da_e1: 1.66,
    app_rate_da_s0: 2.22,
    avg_round_da: 20789,
    avg_round_da_e1: 28135,
    avg_round_da_s0: 17049,
    app_rate_da_boss_1: 1.23,
    avg_round_da_boss_1: 19736,
    app_rate_da_boss_2: 0.39,
    avg_round_da_boss_2: 0,
    app_rate_da_boss_3: 8.81,
    avg_round_da_boss_3: 21105,
    sample_da: 565,
    sample_size_players_da: 44,
    app_0: 4.3,
    round_0_sd: 190,
    round_0_da: 17581,
    app_1: 8.21,
    round_1_sd: 197,
    round_1_da: 17484,
    app_2: 10.26,
    round_2_sd: 184,
    round_2_da: 20122,
    app_3: 8.76,
    round_3_sd: 191,
    round_3_da: 18926,
    app_4: 8.1,
    round_4_sd: 192,
    round_4_da: 17172,
    app_5: 7.98,
    round_5_sd: 169,
    round_5_da: 19256,
    app_6: 52.39,
    round_6_sd: 164,
    round_6_da: 23321,
    cons_avg: 4.42,
    weapons_1: 'Box Cutter',
    weapons_1_app: 73.6,
    weapons_1_round_sd: 169,
    weapons_1_round_da: 21718,
    weapons_2: 'Steam Oven',
    weapons_2_app: 13.19,
    weapons_2_round_sd: 196,
    weapons_2_round_da: 19281,
    weapons_3: 'Precious Fossilized Core',
    weapons_3_app: 4.38,
    weapons_3_round_sd: 207,
    weapons_3_round_da: 15630,
    weapons_4: 'Hellfire Gears',
    weapons_4_app: 3.19,
    weapons_4_round_sd: 175,
    weapons_4_round_da: 19366,
    weapons_5: 'The Restrained',
    weapons_5_app: 1.53,
    weapons_5_round_sd: 179,
    weapons_5_round_da: 20058,
    weapons_6: 'Six Shooter',
    weapons_6_app: 1.06,
    weapons_6_round_sd: 147,
    weapons_6_round_da: 19824,
    weapons_7: '[Vortex] Arrow',
    weapons_7_app: 0.69,
    weapons_7_round_sd: 190,
    weapons_7_round_da: 15104,
    weapons_8: 'Demara Battery Mark II',
    weapons_8_app: 0.67,
    weapons_8_round_sd: 167,
    weapons_8_round_da: 15000,
    weapons_9: 'Steel Cushion',
    weapons_9_app: 0.21,
    weapons_9_round_sd: 600,
    weapons_9_round_da: 20680,
    weapons_10: 'Cannon Rotor',
    weapons_10_app: 0.13,
    weapons_10_round_sd: 600,
    weapons_10_round_da: 0,
    artifacts_1: 'Shadow Harmony, Shockstar Disco',
    artifacts_1_1: 'Shadow Harmony',
    artifacts_1_2: 'Shockstar Disco',
    artifacts_1_3: '',
    artifacts_1_app: 44.96,
    artifacts_1_round_sd: 184,
    artifacts_1_round_da: 19982,
    artifacts_2: 'Astral Voice, Shockstar Disco',
    artifacts_2_1: 'Astral Voice',
    artifacts_2_2: 'Shockstar Disco',
    artifacts_2_3: '',
    artifacts_2_app: 27.14,
    artifacts_2_round_sd: 170,
    artifacts_2_round_da: 22216,
    artifacts_3: 'Proto Punk, Shockstar Disco',
    artifacts_3_1: 'Proto Punk',
    artifacts_3_2: 'Shockstar Disco',
    artifacts_3_3: '',
    artifacts_3_app: 6.49,
    artifacts_3_round_sd: 153,
    artifacts_3_round_da: 23492,
    artifacts_4: 'Shadow Harmony, Woodpecker Electro',
    artifacts_4_1: 'Shadow Harmony',
    artifacts_4_2: 'Woodpecker Electro',
    artifacts_4_3: '',
    artifacts_4_app: 6.48,
    artifacts_4_round_sd: 166,
    artifacts_4_round_da: 20320,
    artifacts_5: 'Astral Voice, Shadow Harmony',
    artifacts_5_1: 'Astral Voice',
    artifacts_5_2: 'Shadow Harmony',
    artifacts_5_3: '',
    artifacts_5_app: 1.27,
    artifacts_5_round_sd: 156,
    artifacts_5_round_da: 23124,
    artifacts_6: 'Swing Jazz, Shockstar Disco',
    artifacts_6_1: 'Swing Jazz',
    artifacts_6_2: 'Shockstar Disco',
    artifacts_6_3: '',
    artifacts_6_app: 1.25,
    artifacts_6_round_sd: 153,
    artifacts_6_round_da: 23449,
    artifacts_7: 'Shadow Harmony, Shockstar Disco, Flex',
    artifacts_7_1: 'Shadow Harmony',
    artifacts_7_2: 'Shockstar Disco',
    artifacts_7_3: 'Flex',
    artifacts_7_app: 1.12,
    artifacts_7_round_sd: 183,
    artifacts_7_round_da: 18541,
    artifacts_8: 'Shockstar Disco, Shadow Harmony',
    artifacts_8_1: 'Shockstar Disco',
    artifacts_8_2: 'Shadow Harmony',
    artifacts_8_3: '',
    artifacts_8_app: 0.54,
    artifacts_8_round_sd: 600,
    artifacts_8_round_da: 17088,
    artifacts_9: 'Shadow Harmony, Flex',
    artifacts_9_1: 'Shadow Harmony',
    artifacts_9_2: 'Flex',
    artifacts_9_3: '',
    artifacts_9_app: 0.54,
    artifacts_9_round_sd: 600,
    artifacts_9_round_da: 17952,
    artifacts_10: 'Shadow Harmony, Swing Jazz',
    artifacts_10_1: 'Shadow Harmony',
    artifacts_10_2: 'Swing Jazz',
    artifacts_10_3: '',
    artifacts_10_app: 0.39,
    artifacts_10_round_sd: 142,
    artifacts_10_round_da: 0,
    drive_slot_4_1: 'CRIT Rate',
    drive_slot_4_1_app: 75.32,
    drive_slot_4_2: 'CRIT DMG',
    drive_slot_4_2_app: 13.71,
    drive_slot_4_3: 'Anomaly Proficiency',
    drive_slot_4_3_app: 6.85,
    drive_slot_5_1: 'Physical DMG Bonus',
    drive_slot_5_1_app: 54.8,
    drive_slot_5_2: 'Percent ATK',
    drive_slot_5_2_app: 37,
    drive_slot_5_3: 'PEN Ratio',
    drive_slot_5_3_app: 5.46,
    drive_slot_6_1: 'Impact',
    drive_slot_6_1_app: 91.78,
    drive_slot_6_2: 'Percent ATK',
    drive_slot_6_2_app: 5.48,
    drive_slot_6_3: 'Energy Regen',
    drive_slot_6_3_app: 2.73,
    char_level: 60,
    w_engine_level: 59.32,
    basic_atk: 5.67,
    special_atk: 10.73,
    dash: 5.66,
    ultimate: 9.48,
    core_skill: 6.81,
    assist: 9.92,
    base_hp: 10970.22,
    base_atk: 2053.81,
    base_def: 943.84,
    base_impact: 182.73,
    crit_rate: 47.46,
    crit_dmg: 99.04,
    anomaly_mastery: 92,
    anomaly_proficiency: 132.33,
    pen_ratio: 1.31,
    pen: 33.28,
    base_energy_regen: 128.06,
    dmg_bonus: 16.71,
    percent_hp_sub: 11.34,
    percent_atk_sub: 15,
    percent_def_sub: 18.87,
    crit_rate_sub: 23.6,
    crit_dmg_sub: 42.47,
    pen_sub: 33.28,
    anomaly_proficiency_sub: 36.01
  },
  {
    char: 'anby-demara-soldier-0',
    app_rate_sd: 34.18,
    app_rate_sd_e1: 8.42,
    app_rate_sd_s0: 4.95,
    avg_round_sd: 144,
    avg_round_sd_e1: 110,
    avg_round_sd_s0: 174,
    sample_sd: 1644,
    sample_size_players_sd: 1032,
    app_rate_da: 37.81,
    app_rate_da_e1: 8.53,
    app_rate_da_s0: 6.72,
    avg_round_da: 26549,
    avg_round_da_e1: 37453,
    avg_round_da_s0: 20687,
    app_rate_da_boss_1: 1.03,
    avg_round_da_boss_1: 25837,
    app_rate_da_boss_2: 0.31,
    avg_round_da_boss_2: 0,
    app_rate_da_boss_3: 39.49,
    avg_round_da_boss_3: 26622,
    sample_da: 2212,
    sample_size_players_da: 1212,
    app_0: 87.38,
    round_0_sd: 144,
    round_0_da: 26549,
    app_1: 6.76,
    round_1_sd: 123,
    round_1_da: 32103,
    app_2: 4.17,
    round_2_sd: 90,
    round_2_da: 45604,
    app_3: 0.32,
    round_3_sd: 129,
    round_3_da: 34831,
    app_4: 0.1,
    round_4_sd: 83,
    round_4_da: 39840,
    app_5: 0.06,
    round_5_sd: 105,
    round_5_da: 0,
    app_6: 1.25,
    round_6_sd: 55,
    round_6_da: 54671,
    cons_avg: 0.24,
    weapons_1: 'Severed Innocence',
    weapons_1_app: 69.3,
    weapons_1_round_sd: 136,
    weapons_1_round_da: 28997,
    weapons_2: 'Marcato Desire',
    weapons_2_app: 14.22,
    weapons_2_round_sd: 166,
    weapons_2_round_da: 21753,
    weapons_3: 'Starlight Engine',
    weapons_3_app: 4.38,
    weapons_3_round_sd: 161,
    weapons_3_round_da: 21515,
    weapons_4: 'The Brimstone',
    weapons_4_app: 3.58,
    weapons_4_round_sd: 163,
    weapons_4_round_da: 23255,
    weapons_5: 'Heartstring Nocturne',
    weapons_5_app: 1.79,
    weapons_5_round_sd: 140,
    weapons_5_round_da: 25010,
    weapons_6: 'Cannon Rotor',
    weapons_6_app: 1.6,
    weapons_6_round_sd: 165,
    weapons_6_round_da: 21532,
    weapons_7: 'Zanshin Herb Case',
    weapons_7_app: 1.24,
    weapons_7_round_sd: 139,
    weapons_7_round_da: 24272,
    weapons_8: 'Gilded Blossom',
    weapons_8_app: 1.11,
    weapons_8_round_sd: 165,
    weapons_8_round_da: 20647,
    weapons_9: 'Steel Cushion',
    weapons_9_app: 1.08,
    weapons_9_round_sd: 164,
    weapons_9_round_da: 21582,
    weapons_10: '',
    weapons_10_app: 0,
    weapons_10_round_sd: 600,
    weapons_10_round_da: 0,
    artifacts_1: 'Shadow Harmony, Branch & Blade Song',
    artifacts_1_1: 'Shadow Harmony',
    artifacts_1_2: 'Branch & Blade Song',
    artifacts_1_3: '',
    artifacts_1_app: 46.17,
    artifacts_1_round_sd: 147,
    artifacts_1_round_da: 25795,
    artifacts_2: 'Shadow Harmony, Woodpecker Electro',
    artifacts_2_1: 'Shadow Harmony',
    artifacts_2_2: 'Woodpecker Electro',
    artifacts_2_3: '',
    artifacts_2_app: 45.75,
    artifacts_2_round_sd: 141,
    artifacts_2_round_da: 27293,
    artifacts_3: 'Shadow Harmony, Thunder Metal',
    artifacts_3_1: 'Shadow Harmony',
    artifacts_3_2: 'Thunder Metal',
    artifacts_3_3: '',
    artifacts_3_app: 2.97,
    artifacts_3_round_sd: 147,
    artifacts_3_round_da: 26440,
    artifacts_4: 'Shadow Harmony, Astral Voice',
    artifacts_4_1: 'Shadow Harmony',
    artifacts_4_2: 'Astral Voice',
    artifacts_4_3: '',
    artifacts_4_app: 1.57,
    artifacts_4_round_sd: 122,
    artifacts_4_round_da: 29928,
    artifacts_5: 'Shadow Harmony, Flex',
    artifacts_5_1: 'Shadow Harmony',
    artifacts_5_2: 'Flex',
    artifacts_5_3: '',
    artifacts_5_app: 0.92,
    artifacts_5_round_sd: 138,
    artifacts_5_round_da: 26403,
    artifacts_6: 'Shadow Harmony, Hormone Punk',
    artifacts_6_1: 'Shadow Harmony',
    artifacts_6_2: 'Hormone Punk',
    artifacts_6_3: '',
    artifacts_6_app: 0.64,
    artifacts_6_round_sd: 128,
    artifacts_6_round_da: 27856,
    artifacts_7: 'Shadow Harmony, Puffer Electro',
    artifacts_7_1: 'Shadow Harmony',
    artifacts_7_2: 'Puffer Electro',
    artifacts_7_3: '',
    artifacts_7_app: 0.59,
    artifacts_7_round_sd: 127,
    artifacts_7_round_da: 30443,
    artifacts_8: 'Thunder Metal, Branch & Blade Song',
    artifacts_8_1: 'Thunder Metal',
    artifacts_8_2: 'Branch & Blade Song',
    artifacts_8_3: '',
    artifacts_8_app: 0.23,
    artifacts_8_round_sd: 154,
    artifacts_8_round_da: 24100,
    artifacts_9: 'Thunder Metal, Woodpecker Electro',
    artifacts_9_1: 'Thunder Metal',
    artifacts_9_2: 'Woodpecker Electro',
    artifacts_9_3: '',
    artifacts_9_app: 0.12,
    artifacts_9_round_sd: 600,
    artifacts_9_round_da: 23800,
    artifacts_10: 'Branch & Blade Song, Shadow Harmony, Thunder Metal',
    artifacts_10_1: 'Branch & Blade Song',
    artifacts_10_2: 'Shadow Harmony',
    artifacts_10_3: 'Thunder Metal',
    artifacts_10_app: 0.11,
    artifacts_10_round_sd: 194,
    artifacts_10_round_da: 0,
    drive_slot_4_1: 'CRIT Rate',
    drive_slot_4_1_app: 60.9,
    drive_slot_4_2: 'CRIT DMG',
    drive_slot_4_2_app: 37.54,
    drive_slot_4_3: 'Percent ATK',
    drive_slot_4_3_app: 1.47,
    drive_slot_5_1: 'Electric DMG Bonus',
    drive_slot_5_1_app: 78.03,
    drive_slot_5_2: 'Percent ATK',
    drive_slot_5_2_app: 14.17,
    drive_slot_5_3: 'PEN Ratio',
    drive_slot_5_3_app: 7.62,
    drive_slot_6_1: 'Percent ATK',
    drive_slot_6_1_app: 98.8,
    drive_slot_6_2: 'Energy Regen',
    drive_slot_6_2_app: 0.76,
    drive_slot_6_3: 'Percent DEF',
    drive_slot_6_3_app: 0.27,
    char_level: 59.98,
    w_engine_level: 59.79,
    basic_atk: 11.38,
    special_atk: 11.79,
    dash: 9.36,
    ultimate: 11.34,
    core_skill: 6.99,
    assist: 9.27,
    base_hp: 10900.62,
    base_atk: 2847.73,
    base_def: 924.57,
    base_impact: 93.03,
    crit_rate: 67.07,
    crit_dmg: 171.19,
    anomaly_mastery: 94,
    anomaly_proficiency: 120.37,
    pen_ratio: 1.89,
    pen: 30.28,
    base_energy_regen: 120.57,
    dmg_bonus: 23.76,
    percent_hp_sub: 9.31,
    percent_atk_sub: 16.02,
    percent_def_sub: 14.48,
    crit_rate_sub: 26.5,
    crit_dmg_sub: 57.41,
    pen_sub: 30.28,
    anomaly_proficiency_sub: 27.33
  },
  {
    char: 'trigger',
    app_rate_sd: 42.95,
    app_rate_sd_e1: 12.25,
    app_rate_sd_s0: 5.61,
    avg_round_sd: 139,
    avg_round_sd_e1: 103,
    avg_round_sd_s0: 167,
    sample_sd: 2066,
    sample_size_players_sd: 1026,
    app_rate_da: 45.22,
    app_rate_da_e1: 12.12,
    app_rate_da_s0: 6.85,
    avg_round_da: 27561,
    avg_round_da_e1: 38946,
    avg_round_da_s0: 22152,
    app_rate_da_boss_1: 5.09,
    avg_round_da_boss_1: 27461,
    app_rate_da_boss_2: 2.49,
    avg_round_da_boss_2: 24621,
    app_rate_da_boss_3: 41.3,
    avg_round_da_boss_3: 27676,
    sample_da: 2646,
    sample_size_players_da: 1161,
    app_0: 87.77,
    round_0_sd: 139,
    round_0_da: 27561,
    app_1: 9.89,
    round_1_sd: 97,
    round_1_da: 40509,
    app_2: 1.27,
    round_2_sd: 80,
    round_2_da: 44992,
    app_3: 0.23,
    round_3_sd: 101,
    round_3_da: 50990,
    app_4: 0.04,
    round_4_sd: 600,
    round_4_da: 26923,
    app_5: 0.04,
    round_5_sd: 129,
    round_5_da: 32227,
    app_6: 0.77,
    round_6_sd: 57,
    round_6_da: 57010,
    cons_avg: 0.18,
    weapons_1: 'Spectral Gaze',
    weapons_1_app: 60.74,
    weapons_1_round_sd: 128,
    weapons_1_round_da: 30141,
    weapons_2: 'Precious Fossilized Core',
    weapons_2_app: 13.63,
    weapons_2_round_sd: 154,
    weapons_2_round_da: 24087,
    weapons_3: 'The Restrained',
    weapons_3_app: 10.39,
    weapons_3_round_sd: 148,
    weapons_3_round_da: 26203,
    weapons_4: 'Hellfire Gears',
    weapons_4_app: 4.06,
    weapons_4_round_sd: 155,
    weapons_4_round_da: 23900,
    weapons_5: 'Steam Oven',
    weapons_5_app: 3.94,
    weapons_5_round_sd: 155,
    weapons_5_round_da: 23009,
    weapons_6: 'Demara Battery Mark II',
    weapons_6_app: 2.76,
    weapons_6_round_sd: 160,
    weapons_6_round_da: 22681,
    weapons_7: 'Ice-Jade Teapot',
    weapons_7_app: 1.1,
    weapons_7_round_sd: 141,
    weapons_7_round_da: 28397,
    weapons_8: 'Box Cutter',
    weapons_8_app: 0.84,
    weapons_8_round_sd: 151,
    weapons_8_round_da: 26777,
    weapons_9: 'Steel Cushion',
    weapons_9_app: 0.59,
    weapons_9_round_sd: 148,
    weapons_9_round_da: 28458,
    weapons_10: '',
    weapons_10_app: 0,
    weapons_10_round_sd: 600,
    weapons_10_round_da: 0,
    artifacts_1: 'Shadow Harmony, Woodpecker Electro',
    artifacts_1_1: 'Shadow Harmony',
    artifacts_1_2: 'Woodpecker Electro',
    artifacts_1_3: '',
    artifacts_1_app: 38.17,
    artifacts_1_round_sd: 144,
    artifacts_1_round_da: 26009,
    artifacts_2: 'Shockstar Disco, Woodpecker Electro',
    artifacts_2_1: 'Shockstar Disco',
    artifacts_2_2: 'Woodpecker Electro',
    artifacts_2_3: '',
    artifacts_2_app: 30.88,
    artifacts_2_round_sd: 138,
    artifacts_2_round_da: 28123,
    artifacts_3: 'Shadow Harmony, Shockstar Disco',
    artifacts_3_1: 'Shadow Harmony',
    artifacts_3_2: 'Shockstar Disco',
    artifacts_3_3: '',
    artifacts_3_app: 18.44,
    artifacts_3_round_sd: 129,
    artifacts_3_round_da: 29960,
    artifacts_4: 'Shadow Harmony, Branch & Blade Song',
    artifacts_4_1: 'Shadow Harmony',
    artifacts_4_2: 'Branch & Blade Song',
    artifacts_4_3: '',
    artifacts_4_app: 3.33,
    artifacts_4_round_sd: 131,
    artifacts_4_round_da: 28694,
    artifacts_5: 'Shockstar Disco, Shadow Harmony',
    artifacts_5_1: 'Shockstar Disco',
    artifacts_5_2: 'Shadow Harmony',
    artifacts_5_3: '',
    artifacts_5_app: 2.07,
    artifacts_5_round_sd: 140,
    artifacts_5_round_da: 27994,
    artifacts_6: 'Astral Voice, Woodpecker Electro',
    artifacts_6_1: 'Astral Voice',
    artifacts_6_2: 'Woodpecker Electro',
    artifacts_6_3: '',
    artifacts_6_app: 0.75,
    artifacts_6_round_sd: 122,
    artifacts_6_round_da: 33564,
    artifacts_7: 'Shadow Harmony, Flex',
    artifacts_7_1: 'Shadow Harmony',
    artifacts_7_2: 'Flex',
    artifacts_7_3: '',
    artifacts_7_app: 0.68,
    artifacts_7_round_sd: 171,
    artifacts_7_round_da: 23132,
    artifacts_8: 'Shockstar Disco, Branch & Blade Song',
    artifacts_8_1: 'Shockstar Disco',
    artifacts_8_2: 'Branch & Blade Song',
    artifacts_8_3: '',
    artifacts_8_app: 0.67,
    artifacts_8_round_sd: 138,
    artifacts_8_round_da: 27518,
    artifacts_9: 'Shadow Harmony, Thunder Metal',
    artifacts_9_1: 'Shadow Harmony',
    artifacts_9_2: 'Thunder Metal',
    artifacts_9_3: '',
    artifacts_9_app: 0.64,
    artifacts_9_round_sd: 156,
    artifacts_9_round_da: 26149,
    artifacts_10: '',
    artifacts_10_1: '',
    artifacts_10_2: '',
    artifacts_10_3: '',
    artifacts_10_app: 0,
    artifacts_10_round_sd: 600,
    artifacts_10_round_da: 0,
    drive_slot_4_1: 'CRIT Rate',
    drive_slot_4_1_app: 91.09,
    drive_slot_4_2: 'CRIT DMG',
    drive_slot_4_2_app: 8.26,
    drive_slot_4_3: 'Percent ATK',
    drive_slot_4_3_app: 0.31,
    drive_slot_5_1: 'Electric DMG Bonus',
    drive_slot_5_1_app: 68.85,
    drive_slot_5_2: 'Percent ATK',
    drive_slot_5_2_app: 25.23,
    drive_slot_5_3: 'PEN Ratio',
    drive_slot_5_3_app: 4.77,
    drive_slot_6_1: 'Impact',
    drive_slot_6_1_app: 94.42,
    drive_slot_6_2: 'Percent ATK',
    drive_slot_6_2_app: 4.67,
    drive_slot_6_3: 'Anomaly Mastery',
    drive_slot_6_3_app: 0.22,
    char_level: 59.93,
    w_engine_level: 59.15,
    basic_atk: 11.6,
    special_atk: 10.77,
    dash: 6.68,
    ultimate: 10.67,
    core_skill: 6.94,
    assist: 9.02,
    base_hp: 11293.82,
    base_atk: 2168.77,
    base_def: 927.47,
    base_impact: 162.54,
    crit_rate: 77.79,
    crit_dmg: 97.75,
    anomaly_mastery: 96.09,
    anomaly_proficiency: 126.48,
    pen_ratio: 1.14,
    pen: 31.31,
    base_energy_regen: 121.81,
    dmg_bonus: 20.75,
    percent_hp_sub: 10.73,
    percent_atk_sub: 15.66,
    percent_def_sub: 16.64,
    crit_rate_sub: 28.06,
    crit_dmg_sub: 42.93,
    pen_sub: 31.31,
    anomaly_proficiency_sub: 31.4
  },
  {
    char: 'vivian',
    app_rate_sd: 45.03,
    app_rate_sd_e1: 15.76,
    app_rate_sd_s0: 5.84,
    avg_round_sd: 105,
    avg_round_sd_e1: 80,
    avg_round_sd_s0: 125,
    sample_sd: 2166,
    sample_size_players_sd: 1166,
    app_rate_da: 21.48,
    app_rate_da_e1: 6.61,
    app_rate_da_s0: 4.7,
    avg_round_da: 30412,
    avg_round_da_e1: 44403,
    avg_round_da_s0: 27541,
    app_rate_da_boss_1: 10.72,
    avg_round_da_boss_1: 31947,
    app_rate_da_boss_2: 4.83,
    avg_round_da_boss_2: 28134,
    app_rate_da_boss_3: 7.68,
    avg_round_da_boss_3: 29468,
    sample_da: 1257,
    sample_size_players_da: 716,
    app_0: 89.69,
    round_0_sd: 105,
    round_0_da: 30412,
    app_1: 4.97,
    round_1_sd: 85,
    round_1_da: 41363,
    app_2: 3.81,
    round_2_sd: 75,
    round_2_da: 49346,
    app_3: 0.25,
    round_3_sd: 92,
    round_3_da: 50864,
    app_4: 0.05,
    round_4_sd: 90,
    round_4_da: 0,
    app_5: 1,
    round_5_sd: 600,
    round_5_da: 0,
    app_6: 1.26,
    round_6_sd: 55,
    round_6_da: 60011,
    cons_avg: 0.21,
    weapons_1: 'Flight of Fancy',
    weapons_1_app: 50.71,
    weapons_1_round_sd: 102,
    weapons_1_round_da: 31516,
    weapons_2: 'Weeping Gemini',
    weapons_2_app: 41.87,
    weapons_2_round_sd: 105,
    weapons_2_round_da: 30087,
    weapons_3: 'Electro-Lip Gloss',
    weapons_3_app: 3.74,
    weapons_3_round_sd: 118,
    weapons_3_round_da: 30043,
    weapons_4: 'Rainforest Gourmet',
    weapons_4_app: 1.86,
    weapons_4_round_sd: 132,
    weapons_4_round_da: 20429,
    weapons_5: 'Fusion Compiler',
    weapons_5_app: 0.69,
    weapons_5_round_sd: 125,
    weapons_5_round_da: 26584,
    weapons_6: 'Roaring Ride',
    weapons_6_app: 0.22,
    weapons_6_round_sd: 108,
    weapons_6_round_da: 16849,
    weapons_7: 'Flamemaker Shaker',
    weapons_7_app: 0.17,
    weapons_7_round_sd: 106,
    weapons_7_round_da: 29773,
    weapons_8: 'Sharpened Stinger',
    weapons_8_app: 0.06,
    weapons_8_round_sd: 102,
    weapons_8_round_da: 0,
    weapons_9: 'Timeweaver',
    weapons_9_app: 0.03,
    weapons_9_round_sd: 190,
    weapons_9_round_da: 0,
    weapons_10: '[Magnetic Storm] Alpha',
    weapons_10_app: 0.03,
    weapons_10_round_sd: 600,
    weapons_10_round_da: 8527,
    artifacts_1: "Phaethon's Melody, Freedom Blues",
    artifacts_1_1: "Phaethon's Melody",
    artifacts_1_2: 'Freedom Blues',
    artifacts_1_3: '',
    artifacts_1_app: 55.69,
    artifacts_1_round_sd: 109,
    artifacts_1_round_da: 29056,
    artifacts_2: "Phaethon's Melody, Chaos Jazz",
    artifacts_2_1: "Phaethon's Melody",
    artifacts_2_2: 'Chaos Jazz',
    artifacts_2_3: '',
    artifacts_2_app: 37.44,
    artifacts_2_round_sd: 100,
    artifacts_2_round_da: 32595,
    artifacts_3: "Phaethon's Melody, Swing Jazz",
    artifacts_3_1: "Phaethon's Melody",
    artifacts_3_2: 'Swing Jazz',
    artifacts_3_3: '',
    artifacts_3_app: 1.86,
    artifacts_3_round_sd: 105,
    artifacts_3_round_da: 29065,
    artifacts_4: "Phaethon's Melody, Chaotic Metal",
    artifacts_4_1: "Phaethon's Melody",
    artifacts_4_2: 'Chaotic Metal',
    artifacts_4_3: '',
    artifacts_4_app: 1.37,
    artifacts_4_round_sd: 96,
    artifacts_4_round_da: 28223,
    artifacts_5: "Phaethon's Melody, Astral Voice",
    artifacts_5_1: "Phaethon's Melody",
    artifacts_5_2: 'Astral Voice',
    artifacts_5_3: '',
    artifacts_5_app: 0.91,
    artifacts_5_round_sd: 97,
    artifacts_5_round_da: 34881,
    artifacts_6: "Phaethon's Melody, Flex",
    artifacts_6_1: "Phaethon's Melody",
    artifacts_6_2: 'Flex',
    artifacts_6_3: '',
    artifacts_6_app: 0.65,
    artifacts_6_round_sd: 108,
    artifacts_6_round_da: 34149,
    artifacts_7: "Phaethon's Melody, Puffer Electro",
    artifacts_7_1: "Phaethon's Melody",
    artifacts_7_2: 'Puffer Electro',
    artifacts_7_3: '',
    artifacts_7_app: 0.49,
    artifacts_7_round_sd: 88,
    artifacts_7_round_da: 37656,
    artifacts_8: "Phaethon's Melody, Flex",
    artifacts_8_1: "Phaethon's Melody",
    artifacts_8_2: 'Flex',
    artifacts_8_3: '',
    artifacts_8_app: 0.33,
    artifacts_8_round_sd: 158,
    artifacts_8_round_da: 9711,
    artifacts_9: "Phaethon's Melody, Hormone Punk",
    artifacts_9_1: "Phaethon's Melody",
    artifacts_9_2: 'Hormone Punk',
    artifacts_9_3: '',
    artifacts_9_app: 0.27,
    artifacts_9_round_sd: 77,
    artifacts_9_round_da: 36251,
    artifacts_10: '',
    artifacts_10_1: '',
    artifacts_10_2: '',
    artifacts_10_3: '',
    artifacts_10_app: 0,
    artifacts_10_round_sd: 600,
    artifacts_10_round_da: 0,
    drive_slot_4_1: 'Anomaly Proficiency',
    drive_slot_4_1_app: 99.28,
    drive_slot_4_2: 'Percent ATK',
    drive_slot_4_2_app: 0.27,
    drive_slot_4_3: '',
    drive_slot_4_3_app: 0.21,
    drive_slot_5_1: 'Ether DMG Bonus',
    drive_slot_5_1_app: 81.76,
    drive_slot_5_2: 'Percent ATK',
    drive_slot_5_2_app: 11.36,
    drive_slot_5_3: 'PEN Ratio',
    drive_slot_5_3_app: 6,
    drive_slot_6_1: 'Anomaly Mastery',
    drive_slot_6_1_app: 94.5,
    drive_slot_6_2: 'Energy Regen',
    drive_slot_6_2_app: 2.99,
    drive_slot_6_3: 'Percent ATK',
    drive_slot_6_3_app: 2.29,
    char_level: 59.86,
    w_engine_level: 58.98,
    basic_atk: 11.01,
    special_atk: 10.3,
    dash: 6.74,
    ultimate: 10.16,
    core_skill: 6.8,
    assist: 8.73,
    base_hp: 11055.4,
    base_atk: 2479.12,
    base_def: 936.43,
    base_impact: 86.01,
    crit_rate: 14.72,
    crit_dmg: 69.05,
    anomaly_mastery: 194.78,
    anomaly_proficiency: 402.83,
    pen_ratio: 1.57,
    pen: 35.95,
    base_energy_regen: 122.54,
    dmg_bonus: 24.55,
    percent_hp_sub: 11.14,
    percent_atk_sub: 23.68,
    percent_def_sub: 16.99,
    crit_rate_sub: 9.69,
    crit_dmg_sub: 19.01,
    pen_sub: 35.95,
    anomaly_proficiency_sub: 110.15
  }
];
